var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoinsAmico(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-17",
    cx: 251,
    cy: 381.96,
    rx: 227.47,
    ry: 109.28,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-17",
    cx: 201.25,
    cy: 351.29,
    rx: 98.62,
    ry: 56.94,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-17",
    cx: 148.91,
    cy: 409.99,
    rx: 88.49,
    ry: 51.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-17",
    cx: 359.9,
    cy: 379.34,
    rx: 98.62,
    ry: 56.94,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sparkles--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shine--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.31,118.76c.05,4.71-.12,9.25-6.92,10.31,7.19-.1,6.64,4.43,7,10.11.2-5.68.7-9.75,6.3-10C422.88,128.2,423,125.51,422.31,118.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.13,113.83c0,3.57-.09,7-5.25,7.8,5.45-.07,5,3.36,5.3,7.66.15-4.3.52-7.38,4.77-7.58C46.56,121,46.68,118.94,46.13,113.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.59,26.63c.06,5.54-.14,10.87-8.14,12.12,8.45-.11,7.81,5.22,8.23,11.89.22-6.67.81-11.46,7.4-11.78C147.26,37.73,147.44,34.57,146.59,26.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.1,229.63c0,2.77-.07,5.44-4.08,6.06,4.23-.06,3.91,2.61,4.12,5.95.11-3.34.41-5.73,3.7-5.89C317.43,235.18,317.52,233.6,317.1,229.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.29,154.59c.08,7.19-.18,14.12-10.57,15.73,11-.14,10.15,6.78,10.68,15.45.3-8.67,1.06-14.89,9.62-15.3C399.16,169,399.4,164.9,398.29,154.59Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.09,104.53c.07,6-.15,11.85-8.88,13.21,9.22-.12,8.53,5.69,9,13,.24-7.28.88-12.5,8.07-12.85C299.83,116.63,300,113.19,299.09,104.53Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.34,31.25c0,2.67-.06,5.23-3.91,5.82,4.06,0,3.76,2.51,3.95,5.71.11-3.2.39-5.5,3.56-5.65C377.67,36.59,377.75,35.07,377.34,31.25Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.48,249.31c0,2.73-.06,5.35-4,6,4.16-.05,3.84,2.57,4,5.86.11-3.29.4-5.65,3.64-5.8C75.82,254.77,75.9,253.22,75.48,249.31Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.82,130.78c.07,7.26-.19,14.25-10.68,15.88,11.09-.14,10.25,6.84,10.79,15.6.3-8.76,2.25-15.33,10.89-15.74C73.88,145,72.94,141.19,71.82,130.78Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.55,148.46c0,3.68-.74,7.38-6.06,8.2,5.62-.07,5.84,3.32,6.11,7.76.15-4.44,1.37-7.86,5.75-8.07C440.82,155.6,440.11,153.74,439.55,148.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.79,267.21c0,3.94-.79,7.89-6.47,8.77,6-.08,6.24,3.55,6.54,8.29.16-4.74,1.45-8.4,6.14-8.62C457.15,274.85,456.4,272.85,455.79,267.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.78,283.84c0,3.94-.79,7.89-6.48,8.77,6-.08,6.24,3.55,6.54,8.29.16-4.74,1.46-8.4,6.14-8.62C32.14,291.48,31.38,289.48,30.78,283.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.87,38.64c.05,5.12-.13,10-7.53,11.2,7.82-.11,7.23,4.82,7.61,11,.21-6.17.75-10.6,6.84-10.89C395.49,48.9,395.66,46,394.87,38.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.72,113.05c0-5.12-.13-9.69-7.53-10.84,7.82.11,7.22-5.18,7.61-11.35C83,97,84,102.32,90,102.61,83.74,103.65,83.51,105.71,82.72,113.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.32,332.72a10,10,0,0,0-6.18-8.66c-4.73-2.13-10.29-2-10.71-1.52s1.59,5.61,6.78,8.76A11.69,11.69,0,0,0,52.32,332.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,344.28a10,10,0,0,0-9.45-4.89c-5.18.27-10.06,2.93-10.22,3.53s4,4.27,10,4.71A11.68,11.68,0,0,0,58,344.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.88,343.49a10,10,0,0,0,3.18-10.15c-1.16-5.06-4.09-9.22-4.71-9.27s-3.93,5.11-3.75,10.57C62.79,340.59,66.74,342.51,67.88,343.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.13,384.12c-.13-4.67-1.76-9.25-3.47-13.55a79.14,79.14,0,0,0-5.8-11.66A102.05,102.05,0,0,0,58.92,337.8c-4.16-4-8.75-8-14-10.43-.11-.05-.3.19-.2.27a81.07,81.07,0,0,1,12,10.34,95.26,95.26,0,0,1,9.48,10.54,98.27,98.27,0,0,1,12.19,20.75c2.15,4.89,3.45,10,5,15.11A.87.87,0,0,0,85.13,384.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,347.7a31.83,31.83,0,0,0,.61-7,17.73,17.73,0,0,0-1.16-6.62c-.12-.29-.25.17-.23.37a52.43,52.43,0,0,1,.24,6,22.92,22.92,0,0,1-1.07,6.3,1.43,1.43,0,0,0,.53,1.54A.75.75,0,0,0,68,347.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.31,347.15c-2.71-1.89-5.36-2.7-9.1-3.66a28.87,28.87,0,0,0-4.43-.75,17.78,17.78,0,0,0-5.32.24c-.06,0-.42.27-.29.28a45.61,45.61,0,0,1,5.2.44,27,27,0,0,1,4.63,1,42.28,42.28,0,0,1,8.75,3.62C67.33,348.65,67.78,347.48,67.31,347.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.73,359.52a10,10,0,0,0-8.23-6.75c-5.12-.82-10.45.77-10.73,1.32s3,5,8.83,6.7A11.65,11.65,0,0,0,69.73,359.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.22,364.27c-2.26-2.41-4.68-3.76-8.13-5.47a28.41,28.41,0,0,0-4.18-1.66,17.86,17.86,0,0,0-5.25-.88c-.07,0-.47.18-.34.21a47.59,47.59,0,0,1,5,1.52,27.94,27.94,0,0,1,4.33,2,42.44,42.44,0,0,1,7.79,5.37C77.93,365.75,78.61,364.69,78.22,364.27Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.93,304.65a11,11,0,0,1,1.85-11.53c3.62-4.39,9.16-7,9.79-6.71s1.17,6.29-2.39,11.93A12.8,12.8,0,0,1,86.93,304.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,318.79a10.92,10.92,0,0,1,6.91-9.41c5.22-2.26,11.32-2,11.77-1.51s-1.83,6.14-7.58,9.52A12.77,12.77,0,0,1,87,318.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.88,322.83a10.93,10.93,0,0,1-8.07-8.44c-1.33-5.54-.47-11.05.11-11.41s6.35,3.12,8.84,8.57C80.47,317.49,77.52,321.31,76.88,322.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.72,371.19c-2.15-4.66-2.78-10-3.2-15a86.31,86.31,0,0,1,0-14.29,111.93,111.93,0,0,1,6.36-29c2.17-5.91,4.71-12.13,8.69-17.07.08-.11.39,0,.32.16a89.06,89.06,0,0,0-6.74,16A104.58,104.58,0,0,0,81,327a107.6,107.6,0,0,0-1.87,26.34c.27,5.86,1.48,11.54,2.42,17.31A1,1,0,0,1,79.72,371.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.82,327a34.8,34.8,0,0,1-4-6.6,19.68,19.68,0,0,1-2.09-7.08c0-.34.33.05.4.26a57,57,0,0,0,2.71,6,25.1,25.1,0,0,0,4.11,5.67,1.55,1.55,0,0,1,.24,1.76A.81.81,0,0,1,78.82,327Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.22,326.15c1.75-3.18,4-5.27,7.17-8a31.75,31.75,0,0,1,4-2.9,19.22,19.22,0,0,1,5.34-2.36c.08,0,.55.06.42.13a51.52,51.52,0,0,0-4.89,3,29.75,29.75,0,0,0-4.06,3.26A47.39,47.39,0,0,0,80.35,327C79.94,327.64,78.92,326.7,79.22,326.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.88,339.49a10.93,10.93,0,0,1,4.79-10.64c4.64-3.31,10.65-4.34,11.2-3.93s-.51,6.38-5.42,10.89A12.81,12.81,0,0,1,82.88,339.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.84,348.3c1-3.47,2.76-6,5.33-9.34a31,31,0,0,1,3.3-3.67,19,19,0,0,1,4.73-3.42c.08,0,.56-.06.44,0a51.93,51.93,0,0,0-4.16,3.92,29.66,29.66,0,0,0-3.3,4,46.86,46.86,0,0,0-5.05,9.07C77.85,349.61,76.66,348.9,76.84,348.3Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins-2--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.85,228.63l2.65,1.19-2.46,5.4h0a8.15,8.15,0,0,1-1.14,1.8c-.16.19-.33.37-.51.55a10.61,10.61,0,0,1-3.19,2.11,12.61,12.61,0,0,1-1.35.51,13.31,13.31,0,0,1-1.51.41,20.91,20.91,0,0,1-2.08.36c-.76.09-1.54.15-2.34.17-.6,0-1.21,0-1.83,0-9.08-.33-19.78-4.75-27-11.14-.49-.43-1-.88-1.42-1.33-.66-.64-1.28-1.31-1.86-2s-.91-1.11-1.31-1.66-.66-1-1-1.43-.54-.93-.77-1.39h0a13.83,13.83,0,0,1-1.35-4c0-.28-.08-.55-.1-.81a8.5,8.5,0,0,1,.33-3.29,6.12,6.12,0,0,1,.35-.93h0l2.33-5.1,2.41,1.09c.29-.13.59-.24.9-.35a18.61,18.61,0,0,1,3.91-.88,24.14,24.14,0,0,1,2.59-.17,31.64,31.64,0,0,1,3.48.14,47.06,47.06,0,0,1,23.56,9.71,34.89,34.89,0,0,1,2.79,2.45c.73.7,1.41,1.43,2.05,2.17a24.26,24.26,0,0,1,2.45,3.41A16.5,16.5,0,0,1,465.85,228.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.71,233.51l5-11,3.82,2.25-5,11Q431.55,234.72,429.71,233.51Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466,235.22h0a8.15,8.15,0,0,1-1.14,1.8c-.16.19-.33.37-.51.55a10.61,10.61,0,0,1-3.19,2.11l-.48.2,5.12-11.28v0l2.65,1.19Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,224.08l2.29.45L449.74,241c-.75-.08-1.52-.19-2.28-.32Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.65,239.2,448.13,225l3.88,2.12-6,13.26A43.22,43.22,0,0,1,441.65,239.2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.32,208.08l2.41,1.09c.29-.13.59-.24.9-.35a18.61,18.61,0,0,1,3.91-.88,24.14,24.14,0,0,1,2.59-.17,31.64,31.64,0,0,1,3.48.14c1.12.11,2.26.28,3.4.49l-10.4,22.87c-.53-.42-1-.85-1.54-1.29s-1-.88-1.42-1.33c-.66-.64-1.28-1.31-1.86-2s-.91-1.11-1.31-1.66-.66-1-1-1.43-.54-.93-.77-1.39h0a13.83,13.83,0,0,1-1.35-4c0-.28-.08-.55-.1-.81a8.5,8.5,0,0,1,.33-3.29,6.12,6.12,0,0,1,.35-.93h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.41,218.21c0-.28-.08-.55-.1-.81a8.5,8.5,0,0,1,.33-3.29,6.12,6.12,0,0,1,.35-.93h0l2.33-5.1,2.41,1.09,0,0,.68.67-5.17,11.35A13.34,13.34,0,0,1,417.41,218.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.64,216.47c-.64-.75-1.32-1.47-2.05-2.18a36.9,36.9,0,0,0-2.79-2.44,47.07,47.07,0,0,0-23.56-9.72,31.64,31.64,0,0,0-3.48-.14c-.89,0-1.75.08-2.59.18a18.62,18.62,0,0,0-3.91.87,11.83,11.83,0,0,0-3.41,1.81,7.9,7.9,0,0,0-2.8,4,8.46,8.46,0,0,0-.33,3.28c0,.27.06.54.1.81a13.78,13.78,0,0,0,1.35,4h0c.23.46.49.92.78,1.39s.6.95.94,1.42.84,1.11,1.31,1.67,1.2,1.34,1.86,2c.46.45.93.9,1.43,1.33,7.23,6.39,17.93,10.81,27,11.14.62,0,1.23,0,1.83,0,.8,0,1.58-.08,2.34-.17a20.41,20.41,0,0,0,2.08-.36c.53-.12,1-.25,1.51-.41a12.62,12.62,0,0,0,1.35-.52,10.59,10.59,0,0,0,3.19-2.1c.18-.18.35-.37.51-.56a7.52,7.52,0,0,0,1.51-2.79,9.36,9.36,0,0,0-.05-5.14,16,16,0,0,0-1.68-3.91A25.67,25.67,0,0,0,464.64,216.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,226c-.53-.43-1-.86-1.54-1.3s-1-.88-1.43-1.33c-.66-.65-1.28-1.31-1.86-2s-.91-1.11-1.31-1.67-.66-.95-.94-1.42-.55-.93-.78-1.39h0a13.78,13.78,0,0,1-1.35-4c0-.27-.08-.54-.1-.81a8.46,8.46,0,0,1,.33-3.28,7.9,7.9,0,0,1,2.8-4,11.83,11.83,0,0,1,3.41-1.81,18.62,18.62,0,0,1,3.91-.87c.75-.09,1.51-.14,2.29-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.68,215.83a13.39,13.39,0,0,1-.86-2.93c0-.27-.08-.54-.1-.81a8.46,8.46,0,0,1,.33-3.28,7.7,7.7,0,0,1,2.12-3.37Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.93,230.47c-1.31-.7-2.59-1.46-3.81-2.26l3.74-26.11.38,0c1.2.12,2.43.31,3.67.55Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.38,235c-1.43-.3-2.88-.69-4.32-1.14l4.12-28.74c1.43.58,2.83,1.23,4.21,1.93Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.16,235.64c-.76-.08-1.53-.19-2.3-.32l3.93-27.47c.74.41,1.46.83,2.17,1.28Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.55,217.61h0c.24.32.46.63.68.94l.21.31.21.31.44.7a16,16,0,0,1,1.68,3.91,9.36,9.36,0,0,1,.05,5.14,7.52,7.52,0,0,1-1.51,2.79c-.16.19-.33.38-.51.56a10.59,10.59,0,0,1-3.19,2.1l-.49.21Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.44,217c-5.66-6.61-16.48-11.24-24.67-10.69-.35,0-.7.05-1,.09-8.29,1-10.23,7.46-4.33,14.35s17.41,11.63,25.7,10.59q.51-.06,1-.15C463.54,229.82,465.1,223.64,459.44,217Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.77,217.12q-.27-.31-.57-.63c-5.53-6-15.44-10.09-23-9.58H435l-.78.08a11.58,11.58,0,0,0-4,1.16,5.86,5.86,0,0,0-3.33,6.35,11.79,11.79,0,0,0,2.37,5.17c.25.34.52.68.82,1s.55.63.84.94a25.31,25.31,0,0,0,2,1.85,33.25,33.25,0,0,0,18,7.42,19.78,19.78,0,0,0,2.55,0c.39,0,.78-.05,1.16-.1s.63-.09.94-.15l.25-.05a8.73,8.73,0,0,0,4.61-2.29c1.78-1.82,2.11-4.45.83-7.38A15.59,15.59,0,0,0,458.77,217.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.77,217.12q-.27-.31-.57-.63c-5.53-6-15.44-10.09-23-9.58H435l-.78.08a11.58,11.58,0,0,0-4,1.16,5.86,5.86,0,0,0-3.33,6.35,11.79,11.79,0,0,0,2.37,5.17c.25.34.52.68.82,1s.55.63.84.94a25.31,25.31,0,0,0,2,1.85,33.25,33.25,0,0,0,18,7.42,19.78,19.78,0,0,0,2.55,0c.39,0,.78-.05,1.16-.1s.63-.09.94-.15l.25-.05a8.73,8.73,0,0,0,4.61-2.29c1.78-1.82,2.11-4.45.83-7.38A15.59,15.59,0,0,0,458.77,217.12Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.29,218.5c.2.21.39.42.57.64a15.55,15.55,0,0,1,2.49,3.83,7.65,7.65,0,0,1,.62,4.73,5.38,5.38,0,0,1-.54.64,8.73,8.73,0,0,1-4.61,2.29l-.25.05c-.31.06-.62.11-.94.15s-.77.08-1.16.1a19.78,19.78,0,0,1-2.55,0,33.25,33.25,0,0,1-18-7.42,25.31,25.31,0,0,1-2-1.85c-.29-.31-.57-.62-.84-.94s-.57-.68-.82-1a11.79,11.79,0,0,1-2.37-5.17,6.4,6.4,0,0,1,.07-2.36,6.54,6.54,0,0,1,2.36-2,11.73,11.73,0,0,1,4-1.17l.78-.07.21,0C441.86,208.42,451.76,212.53,457.29,218.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.8,232.27c-5.48,4.81-14.2,3.75-20.9,2-10-2.94-19.81-8.76-24.65-17.46v0a11,11,0,0,1-1.21-8,10.9,10.9,0,0,0,1,8.12h0c3.8,7.23,11.25,12.41,19.14,15.75C448.28,235.79,459.69,238.44,466.8,232.27Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.49,218.86c2.16,2.34,5,3,7.82,3.29l-.94.37-1.26,2.77a14.53,14.53,0,0,0,1.53,1,13.25,13.25,0,0,0,2.91,1.2,16.91,16.91,0,0,0,5.14.56l1.9,2.06,4.06-.51,1.26-2.76-.48-.53-.1-.11a2.88,2.88,0,0,0,.36-.62,2.09,2.09,0,0,0,.08-.23c.11-.36.9-1.89,1.18-2.54a2.09,2.09,0,0,0,.08-.23c.26-.81-.07-1.8-1.13-2.94h0a9.25,9.25,0,0,0-3.94-2.47l-.38-.12h0l-.4-.11a3.58,3.58,0,0,0-.35-.09l-.15,0-.27-.06a20.71,20.71,0,0,0-2.29-.33l-1-.07,1.24-.49,1.26-2.77a14.76,14.76,0,0,0-9-2.53l-1.9-2-4,.58-1.26,2.77.59.64a1.84,1.84,0,0,0-.31.49v0c-.17.44-1,2.25-1.25,2.75v0C431,216.62,431.37,217.65,432.49,218.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.89,223c-.32.71-1,2.08-1.12,2.41l-.08.23a3.14,3.14,0,0,1-.36.62L453,224.74A3.55,3.55,0,0,0,455.89,223Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.87,215.15c-.57-.62-.44-1.22,1.24-1.47a5.73,5.73,0,0,1,4.4,1l4.05-1.61-1.27,2.76-1.22.49H446l-1.55-.07-.59,0a18.33,18.33,0,0,1-3.23-.25,3.49,3.49,0,0,1-1.24-.46A2.43,2.43,0,0,1,438.87,215.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.93,212.5l-.59-.64,1.26-2.76,1.89,2.05A5,5,0,0,0,432.93,212.5Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.85,227.36l4.06-.51-1.25,2.77-4.07.51-1.89-2.06a16.66,16.66,0,0,1-5.15-.57,12.74,12.74,0,0,1-2.91-1.19,13.12,13.12,0,0,1-1.53-1l1.26-2.77a13.92,13.92,0,0,0,1.52,1,13,13,0,0,0,2.92,1.19,16.33,16.33,0,0,0,5.14.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.7,228.07a12.79,12.79,0,0,1-4.23-.16,10.43,10.43,0,0,1-3.83-1.6,19.91,19.91,0,0,0,3.92,1.26,19.7,19.7,0,0,0,2,.33C446.29,228,447,228,447.7,228.07Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.36,215.79v0c.21-.5,1.08-2.31,1.25-2.75-.32.84,0,1.86,1.14,3.07,2.51,2.71,5.9,3.23,9.16,3.38,3,.13,5.39-.12,6.61,1.19.76.82.2,1.32-1.12,1.5a6.18,6.18,0,0,1-4.74-1.32l-3.35,1.31h0c-2.83-.25-5.66-1-7.81-3.29C431.36,217.65,431,216.63,431.36,215.79Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.25 217.49 444.51 214.72 448.56 213.1 447.3 215.87 443.25 217.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.25 217.49 444.51 214.72 448.56 213.1 447.3 215.87 443.25 217.49",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.6 209.1 435.5 211.15 432.93 212.51 432.34 211.87 433.6 209.1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.6 209.1 435.5 211.15 432.93 212.51 432.34 211.87 433.6 209.1",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.43,226.33,453,224.74a3.49,3.49,0,0,0,3-1.91,2.09,2.09,0,0,0,.08-.23c.26-.81-.07-1.8-1.13-2.94h0a9.25,9.25,0,0,0-3.94-2.47l-.38-.12h0l-.4-.11a3.58,3.58,0,0,0-.35-.09l-.15,0-.27-.06a20.71,20.71,0,0,0-2.29-.33c-.37,0-.74-.06-1.11-.07l-1.55-.07-.59,0a19.55,19.55,0,0,1-3.23-.24,3.69,3.69,0,0,1-1.24-.47,2.43,2.43,0,0,1-.49-.41c-.57-.62-.44-1.22,1.24-1.46a5.64,5.64,0,0,1,4.4,1l4.05-1.62a14.76,14.76,0,0,0-9-2.53l-1.9-2-4,.58,1.9,2.05c-1.54.41-2.54,1-2.88,1.85v0c-.32.84,0,1.86,1.14,3.08,2.5,2.7,5.9,3.22,9.16,3.37,3,.13,5.39-.12,6.61,1.19.75.82.2,1.32-1.12,1.5a6.22,6.22,0,0,1-4.74-1.31l-4.29,1.67a12.33,12.33,0,0,0,1.53,1,13.25,13.25,0,0,0,2.91,1.2,16.61,16.61,0,0,0,5.14.56l1.9,2.06,4.06-.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.43,226.33,453,224.74a3.49,3.49,0,0,0,3-1.91,2.09,2.09,0,0,0,.08-.23c.26-.81-.07-1.8-1.13-2.94h0a9.25,9.25,0,0,0-3.94-2.47l-.38-.12h0l-.4-.11a3.58,3.58,0,0,0-.35-.09l-.15,0-.27-.06a20.71,20.71,0,0,0-2.29-.33c-.37,0-.74-.06-1.11-.07l-1.55-.07-.59,0a19.55,19.55,0,0,1-3.23-.24,3.69,3.69,0,0,1-1.24-.47,2.43,2.43,0,0,1-.49-.41c-.57-.62-.44-1.22,1.24-1.46a5.64,5.64,0,0,1,4.4,1l4.05-1.62a14.76,14.76,0,0,0-9-2.53l-1.9-2-4,.58,1.9,2.05c-1.54.41-2.54,1-2.88,1.85v0c-.32.84,0,1.86,1.14,3.08,2.5,2.7,5.9,3.22,9.16,3.37,3,.13,5.39-.12,6.61,1.19.75.82.2,1.32-1.12,1.5a6.22,6.22,0,0,1-4.74-1.31l-4.29,1.67a12.33,12.33,0,0,0,1.53,1,13.25,13.25,0,0,0,2.91,1.2,16.61,16.61,0,0,0,5.14.56l1.9,2.06,4.06-.5Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.75,216.1a9.77,9.77,0,0,0,3.42,2.24,14.69,14.69,0,0,0,4.11.92c1.42.15,2.84.15,4.27.21a13.86,13.86,0,0,1,2.14.22,3.43,3.43,0,0,1,1.83,1,3.45,3.45,0,0,0-1.85-.88,15,15,0,0,0-2.12-.17c-1.43,0-2.86,0-4.29-.16a14.75,14.75,0,0,1-4.16-1,9.83,9.83,0,0,1-1.83-1A11.07,11.07,0,0,1,433.75,216.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.85 227.36 449.59 230.13 447.69 228.07 448.95 225.3 450.85 227.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.85 227.36 449.59 230.13 447.69 228.07 448.95 225.3 450.85 227.36",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.91 226.85 451 227.06 448.95 225.3 450.85 227.36 454.91 226.85",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.54 210.57 437.53 208.82 433.6 209.1 437.64 208.53 439.54 210.57",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.56,213.1a13.3,13.3,0,0,0-1.4-.84l-.21,1.48Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.84,216.18a9.47,9.47,0,0,0,3.79,2.42l1.25-8.74-1.24-1.34-2.76.39-.19,1.36.81.88a7.51,7.51,0,0,0-1,.32Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.51,219.25a9.22,9.22,0,0,0-2.14-1.48L451,227.34l2.39-.3.23-1.59-.65-.71a3.77,3.77,0,0,0,.77-.13Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.54,217.05l-.4-.11a3.58,3.58,0,0,0-.35-.09l-.15,0-.27-.06a20.71,20.71,0,0,0-2.29-.33l-.51,0-.45,3.16c1.48.08,2.66.3,3.4,1.1s.2,1.32-1.12,1.5a6.09,6.09,0,0,1-2.63-.21l-.44,3.12a17.4,17.4,0,0,0,3.62.23l.72.78,1.27-8.91-.36-.11Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.28,65.4l2.7,1.06L327.78,72h0a8,8,0,0,1-1,1.84,6.82,6.82,0,0,1-.49.58,10.27,10.27,0,0,1-3.08,2.25,12.4,12.4,0,0,1-1.33.58,15.1,15.1,0,0,1-1.48.48,20.13,20.13,0,0,1-2.06.46c-.76.12-1.54.22-2.33.28-.6,0-1.21.07-1.83.07-9.07.1-20-3.8-27.48-9.84-.52-.41-1-.83-1.49-1.27a27,27,0,0,1-2-1.9c-.49-.53-1-1.06-1.38-1.59s-.7-.92-1-1.38-.59-.91-.85-1.36h0a14.06,14.06,0,0,1-1.53-3.9c-.05-.27-.1-.54-.14-.8a8.56,8.56,0,0,1,.18-3.29,7.53,7.53,0,0,1,.31-1h0l2.08-5.2,2.46,1c.29-.14.58-.27.88-.39a19.14,19.14,0,0,1,3.86-1.06,23.94,23.94,0,0,1,2.58-.29,28.79,28.79,0,0,1,3.48,0,47,47,0,0,1,24,8.58c1,.74,2,1.51,2.9,2.31.76.67,1.48,1.37,2.15,2.08a24.51,24.51,0,0,1,2.6,3.28A17.05,17.05,0,0,1,327.28,65.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.44,72,295.9,60.8l3.92,2.06-4.46,11.19Q293.33,73.09,291.44,72Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.78,72h0a8,8,0,0,1-1,1.84,6.82,6.82,0,0,1-.49.58,10.27,10.27,0,0,1-3.08,2.25l-.48.23,4.59-11.5v0l2.7,1.06Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.19,61.37l2.3.35-6.71,16.73c-.76,0-1.52-.12-2.3-.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.63,77.08l5.79-14.51,4,1.94L308,78A43.6,43.6,0,0,1,303.63,77.08Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.87,47l2.46,1c.29-.14.58-.27.88-.39a19.14,19.14,0,0,1,3.86-1.06,23.94,23.94,0,0,1,2.58-.29,28.79,28.79,0,0,1,3.48,0,33.78,33.78,0,0,1,3.42.33l-9.31,23.31c-.55-.4-1.08-.8-1.59-1.21s-1-.83-1.49-1.27a27,27,0,0,1-2-1.9c-.49-.53-1-1.06-1.38-1.59s-.7-.92-1-1.38-.59-.91-.85-1.36h0a14.06,14.06,0,0,1-1.53-3.9c-.05-.27-.1-.54-.14-.8a8.56,8.56,0,0,1,.18-3.29,7.53,7.53,0,0,1,.31-1h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.44,57.27c-.05-.27-.1-.54-.14-.8a8.56,8.56,0,0,1,.18-3.29,7.53,7.53,0,0,1,.31-1h0l2.08-5.2,2.46,1,.05,0,.7.63-4.62,11.58A13.23,13.23,0,0,1,278.44,57.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.5,53.32c-.67-.71-1.39-1.41-2.14-2.08-.91-.8-1.88-1.57-2.9-2.3a47,47,0,0,0-24-8.59,31,31,0,0,0-3.48,0q-1.32.09-2.58.3a19.15,19.15,0,0,0-3.86,1,11.57,11.57,0,0,0-3.31,2,8,8,0,0,0-2.62,4.08,8.78,8.78,0,0,0-.17,3.29c0,.27.09.54.14.81a14.18,14.18,0,0,0,1.53,3.9h0c.26.45.54.9.84,1.36s.65.91,1,1.37.88,1.07,1.38,1.6,1.26,1.29,1.95,1.9c.48.43,1,.85,1.48,1.26,7.52,6,18.41,9.95,27.49,9.85.62,0,1.23,0,1.83-.08.79-.06,1.57-.15,2.33-.28a20.15,20.15,0,0,0,2.06-.45,15.1,15.1,0,0,0,1.48-.48c.47-.18.91-.37,1.33-.58A10.45,10.45,0,0,0,328.4,69c.17-.19.33-.38.49-.58a7.72,7.72,0,0,0,1.37-2.86,9.3,9.3,0,0,0-.29-5.13,16.37,16.37,0,0,0-1.87-3.82A23.73,23.73,0,0,0,325.5,53.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.41,64.48c-.55-.4-1.09-.8-1.61-1.22s-1-.83-1.48-1.26c-.69-.61-1.34-1.25-1.95-1.9s-1-1.07-1.38-1.6-.71-.92-1-1.37-.58-.91-.84-1.36h0a14.18,14.18,0,0,1-1.53-3.9c-.05-.27-.1-.54-.14-.81a8.78,8.78,0,0,1,.17-3.29,8,8,0,0,1,2.62-4.08,11.57,11.57,0,0,1,3.31-2,19.15,19.15,0,0,1,3.86-1,21.38,21.38,0,0,1,2.29-.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.6,54.75a13.19,13.19,0,0,1-1-2.88c-.05-.27-.1-.54-.14-.81a8.78,8.78,0,0,1,.17-3.29,7.88,7.88,0,0,1,2-3.46Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.5,68.64c-1.34-.64-2.65-1.33-3.9-2.08l2.5-26.23.38,0c1.21.06,2.44.19,3.69.37Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.15,72.62a43.19,43.19,0,0,1-4.37-.94l2.76-28.87c1.45.51,2.89,1.09,4.29,1.73Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,73.05c-.77,0-1.54-.12-2.32-.22l2.64-27.6c.75.37,1.5.76,2.22,1.17Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.47,54.42h0q.38.45.72.9l.22.3.23.31c.16.22.32.45.46.67A16.37,16.37,0,0,1,330,60.42a9.3,9.3,0,0,1,.29,5.13,7.72,7.72,0,0,1-1.37,2.86c-.16.2-.32.39-.49.58a10.45,10.45,0,0,1-3.08,2.25l-.48.22Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.34,54.13c-6-6.33-17-10.44-25.13-9.51-.34,0-.69.09-1,.15-8.23,1.42-9.86,7.92-3.65,14.52s17.92,10.79,26.15,9.36a10,10,0,0,0,1-.2C325,66.7,326.3,60.46,320.34,54.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.67,54.25c-.19-.21-.39-.41-.59-.61-5.81-5.7-15.88-9.34-23.41-8.48l-.21,0c-.26,0-.52.07-.77.12a11.69,11.69,0,0,0-3.94,1.35,5.84,5.84,0,0,0-3,6.49,11.8,11.8,0,0,0,2.61,5c.26.33.55.66.86,1s.58.6.89.89a25.71,25.71,0,0,0,2.08,1.76,33.21,33.21,0,0,0,18.33,6.56,19.27,19.27,0,0,0,2.54-.1c.39,0,.78-.09,1.15-.16s.63-.12.93-.19l.25-.06a8.83,8.83,0,0,0,4.5-2.5c1.69-1.91,1.89-4.54.47-7.41A15.26,15.26,0,0,0,319.67,54.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.67,54.25c-.19-.21-.39-.41-.59-.61-5.81-5.7-15.88-9.34-23.41-8.48l-.21,0c-.26,0-.52.07-.77.12a11.69,11.69,0,0,0-3.94,1.35,5.84,5.84,0,0,0-3,6.49,11.8,11.8,0,0,0,2.61,5c.26.33.55.66.86,1s.58.6.89.89a25.71,25.71,0,0,0,2.08,1.76,33.21,33.21,0,0,0,18.33,6.56,19.27,19.27,0,0,0,2.54-.1c.39,0,.78-.09,1.15-.16s.63-.12.93-.19l.25-.06a8.83,8.83,0,0,0,4.5-2.5c1.69-1.91,1.89-4.54.47-7.41A15.26,15.26,0,0,0,319.67,54.25Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.27,55.7l.59.6A15.53,15.53,0,0,1,321.52,60a7.61,7.61,0,0,1,.85,4.69,5.39,5.39,0,0,1-.51.67,8.83,8.83,0,0,1-4.5,2.5l-.25.06c-.3.07-.61.14-.93.19s-.76.12-1.15.16a19.27,19.27,0,0,1-2.54.1,33.21,33.21,0,0,1-18.33-6.56,25.71,25.71,0,0,1-2.08-1.76c-.31-.29-.6-.59-.89-.89s-.6-.66-.86-1a11.8,11.8,0,0,1-2.61-5,6.48,6.48,0,0,1,0-2.36,6.71,6.71,0,0,1,2.26-2.08,11.63,11.63,0,0,1,3.93-1.35l.78-.11.2,0C302.38,46.35,312.46,50,318.27,55.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.4,69c-5.25,5.06-14,4.41-20.77,3-10.17-2.47-20.18-7.82-25.42-16.27v0a11,11,0,0,1-1.59-8,10.94,10.94,0,0,0,1.43,8.06v0c4.13,7,11.81,11.87,19.84,14.82C310.08,73.37,321.59,75.48,328.4,69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.53,57.22c2.26,2.23,5.12,2.8,8,2.91l-.93.41-1.12,2.83a12.77,12.77,0,0,0,1.57.94,13,13,0,0,0,3,1.06,16.9,16.9,0,0,0,5.15.33l2,2,4-.69,1.13-2.83-.5-.5-.11-.11a2.67,2.67,0,0,0,.33-.63,2,2,0,0,0,.07-.23c.1-.36.81-1.93,1.06-2.59,0-.08.05-.16.07-.23.22-.83-.16-1.8-1.27-2.89h0a9.35,9.35,0,0,0-4.05-2.28l-.38-.1h0l-.41-.09-.35-.07-.15,0-.28,0a20.31,20.31,0,0,0-2.3-.22l-1,0,1.21-.55,1.13-2.82a14.6,14.6,0,0,0-9.11-2.1l-2-2-4,.76L293,50.24l.63.62a2.1,2.1,0,0,0-.29.5v0c-.16.45-.94,2.3-1.12,2.8v0C292,55.05,292.35,56.06,293.53,57.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.07,60.21c-.28.72-.91,2.12-1,2.46a2,2,0,0,1-.07.23,3,3,0,0,1-.33.64l-1.43-1.42A3.51,3.51,0,0,0,317.07,60.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.72,53.21c-.6-.59-.5-1.19,1.17-1.52a5.66,5.66,0,0,1,4.43.83l4-1.8-1.13,2.82-1.2.55h-.1c-.53,0-1.05,0-1.54,0h-.59a19.4,19.4,0,0,1-3.24-.09,3.4,3.4,0,0,1-1.26-.41A2.16,2.16,0,0,1,299.72,53.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.66,50.85l-.62-.61,1.14-2.82,2,2A5.08,5.08,0,0,0,293.66,50.85Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.25,64.84l4-.7L315.16,67l-4,.7-2-2a16.63,16.63,0,0,1-5.16-.33,12.69,12.69,0,0,1-4.54-2l1.12-2.83a12.41,12.41,0,0,0,4.54,2,17,17,0,0,0,5.16.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.14,65.7a12.78,12.78,0,0,1-4.23,0,10.27,10.27,0,0,1-3.9-1.42,19.61,19.61,0,0,0,4,1.08c.68.11,1.37.18,2.06.23S308.43,65.69,309.14,65.7Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.25,54.2h0c.18-.51,1-2.36,1.12-2.81-.29.85.09,1.86,1.27,3,2.63,2.58,6.05,2.94,9.31,2.94,3,0,5.37-.38,6.65.87.79.78.26,1.31-1.05,1.56a6.23,6.23,0,0,1-4.79-1.1l-3.28,1.47h0c-2.84-.12-5.7-.7-8-2.92C292.35,56.06,292,55.06,292.25,54.2Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.2 55.34 305.32 52.52 309.29 50.72 308.16 53.54 304.2 55.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.2 55.34 305.32 52.52 309.29 50.72 308.16 53.54 304.2 55.34",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.17 47.42 296.17 49.38 293.67 50.86 293.04 50.24 294.17 47.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.17 47.42 296.17 49.38 293.67 50.86 293.04 50.24 294.17 47.42",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.78,63.64l-1.54-1.52a3.5,3.5,0,0,0,2.89-2c0-.08.05-.16.07-.23.22-.83-.16-1.8-1.27-2.89h0a9.35,9.35,0,0,0-4.05-2.28l-.38-.1h0l-.41-.09-.35-.07-.15,0-.28,0a20.31,20.31,0,0,0-2.3-.22c-.37,0-.74,0-1.11,0-.53,0-1.05,0-1.55,0h-.59a19.49,19.49,0,0,1-3.24-.09,3.35,3.35,0,0,1-1.25-.41,2.46,2.46,0,0,1-.51-.39c-.6-.59-.5-1.2,1.17-1.51a5.62,5.62,0,0,1,4.43.82l4-1.8a14.6,14.6,0,0,0-9.11-2.1l-2-2-4,.76,2,2c-1.52.48-2.49,1.15-2.79,2v0c-.29.85.1,1.86,1.28,3,2.62,2.58,6,2.94,9.3,2.94,3,0,5.37-.38,6.65.87.79.79.26,1.31-1.05,1.56a6.19,6.19,0,0,1-4.79-1.1l-4.21,1.87a12.48,12.48,0,0,0,1.58,1,12.81,12.81,0,0,0,3,1.06,17,17,0,0,0,5.16.33l2,2,4-.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.78,63.64l-1.54-1.52a3.5,3.5,0,0,0,2.89-2c0-.08.05-.16.07-.23.22-.83-.16-1.8-1.27-2.89h0a9.35,9.35,0,0,0-4.05-2.28l-.38-.1h0l-.41-.09-.35-.07-.15,0-.28,0a20.31,20.31,0,0,0-2.3-.22c-.37,0-.74,0-1.11,0-.53,0-1.05,0-1.55,0h-.59a19.49,19.49,0,0,1-3.24-.09,3.35,3.35,0,0,1-1.25-.41,2.46,2.46,0,0,1-.51-.39c-.6-.59-.5-1.2,1.17-1.51a5.62,5.62,0,0,1,4.43.82l4-1.8a14.6,14.6,0,0,0-9.11-2.1l-2-2-4,.76,2,2c-1.52.48-2.49,1.15-2.79,2v0c-.29.85.1,1.86,1.28,3,2.62,2.58,6,2.94,9.3,2.94,3,0,5.37-.38,6.65.87.79.79.26,1.31-1.05,1.56a6.19,6.19,0,0,1-4.79-1.1l-4.21,1.87a12.48,12.48,0,0,0,1.58,1,12.81,12.81,0,0,0,3,1.06,17,17,0,0,0,5.16.33l2,2,4-.7Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.66,54.4a9.8,9.8,0,0,0,3.51,2.08,14.46,14.46,0,0,0,4.15.72c1.42.09,2.84,0,4.27,0a14,14,0,0,1,2.15.12,3.55,3.55,0,0,1,1.87.88,3.44,3.44,0,0,0-1.89-.78,13.7,13.7,0,0,0-2.13-.08c-1.42,0-2.85.12-4.29,0a14.5,14.5,0,0,1-4.19-.77,9.68,9.68,0,0,1-1.88-.93A9.38,9.38,0,0,1,294.66,54.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.25 64.84 311.12 67.66 309.13 65.7 310.26 62.88 312.25 64.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.25 64.84 311.12 67.66 309.13 65.7 310.26 62.88 312.25 64.84",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.28 64.14 312.39 64.53 310.26 62.88 312.25 64.84 316.28 64.14",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.18 48.62 298.08 46.96 294.17 47.42 298.18 46.66 300.18 48.62",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.29,50.72a11.68,11.68,0,0,0-1.43-.78l-.14,1.49Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.75,54.48a9.48,9.48,0,0,0,3.89,2.23l.84-8.78-1.3-1.27-2.73.52-.13,1.37.85.83a8.27,8.27,0,0,0-1,.36Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.52,56.58a9,9,0,0,0-2.2-1.39l-.92,9.62,2.37-.41.16-1.6-.69-.68A3.52,3.52,0,0,0,315,62Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.46,54.56l-.41-.09-.35-.07-.15,0-.28,0a20.31,20.31,0,0,0-2.3-.22h-.51l-.3,3.18c1.49,0,2.67.17,3.45.93s.26,1.31-1.05,1.56a6.2,6.2,0,0,1-2.63-.09l-.3,3.13a17.78,17.78,0,0,0,3.63.07l.75.74.85-8.95-.36-.1Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.81,210.71l2.06,1.52-3.12,4.2h0a6.65,6.65,0,0,1-1.31,1.34,5.3,5.3,0,0,1-.54.39,9.33,9.33,0,0,1-3.14,1.23,11.89,11.89,0,0,1-1.26.19,12.2,12.2,0,0,1-1.38.08,17.15,17.15,0,0,1-1.86-.08c-.67-.06-1.35-.15-2.05-.28-.52-.1-1-.21-1.57-.35-7.77-1.95-16.19-7.73-21.25-14.57q-.52-.69-1-1.41c-.45-.68-.86-1.36-1.23-2.06s-.58-1.12-.83-1.67-.39-1-.55-1.4-.3-.91-.42-1.35h0a12.46,12.46,0,0,1-.43-3.67c0-.25,0-.49.06-.72a7.46,7.46,0,0,1,.89-2.77,6.26,6.26,0,0,1,.48-.74h0l2.94-4L323.2,186l.83-.14a16.62,16.62,0,0,1,3.54,0,20.14,20.14,0,0,1,2.26.32,26.15,26.15,0,0,1,3,.77,41.52,41.52,0,0,1,18.54,12.71,31.73,31.73,0,0,1,1.95,2.62c.5.74.95,1.49,1.36,2.25a20.77,20.77,0,0,1,1.49,3.39A14.45,14.45,0,0,1,356.81,210.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.74,208.28l6.31-8.54,2.88,2.64-6.32,8.55C326.61,210.08,325.65,209.2,324.74,208.28Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.75,216.43h0a6.65,6.65,0,0,1-1.31,1.34,5.3,5.3,0,0,1-.54.39,9.33,9.33,0,0,1-3.14,1.23l-.45.08,6.49-8.78v0l2.06,1.52Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.24,204.79l1.89.81-9.49,12.78c-.63-.21-1.27-.45-1.91-.7Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,215.38l8.2-11.09,3,2.55-7.64,10.32A38.74,38.74,0,0,1,334,215.38Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.31,184.61,323.2,186l.83-.14a16.62,16.62,0,0,1,3.54,0,20.14,20.14,0,0,1,2.26.32,26.15,26.15,0,0,1,3,.77c.94.29,1.89.65,2.84,1.05l-13.17,17.8c-.38-.45-.75-.92-1.09-1.39s-.68-.93-1-1.41c-.45-.68-.86-1.36-1.23-2.06s-.58-1.12-.83-1.67-.39-1-.55-1.4-.3-.91-.42-1.35h0a12.46,12.46,0,0,1-.43-3.67c0-.25,0-.49.06-.72a7.46,7.46,0,0,1,.89-2.77,6.26,6.26,0,0,1,.48-.74h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.94,192.82c0-.25,0-.49.06-.72a7.46,7.46,0,0,1,.89-2.77,6.26,6.26,0,0,1,.48-.74h0l2.94-4L323.2,186h0l.46.7-6.54,8.85A11.29,11.29,0,0,1,316.94,192.82Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,200c-.41-.76-.86-1.51-1.36-2.25a31.73,31.73,0,0,0-1.95-2.62,41.6,41.6,0,0,0-18.54-12.71,26.07,26.07,0,0,0-3-.76,22.81,22.81,0,0,0-2.26-.33,16,16,0,0,0-3.54,0,10.18,10.18,0,0,0-3.27.93,7,7,0,0,0-3.14,2.9,7.58,7.58,0,0,0-.89,2.77q0,.34-.06.72a11.83,11.83,0,0,0,.43,3.67h0c.11.44.25.89.41,1.35s.35.92.56,1.4.52,1.11.82,1.67.79,1.38,1.24,2.06c.31.48.64.95,1,1.41,5.06,6.85,13.48,12.62,21.25,14.58.53.13,1.06.24,1.58.34.69.13,1.37.22,2.05.29s1.27.08,1.86.07a12,12,0,0,0,1.37-.08,12.5,12.5,0,0,0,1.27-.19A9.36,9.36,0,0,0,357,214c.19-.12.37-.25.55-.39a6.6,6.6,0,0,0,1.81-2.13,8.27,8.27,0,0,0,.9-4.44,14.09,14.09,0,0,0-.73-3.68A21.67,21.67,0,0,0,358,200Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.54,201.65c-.38-.46-.75-.92-1.1-1.4s-.67-.93-1-1.41c-.45-.68-.86-1.36-1.24-2.06s-.58-1.12-.82-1.67-.4-.94-.56-1.4-.3-.91-.41-1.35h0a11.83,11.83,0,0,1-.43-3.67q0-.37.06-.72a7.58,7.58,0,0,1,.89-2.77,7,7,0,0,1,3.14-2.9,10.26,10.26,0,0,1,3.27-.93,16,16,0,0,1,3.54,0c.66.06,1.33.16,2,.28Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.2,191.37a12,12,0,0,1-.2-2.68q0-.37.06-.72a7.58,7.58,0,0,1,.89-2.77,6.87,6.87,0,0,1,2.45-2.52Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.66,206.8c-1-.85-2-1.73-2.87-2.65l8-21.83.32.1c1,.32,2,.71,3.06,1.14Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.56,213a38.74,38.74,0,0,1-3.52-1.78l8.84-24c1.12.76,2.22,1.58,3.27,2.45Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.71,214.25c-.64-.21-1.29-.45-1.93-.71l8.44-23c.56.49,1.11,1,1.64,1.51Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.57,201.16h0c.15.31.29.62.41.93,0,.1.09.2.13.3l.12.32c.09.23.17.46.25.68a14.09,14.09,0,0,1,.73,3.68,8.27,8.27,0,0,1-.9,4.44,6.6,6.6,0,0,1-1.81,2.13c-.18.14-.36.27-.55.39a9.36,9.36,0,0,1-3.13,1.23l-.46.08Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.4,199.54c-3.66-6.74-12.14-12.72-19.31-13.76l-.9-.11c-7.35-.63-10.2,4.55-6.38,11.58s12.87,13.23,20.22,13.86c.3,0,.59,0,.87,0C354.59,211.32,357.07,206.28,353.4,199.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.81,199.49c-.11-.22-.24-.44-.37-.65-3.68-6.17-11.46-11.54-18.08-12.5l-.18,0c-.23,0-.46-.06-.69-.08a10.37,10.37,0,0,0-3.66.27,5.16,5.16,0,0,0-4,4.86,10.34,10.34,0,0,0,1.09,4.89c.16.34.33.69.52,1s.36.64.56,1a20.55,20.55,0,0,0,1.38,2,29.24,29.24,0,0,0,14.17,9.72,18,18,0,0,0,2.19.48c.34.06.68.1,1,.13s.57,0,.84,0h.22a7.79,7.79,0,0,0,4.4-1.12c1.87-1.25,2.64-3.45,2.07-6.22A13.64,13.64,0,0,0,352.81,199.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.81,199.49c-.11-.22-.24-.44-.37-.65-3.68-6.17-11.46-11.54-18.08-12.5l-.18,0c-.23,0-.46-.06-.69-.08a10.37,10.37,0,0,0-3.66.27,5.16,5.16,0,0,0-4,4.86,10.34,10.34,0,0,0,1.09,4.89c.16.34.33.69.52,1s.36.64.56,1a20.55,20.55,0,0,0,1.38,2,29.24,29.24,0,0,0,14.17,9.72,18,18,0,0,0,2.19.48c.34.06.68.1,1,.13s.57,0,.84,0h.22a7.79,7.79,0,0,0,4.4-1.12c1.87-1.25,2.64-3.45,2.07-6.22A13.64,13.64,0,0,0,352.81,199.49Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.29,200.41c.13.21.25.43.37.65a14,14,0,0,1,1.44,3.76,6.72,6.72,0,0,1-.33,4.19,4.44,4.44,0,0,1-.59.46,7.79,7.79,0,0,1-4.4,1.12h-.22c-.27,0-.56,0-.84,0s-.68-.07-1-.13a18,18,0,0,1-2.19-.48,29.24,29.24,0,0,1-14.17-9.72,20.55,20.55,0,0,1-1.38-2c-.2-.32-.38-.64-.56-1s-.36-.7-.52-1a10.34,10.34,0,0,1-1.09-4.89,5.88,5.88,0,0,1,.49-2,5.93,5.93,0,0,1,2.4-1.27,10.35,10.35,0,0,1,3.66-.27l.69.08.18,0C339.83,188.87,347.61,194.24,351.29,200.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,214c-5.61,3.14-12.93.62-18.39-2.11-8.13-4.39-15.47-11.2-18.05-19.59h0a9.63,9.63,0,0,1,.44-7.14,9.57,9.57,0,0,0-.6,7.19h0c1.94,6.94,7.42,12.78,13.61,17.1C340.34,213.66,349.69,218,357,214Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.83,196.16a10,10,0,0,0,6.14,4.27l-.88.14-1.6,2.16a12.44,12.44,0,0,0,1.13,1.16,11.87,11.87,0,0,0,2.3,1.57,14.61,14.61,0,0,0,4.32,1.43L342.5,209l3.6.31,1.6-2.16-.32-.54-.07-.12a2.39,2.39,0,0,0,.43-.46l.11-.18c.16-.29,1.12-1.47,1.48-2a1.74,1.74,0,0,0,.11-.18c.38-.65.28-1.57-.43-2.75h0a8.2,8.2,0,0,0-2.94-2.86l-.31-.17,0,0-.32-.17-.29-.14-.12,0a1.15,1.15,0,0,0-.23-.1,17.81,17.81,0,0,0-1.92-.71c-.28-.09-.57-.17-.86-.24l1.16-.2,1.59-2.16a12.92,12.92,0,0,0-7.3-3.83l-1.27-2.12-3.59-.25-1.6,2.15.4.67a1.75,1.75,0,0,0-.36.36v0c-.23.35-1.32,1.75-1.58,2.14l0,0C329,194,329.08,194.9,329.83,196.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.26,204c-.41.56-1.26,1.61-1.41,1.88l-.11.18a3.25,3.25,0,0,1-.43.47l-.9-1.53A3.11,3.11,0,0,0,349.26,204Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,194.12c-.38-.63-.15-1.13,1.34-1a5,5,0,0,1,3.6,1.7l3.79-.64-1.59,2.15-1.15.2-.09,0-1.32-.34-.5-.12a17.32,17.32,0,0,1-2.75-.81,3.13,3.13,0,0,1-1-.63A1.94,1.94,0,0,1,336,194.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.38,190.75l-.4-.66,1.6-2.15,1.26,2.11A4.42,4.42,0,0,0,331.38,190.75Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.1,206.86l3.6.31-1.6,2.16-3.6-.31-1.25-2.12a14.9,14.9,0,0,1-4.33-1.44,11.57,11.57,0,0,1-2.3-1.57,11.32,11.32,0,0,1-1.13-1.16l1.6-2.16a9.57,9.57,0,0,0,1.13,1.16,11.38,11.38,0,0,0,2.29,1.57,14.8,14.8,0,0,0,4.33,1.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.25,206.9a11.42,11.42,0,0,1-3.62-.92,9.29,9.29,0,0,1-3-2.09,17.61,17.61,0,0,0,3.15,1.81c.56.25,1.13.46,1.71.66S340.65,206.73,341.25,206.9Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.42,193.29h0c.26-.39,1.35-1.79,1.58-2.14-.43.66-.33,1.6.41,2.86,1.67,2.79,4.5,3.87,7.29,4.6,2.59.67,4.67.88,5.47,2.23.51.85-.06,1.18-1.23,1.1a5.5,5.5,0,0,1-3.85-2l-3.13.51h0c-2.4-.74-4.7-1.87-6.13-4.27C329.08,194.9,329,194,329.42,193.29Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.36 196.95 340.95 194.79 344.74 194.14 343.15 196.3 339.36 196.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.36 196.95 340.95 194.79 344.74 194.14 343.15 196.3 339.36 196.95",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.58 187.94 333.84 190.05 331.38 190.75 330.98 190.09 332.58 187.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.58 187.94 333.84 190.05 331.38 190.75 330.98 190.09 332.58 187.94",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.38,206.63l-1-1.64a3.07,3.07,0,0,0,2.92-1.1,1.74,1.74,0,0,0,.11-.18c.38-.65.28-1.57-.43-2.75h0a8.2,8.2,0,0,0-2.94-2.86l-.31-.17,0,0-.32-.17-.29-.14-.12,0a1.15,1.15,0,0,0-.23-.1,17.81,17.81,0,0,0-1.92-.71l-.94-.27-1.32-.34-.5-.12a17,17,0,0,1-2.75-.81,3.13,3.13,0,0,1-1-.63,2.51,2.51,0,0,1-.35-.44c-.38-.64-.15-1.14,1.34-1a5,5,0,0,1,3.6,1.7l3.79-.65a12.92,12.92,0,0,0-7.3-3.83l-1.27-2.12-3.59-.25,1.26,2.11c-1.4.08-2.38.43-2.82,1.07v0c-.43.66-.33,1.61.42,2.86,1.65,2.79,4.49,3.87,7.28,4.6,2.59.67,4.67.88,5.47,2.24.5.84-.06,1.17-1.24,1.09a5.52,5.52,0,0,1-3.84-2l-4,.65a10.36,10.36,0,0,0,1.13,1.16,11.56,11.56,0,0,0,2.29,1.58,15.07,15.07,0,0,0,4.33,1.43l1.26,2.12,3.6.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.38,206.63l-1-1.64a3.07,3.07,0,0,0,2.92-1.1,1.74,1.74,0,0,0,.11-.18c.38-.65.28-1.57-.43-2.75h0a8.2,8.2,0,0,0-2.94-2.86l-.31-.17,0,0-.32-.17-.29-.14-.12,0a1.15,1.15,0,0,0-.23-.1,17.81,17.81,0,0,0-1.92-.71l-.94-.27-1.32-.34-.5-.12a17,17,0,0,1-2.75-.81,3.13,3.13,0,0,1-1-.63,2.51,2.51,0,0,1-.35-.44c-.38-.64-.15-1.14,1.34-1a5,5,0,0,1,3.6,1.7l3.79-.65a12.92,12.92,0,0,0-7.3-3.83l-1.27-2.12-3.59-.25,1.26,2.11c-1.4.08-2.38.43-2.82,1.07v0c-.43.66-.33,1.61.42,2.86,1.65,2.79,4.49,3.87,7.28,4.6,2.59.67,4.67.88,5.47,2.24.5.84-.06,1.17-1.24,1.09a5.52,5.52,0,0,1-3.84-2l-4,.65a10.36,10.36,0,0,0,1.13,1.16,11.56,11.56,0,0,0,2.29,1.58,15.07,15.07,0,0,0,4.33,1.43l1.26,2.12,3.6.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.43,194a8.6,8.6,0,0,0,2.53,2.57,13,13,0,0,0,3.38,1.54c1.19.4,2.42.66,3.64,1a11.59,11.59,0,0,1,1.81.59,2.92,2.92,0,0,1,1.39,1.17,3,3,0,0,0-1.43-1.1,13.83,13.83,0,0,0-1.8-.54c-1.22-.28-2.46-.54-3.67-.93a12.61,12.61,0,0,1-3.4-1.6,8.58,8.58,0,0,1-1.4-1.21A8.16,8.16,0,0,1,331.43,194Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.1 206.86 342.5 209.02 341.25 206.9 342.84 204.74 344.1 206.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.1 206.86 342.5 209.02 341.25 206.9 342.84 204.74 344.1 206.86",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.7 207.17 344.29 206.63 342.84 204.74 344.1 206.86 347.7 207.17",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.44 190.31 336.02 188.42 332.58 187.94 336.17 188.19 337.44 190.31",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.74,194.14a12,12,0,0,0-1-1l-.46,1.24Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.49,194.09a8.23,8.23,0,0,0,2.82,2.78l2.69-7.3-.83-1.38-2.45-.17-.42,1.13.54.9a8,8,0,0,0-.9.1Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.75,200.54a8.35,8.35,0,0,0-1.57-1.67l-2.95,8,2.12.19.49-1.34-.43-.73a3.39,3.39,0,0,0,.69,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.73,197.91l-.32-.17-.29-.14-.12,0a1.15,1.15,0,0,0-.23-.1,17.81,17.81,0,0,0-1.92-.71l-.43-.12-1,2.65a4.18,4.18,0,0,1,2.73,1.57c.5.84-.06,1.17-1.24,1.09a5.36,5.36,0,0,1-2.22-.67l-1,2.61a15.74,15.74,0,0,0,3.08.87l.48.8,2.73-7.45-.29-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.56,93.9l2,1.46-3,4.06h0a7,7,0,0,1-1.26,1.3c-.17.13-.35.25-.53.37a9,9,0,0,1-3,1.18,9.31,9.31,0,0,1-1.23.19c-.42.05-.86.07-1.32.08s-1.17,0-1.8-.07-1.31-.16-2-.28c-.5-.09-1-.2-1.52-.33-7.49-1.89-15.62-7.46-20.5-14.07-.34-.45-.66-.9-.95-1.36-.44-.65-.84-1.32-1.2-2s-.56-1.09-.79-1.62-.38-.91-.54-1.35-.29-.88-.4-1.3h0a12,12,0,0,1-.41-3.55q0-.34.06-.69a7.16,7.16,0,0,1,.85-2.67c.14-.25.3-.49.46-.72h0l2.84-3.83,1.82,1.33.81-.13a16,16,0,0,1,3.41,0,21.35,21.35,0,0,1,2.19.31,27,27,0,0,1,2.87.74A40.1,40.1,0,0,1,457.29,83.2c.68.83,1.31,1.68,1.88,2.53s.92,1.45,1.32,2.18a19.73,19.73,0,0,1,1.43,3.27A14.18,14.18,0,0,1,462.56,93.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.61,91.55l6.09-8.23,2.79,2.54-6.11,8.25C433.42,93.3,432.49,92.44,431.61,91.55Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.54,99.42h0a7,7,0,0,1-1.26,1.3c-.17.13-.35.25-.53.37a9,9,0,0,1-3,1.18l-.45.08,6.28-8.47v0l2,1.46Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.29,88.19l1.82.78L447,101.3c-.61-.2-1.23-.43-1.84-.68Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.54,98.41l7.92-10.7,2.85,2.45-7.38,10C442.79,99.62,441.66,99,440.54,98.41Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.3,68.72l1.82,1.33.81-.13a16,16,0,0,1,3.41,0,21.35,21.35,0,0,1,2.19.31,27,27,0,0,1,2.87.74c.91.28,1.83.63,2.74,1L429.43,89.14c-.37-.45-.72-.89-1.05-1.35s-.66-.9-.95-1.36c-.44-.65-.84-1.32-1.2-2s-.56-1.09-.79-1.62-.38-.91-.54-1.35-.29-.88-.4-1.3h0a12,12,0,0,1-.41-3.55q0-.34.06-.69a7.16,7.16,0,0,1,.85-2.67c.14-.25.3-.49.46-.72h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.09,76.63q0-.34.06-.69a7.16,7.16,0,0,1,.85-2.67c.14-.25.3-.49.46-.72h0l2.84-3.83,1.82,1.33h0l.45.67-6.32,8.54A11.56,11.56,0,0,1,424.09,76.63Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.7,83.57c-.39-.73-.83-1.46-1.31-2.18s-1.21-1.7-1.89-2.53A40.1,40.1,0,0,0,442.61,66.6a25.77,25.77,0,0,0-2.87-.74,21.35,21.35,0,0,0-2.19-.31,16.06,16.06,0,0,0-3.41,0,10,10,0,0,0-3.15.9,6.74,6.74,0,0,0-3,2.8,7.49,7.49,0,0,0-.86,2.67c0,.23,0,.46,0,.7a11.59,11.59,0,0,0,.41,3.54h0c.11.43.25.86.4,1.3s.34.89.54,1.35.5,1.07.79,1.62.76,1.33,1.19,2c.3.46.62.91.95,1.36,4.89,6.6,13,12.18,20.51,14.06.51.13,1,.24,1.52.34q1,.18,2,.27a15.91,15.91,0,0,0,1.8.07c.46,0,.9,0,1.32-.07s.83-.11,1.22-.19a8.77,8.77,0,0,0,3-1.19c.18-.12.36-.24.53-.37A6.52,6.52,0,0,0,465,94.67a8.07,8.07,0,0,0,.87-4.28,13.46,13.46,0,0,0-.71-3.55A20.7,20.7,0,0,0,463.7,83.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.38,85.16c-.36-.44-.72-.89-1.06-1.35s-.65-.9-.95-1.36c-.43-.66-.83-1.32-1.19-2s-.56-1.09-.79-1.62-.38-.91-.54-1.35-.29-.87-.4-1.3h0a11.59,11.59,0,0,1-.41-3.54c0-.24,0-.47,0-.7a7.49,7.49,0,0,1,.86-2.67,6.74,6.74,0,0,1,3-2.8,10,10,0,0,1,3.15-.9,16.06,16.06,0,0,1,3.41,0,18.83,18.83,0,0,1,1.94.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.23,75.23a11.06,11.06,0,0,1-.19-2.58c0-.24,0-.47,0-.7a7.49,7.49,0,0,1,.86-2.67,6.57,6.57,0,0,1,2.37-2.43Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.33,90.12c-1-.81-1.9-1.67-2.77-2.55L442.3,66.5l.31.1c1,.31,2,.68,3,1.1Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.88,96.14a34.82,34.82,0,0,1-3.39-1.72L452,71.24c1.09.73,2.14,1.52,3.16,2.35Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.92,97.31c-.62-.2-1.24-.43-1.86-.67l8.15-22.17c.54.47,1.06,1,1.57,1.45Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.26,84.68h0c.15.31.28.6.4.9l.12.29.12.31.24.66a13.46,13.46,0,0,1,.71,3.55,8.07,8.07,0,0,1-.87,4.28,6.52,6.52,0,0,1-1.75,2.06c-.17.13-.35.25-.53.37a8.77,8.77,0,0,1-3,1.19l-.44.08Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.27,83.12c-3.53-6.5-11.71-12.28-18.63-13.28-.29,0-.59-.08-.88-.1-7.09-.61-9.84,4.39-6.15,11.17S446,93.68,453.12,94.29l.85,0C460.42,94.49,462.81,89.62,459.27,83.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.7,83.07q-.17-.31-.36-.63c-3.54-6-11-11.13-17.44-12.06l-.18,0-.66-.08a10.1,10.1,0,0,0-3.53.26,5,5,0,0,0-3.9,4.7A10,10,0,0,0,433.68,80c.15.32.31.66.5,1s.35.62.54.92a19.73,19.73,0,0,0,1.33,1.9,28.29,28.29,0,0,0,13.67,9.38,16.79,16.79,0,0,0,2.12.46c.33.06.66.09,1,.12s.55,0,.81.05h.22a7.52,7.52,0,0,0,4.24-1.08c1.81-1.21,2.55-3.34,2-6A13.34,13.34,0,0,0,458.7,83.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.7,83.07q-.17-.31-.36-.63c-3.54-6-11-11.13-17.44-12.06l-.18,0-.66-.08a10.1,10.1,0,0,0-3.53.26,5,5,0,0,0-3.9,4.7A10,10,0,0,0,433.68,80c.15.32.31.66.5,1s.35.62.54.92a19.73,19.73,0,0,0,1.33,1.9,28.29,28.29,0,0,0,13.67,9.38,16.79,16.79,0,0,0,2.12.46c.33.06.66.09,1,.12s.55,0,.81.05h.22a7.52,7.52,0,0,0,4.24-1.08c1.81-1.21,2.55-3.34,2-6A13.34,13.34,0,0,0,458.7,83.07Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.23,84q.19.32.36.63A13.1,13.1,0,0,1,459,88.22a6.48,6.48,0,0,1-.32,4,4.35,4.35,0,0,1-.57.45,7.52,7.52,0,0,1-4.24,1.08h-.22c-.26,0-.53,0-.81-.05s-.65-.06-1-.12a16.79,16.79,0,0,1-2.12-.46,28.29,28.29,0,0,1-13.67-9.38,19.73,19.73,0,0,1-1.33-1.9c-.19-.3-.37-.61-.54-.92s-.35-.68-.5-1a10,10,0,0,1-1.05-4.72,5.27,5.27,0,0,1,.47-1.95,5.68,5.68,0,0,1,2.31-1.23,10.14,10.14,0,0,1,3.53-.26l.67.08.17,0C446.17,72.82,453.68,78,457.23,84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.7,97.1c-5.42,3-12.48.61-17.75-2C437.1,90.83,430,84.26,427.53,76.16v0a9.34,9.34,0,0,1,.42-6.9,9.26,9.26,0,0,0-.57,6.94h0c1.88,6.7,7.16,12.33,13.14,16.51C446.66,96.74,455.69,101,462.7,97.1Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.53,79.86A9.7,9.7,0,0,0,442.45,84l-.85.14-1.54,2.08a10.52,10.52,0,0,0,1.09,1.12,11.45,11.45,0,0,0,2.21,1.52,14.64,14.64,0,0,0,4.18,1.38l1.22,2,3.47.3,1.54-2.08-.31-.53-.07-.11a2,2,0,0,0,.41-.45.82.82,0,0,0,.11-.17c.16-.28,1.08-1.42,1.43-1.91a.82.82,0,0,0,.11-.17c.36-.64.26-1.52-.42-2.66h0a8,8,0,0,0-2.84-2.76l-.3-.16,0,0-.31-.17-.28-.13-.12,0-.22-.1a16.5,16.5,0,0,0-1.85-.68l-.83-.24,1.12-.19,1.54-2.08a12.49,12.49,0,0,0-7.06-3.7l-1.21-2-3.47-.24L437.64,74l.38.64a1.7,1.7,0,0,0-.35.36h0c-.22.34-1.27,1.69-1.53,2.07h0C435.7,77.73,435.8,78.65,436.53,79.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.27,87.42c-.39.53-1.21,1.55-1.36,1.81l-.1.17a2.28,2.28,0,0,1-.42.45l-.87-1.47A3,3,0,0,0,455.27,87.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.49,77.89c-.37-.61-.15-1.09,1.29-1a4.81,4.81,0,0,1,3.48,1.64l3.66-.62L449.37,80l-1.1.2-.09,0-1.27-.33-.49-.12a16.21,16.21,0,0,1-2.64-.78,2.78,2.78,0,0,1-.95-.61A1.79,1.79,0,0,1,442.49,77.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,74.64l-.38-.64,1.54-2.08,1.21,2A4.15,4.15,0,0,0,438,74.64Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.3,90.18l3.47.31-1.54,2.08-3.48-.3-1.21-2a13.84,13.84,0,0,1-4.17-1.39,10.76,10.76,0,0,1-2.22-1.51,10.52,10.52,0,0,1-1.09-1.12l1.54-2.08a11.59,11.59,0,0,0,1.09,1.12,11,11,0,0,0,2.21,1.51,14.27,14.27,0,0,0,4.18,1.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.54,90.22a10.69,10.69,0,0,1-3.49-.89,8.87,8.87,0,0,1-2.9-2,17,17,0,0,0,3,1.75c.53.24,1.08.44,1.64.64S447,90.06,447.54,90.22Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.12,77.09h0c.26-.38,1.31-1.73,1.53-2.07-.42.64-.32,1.55.4,2.76,1.61,2.7,4.34,3.74,7,4.44,2.5.65,4.51.86,5.29,2.16.48.82-.07,1.14-1.2,1.06a5.33,5.33,0,0,1-3.71-1.94l-3,.49h0a9.72,9.72,0,0,1-5.92-4.13C435.8,78.64,435.71,77.73,436.12,77.09Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.72 80.62 447.26 78.54 450.92 77.91 449.38 79.99 445.72 80.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.72 80.62 447.26 78.54 450.92 77.91 449.38 79.99 445.72 80.62",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.18 71.92 440.39 73.97 438.02 74.64 437.64 74 439.18 71.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.18 71.92 440.39 73.97 438.02 74.64 437.64 74 439.18 71.92",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.46,90l-.94-1.58a3,3,0,0,0,2.82-1.06.82.82,0,0,0,.11-.17c.36-.64.26-1.52-.42-2.66h0a8,8,0,0,0-2.84-2.76l-.3-.16,0,0-.31-.17-.28-.13-.12,0-.22-.1a16.5,16.5,0,0,0-1.85-.68l-.9-.26-1.28-.33-.49-.12a16.7,16.7,0,0,1-2.65-.78,3,3,0,0,1-.94-.6,2.3,2.3,0,0,1-.34-.43c-.37-.62-.15-1.1,1.29-1a4.81,4.81,0,0,1,3.48,1.64l3.66-.63a12.49,12.49,0,0,0-7.06-3.7l-1.21-2-3.47-.24,1.22,2a3.43,3.43,0,0,0-2.73,1h0c-.42.64-.32,1.55.41,2.77,1.59,2.69,4.33,3.73,7,4.43,2.5.65,4.51.86,5.29,2.16.48.82-.07,1.13-1.2,1.06a5.35,5.35,0,0,1-3.71-1.94l-3.87.63a10.52,10.52,0,0,0,1.09,1.12,11.45,11.45,0,0,0,2.21,1.52,14.64,14.64,0,0,0,4.18,1.38l1.22,2,3.47.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.46,90l-.94-1.58a3,3,0,0,0,2.82-1.06.82.82,0,0,0,.11-.17c.36-.64.26-1.52-.42-2.66h0a8,8,0,0,0-2.84-2.76l-.3-.16,0,0-.31-.17-.28-.13-.12,0-.22-.1a16.5,16.5,0,0,0-1.85-.68l-.9-.26-1.28-.33-.49-.12a16.7,16.7,0,0,1-2.65-.78,3,3,0,0,1-.94-.6,2.3,2.3,0,0,1-.34-.43c-.37-.62-.15-1.1,1.29-1a4.81,4.81,0,0,1,3.48,1.64l3.66-.63a12.49,12.49,0,0,0-7.06-3.7l-1.21-2-3.47-.24,1.22,2a3.43,3.43,0,0,0-2.73,1h0c-.42.64-.32,1.55.41,2.77,1.59,2.69,4.33,3.73,7,4.43,2.5.65,4.51.86,5.29,2.16.48.82-.07,1.13-1.2,1.06a5.35,5.35,0,0,1-3.71-1.94l-3.87.63a10.52,10.52,0,0,0,1.09,1.12,11.45,11.45,0,0,0,2.21,1.52,14.64,14.64,0,0,0,4.18,1.38l1.22,2,3.47.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.07,77.78a8.09,8.09,0,0,0,2.44,2.47,13.06,13.06,0,0,0,3.26,1.5c1.15.38,2.34.63,3.52.93a11.76,11.76,0,0,1,1.74.56,3,3,0,0,1,1.35,1.13A2.83,2.83,0,0,0,449,83.32a11.15,11.15,0,0,0-1.73-.52c-1.18-.28-2.38-.53-3.54-.9a12.25,12.25,0,0,1-3.29-1.55,7.93,7.93,0,0,1-1.35-1.17A8,8,0,0,1,438.07,77.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.3 90.19 448.75 92.27 447.54 90.22 449.08 88.14 450.3 90.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.3 90.19 448.75 92.27 447.54 90.22 449.08 88.14 450.3 90.19",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.77 90.49 450.48 89.96 449.08 88.14 450.3 90.19 453.77 90.49",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.87 74.21 442.5 72.39 439.18 71.92 442.64 72.17 443.87 74.21",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.92,77.91a12.91,12.91,0,0,0-1-1l-.45,1.2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.12,77.87a8.12,8.12,0,0,0,2.73,2.68l2.59-7.06-.79-1.33L440.28,72l-.4,1.1.52.87a7.46,7.46,0,0,0-.88.09Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.78,84.09a7.83,7.83,0,0,0-1.52-1.62l-2.84,7.73,2.05.17.47-1.28-.42-.71a3.26,3.26,0,0,0,.67,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.87,81.55l-.31-.17-.28-.13-.12,0-.22-.1a16.5,16.5,0,0,0-1.85-.68l-.41-.12-.94,2.56a4.08,4.08,0,0,1,2.64,1.51c.48.82-.07,1.13-1.2,1.06a5.22,5.22,0,0,1-2.15-.65l-.93,2.52a15.4,15.4,0,0,0,3,.84l.46.77,2.64-7.19-.28-.15Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.66,132.9l-1.94,1.42,2.93,4h0a6.72,6.72,0,0,0,1.23,1.27l.51.36a8.66,8.66,0,0,0,2.95,1.15c.38.08.78.14,1.19.19s.84.07,1.29.07,1.14,0,1.75-.07,1.28-.15,1.93-.27c.49-.09,1-.2,1.48-.32,7.3-1.84,15.21-7.27,20-13.7.33-.44.64-.88.93-1.33.42-.63.81-1.28,1.16-1.93s.54-1.06.77-1.58.37-.88.53-1.31.28-.86.38-1.27h0a11.6,11.6,0,0,0,.4-3.45c0-.23,0-.46-.06-.68a7.09,7.09,0,0,0-.83-2.6c-.14-.24-.29-.47-.45-.7h0L384,108.37l-1.77,1.3-.78-.13a15.3,15.3,0,0,0-3.33,0,20.19,20.19,0,0,0-2.13.3,25.63,25.63,0,0,0-2.8.72,39.1,39.1,0,0,0-17.42,12c-.66.8-1.28,1.63-1.84,2.46s-.89,1.41-1.28,2.12a20.8,20.8,0,0,0-1.39,3.18A13.52,13.52,0,0,0,350.66,132.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.8,130.61l-5.93-8-2.71,2.48,5.94,8C379,132.31,380,131.48,380.8,130.61Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.65,138.27h0a6.72,6.72,0,0,0,1.23,1.27l.51.36a8.66,8.66,0,0,0,2.95,1.15l.43.08-6.11-8.25v0l-1.94,1.42Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.71,127.33l-1.77.76,8.91,12c.6-.19,1.2-.41,1.8-.65Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.1,137.28l-7.71-10.42-2.77,2.4,7.18,9.7A33.06,33.06,0,0,0,372.1,137.28Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,108.37l-1.77,1.3-.78-.13a15.3,15.3,0,0,0-3.33,0,20.19,20.19,0,0,0-2.13.3,25.63,25.63,0,0,0-2.8.72c-.88.28-1.78.61-2.67,1l12.39,16.74c.35-.43.7-.87,1-1.31s.64-.88.93-1.33c.42-.63.81-1.28,1.16-1.93s.54-1.06.77-1.58.37-.88.53-1.31.28-.86.38-1.27h0a11.6,11.6,0,0,0,.4-3.45c0-.23,0-.46-.06-.68a7.09,7.09,0,0,0-.83-2.6c-.14-.24-.29-.47-.45-.7h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.13,116.08c0-.23,0-.46-.06-.68a7.09,7.09,0,0,0-.83-2.6c-.14-.24-.29-.47-.45-.7h0L384,108.37l-1.77,1.3h0l-.43.66,6.15,8.31A10.85,10.85,0,0,0,388.13,116.08Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.15,126a12.78,12.78,0,0,0-.69,3.45,7.7,7.7,0,0,0,.84,4.18,6.18,6.18,0,0,0,1.71,2c.16.13.33.25.51.37a8.58,8.58,0,0,0,3,1.15,10.61,10.61,0,0,0,1.19.18c.41.05.84.07,1.29.08s1.14,0,1.75-.07,1.27-.15,1.93-.27c.48-.09,1-.2,1.48-.32,7.3-1.84,15.21-7.27,20-13.7.33-.44.63-.88.93-1.33.42-.64.81-1.28,1.16-1.93s.54-1.06.77-1.58.37-.88.52-1.32.28-.85.39-1.26h0a11.34,11.34,0,0,0,.41-3.45c0-.23,0-.46-.06-.68a7.09,7.09,0,0,0-.83-2.6,6.56,6.56,0,0,0-3-2.73,9.59,9.59,0,0,0-3.08-.87,15.16,15.16,0,0,0-3.32,0,20.26,20.26,0,0,0-2.13.31,28,28,0,0,0-2.8.71,39.1,39.1,0,0,0-17.42,12c-.66.81-1.28,1.63-1.84,2.46s-.89,1.41-1.28,2.12A20.47,20.47,0,0,0,348.15,126Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.05,124.38c.36-.43.7-.87,1-1.31s.63-.88.93-1.33c.42-.64.81-1.28,1.16-1.93s.54-1.06.77-1.58.37-.88.52-1.32.28-.85.39-1.26h0a11.34,11.34,0,0,0,.41-3.45c0-.23,0-.46-.06-.68a7.09,7.09,0,0,0-.83-2.6,6.56,6.56,0,0,0-3-2.73,9.59,9.59,0,0,0-3.08-.87,15.16,15.16,0,0,0-3.32,0q-.93.09-1.89.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.06,114.72a10.6,10.6,0,0,0,.2-2.52c0-.23,0-.46-.06-.68a7.09,7.09,0,0,0-.83-2.6,6.47,6.47,0,0,0-2.31-2.37Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.24,129.22c.94-.8,1.84-1.63,2.69-2.49l-7.54-20.52-.31.09c-.95.3-1.91.67-2.87,1.08Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.93,135.08a35.33,35.33,0,0,0,3.3-1.68l-8.3-22.58c-1.06.72-2.09,1.48-3.08,2.3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,136.22c.6-.2,1.21-.42,1.81-.66L356.85,114c-.53.46-1,.93-1.54,1.41Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,123.92h0q-.21.43-.39.87l-.12.29c0,.1-.07.2-.11.29s-.16.44-.23.65a12.78,12.78,0,0,0-.69,3.45,7.7,7.7,0,0,0,.84,4.18,6.18,6.18,0,0,0,1.71,2c.16.13.33.25.51.37a8.58,8.58,0,0,0,3,1.15l.43.08Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.86,122.4c3.44-6.34,11.41-12,18.15-12.94l.85-.1c6.91-.59,9.59,4.28,6,10.88s-12.1,12.44-19,13l-.82,0C352.74,133.47,350.41,128.73,353.86,122.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.41,122.35c.11-.21.23-.41.35-.61,3.46-5.8,10.77-10.85,17-11.75l.16,0,.65-.08a9.84,9.84,0,0,1,3.44.26,4.83,4.83,0,0,1,3.8,4.57,9.73,9.73,0,0,1-1,4.59c-.15.32-.31.65-.49,1s-.34.6-.53.9a18.65,18.65,0,0,1-1.29,1.85,27.62,27.62,0,0,1-13.32,9.13,17.35,17.35,0,0,1-2.06.46c-.32.05-.64.09-1,.11s-.53,0-.79,0h-.21a7.26,7.26,0,0,1-4.13-1.06c-1.76-1.17-2.48-3.24-1.95-5.84A12.74,12.74,0,0,1,354.41,122.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.41,122.35c.11-.21.23-.41.35-.61,3.46-5.8,10.77-10.85,17-11.75l.16,0,.65-.08a9.84,9.84,0,0,1,3.44.26,4.83,4.83,0,0,1,3.8,4.57,9.73,9.73,0,0,1-1,4.59c-.15.32-.31.65-.49,1s-.34.6-.53.9a18.65,18.65,0,0,1-1.29,1.85,27.62,27.62,0,0,1-13.32,9.13,17.35,17.35,0,0,1-2.06.46c-.32.05-.64.09-1,.11s-.53,0-.79,0h-.21a7.26,7.26,0,0,1-4.13-1.06c-1.76-1.17-2.48-3.24-1.95-5.84A12.74,12.74,0,0,1,354.41,122.35Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.85,123.21c-.13.21-.24.41-.35.61a13,13,0,0,0-1.35,3.54,6.32,6.32,0,0,0,.3,3.94,4,4,0,0,0,.56.43,7.26,7.26,0,0,0,4.13,1.06h.21c.26,0,.52,0,.79,0s.64-.06,1-.11a17.35,17.35,0,0,0,2.06-.46A27.62,27.62,0,0,0,376.48,123a18.65,18.65,0,0,0,1.29-1.85c.19-.3.36-.6.53-.9s.34-.66.49-1a9.73,9.73,0,0,0,1-4.59,5.25,5.25,0,0,0-.46-1.9,5.58,5.58,0,0,0-2.25-1.2,9.88,9.88,0,0,0-3.44-.25l-.65.07-.17,0C366.62,112.37,359.3,117.41,355.85,123.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.52,136c5.28,2.95,12.16.58,17.29-2,7.64-4.12,14.54-10.53,17-18.41h0a9,9,0,0,0-.4-6.71,9.09,9.09,0,0,1,.56,6.76h0c-1.83,6.52-7,12-12.79,16.07C366.14,135.67,357.35,139.79,350.52,136Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--money-sign--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "361.88 123.87 363.11 125.7 358 126.97 356.76 125.14 361.88 123.87",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.14,122.7c.57,1,2.44,1.31,4,1.52.39,0,.74.08,1.05.13a2,2,0,0,0,.47-.55c.57-1-.47-1.14-2.76-1.41a16.84,16.84,0,0,1-2.29-.41c.23-.54.12-1.17-1.74-1.1Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.06 111.59 374.3 113.42 373.14 115.47 371.9 113.64 373.06 111.59",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.6,118a3.35,3.35,0,0,1,2.75-1.35c2-.15,2.18.8,1.93,1.53l.22.32a3.8,3.8,0,0,0-.91,0,4.06,4.06,0,0,0-2.32.82C366,119.12,365.08,118.89,365.6,118Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.15,116a1.27,1.27,0,0,0,.58.46c0,.12-.05.24-.09.37l1.24,1.82a2.2,2.2,0,0,0-.18-1.94h0l-1.24-1.82S374.79,115.41,375.15,116Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.93,122.39c2.29.27,3.33.4,2.76,1.41a2,2,0,0,1-.47.55c1.54.21,2.19.44,1.71,1.28a3.31,3.31,0,0,1-2.79,1.3c-1.68.13-2.3-.36-2-1.23L358,127s0,.09,0,.14a2.4,2.4,0,0,0-.75,0l1,1.48.1.14v0h0a2.61,2.61,0,0,0,1.25.84,7.24,7.24,0,0,0,2.08.35l0,0-2.38.19,1.24,1.82h0l1.61-.12,2.18-.17h0l1.16-2c3.42-.59,6.21-2.13,7.58-4.55.62-1.1.67-1.86.35-2.41h0l0,0a.6.6,0,0,0-.09-.13L372.2,121a1.19,1.19,0,0,0-.28.69,9.73,9.73,0,0,0-1.58-.34c-2.14-.31-4.24-.21-3.5-1.52a2.18,2.18,0,0,1,.43-.53c-1.31-.15-2.19-.38-1.67-1.3a3.35,3.35,0,0,1,2.75-1.35c2-.15,2.18.8,1.93,1.53h0l.22.32,1,1.51,5.36-1.32-1.24-1.82a3.26,3.26,0,0,0,.14-.86,6.71,6.71,0,0,0-2.64-.51l.47-.83-3.07-.93-1.16,2.05c-3.46.62-6.51,2.2-7.9,4.67a3.78,3.78,0,0,0-.5,1.32A11.68,11.68,0,0,0,363.93,122.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.93,122.39c2.29.27,3.33.4,2.76,1.41a2,2,0,0,1-.47.55c1.54.21,2.19.44,1.71,1.28a3.31,3.31,0,0,1-2.79,1.3c-1.68.13-2.3-.36-2-1.23L358,127s0,.09,0,.14a2.4,2.4,0,0,0-.75,0l1,1.48.1.14v0h0a2.61,2.61,0,0,0,1.25.84,7.24,7.24,0,0,0,2.08.35l0,0-2.38.19,1.24,1.82h0l1.61-.12,2.18-.17h0l1.16-2c3.42-.59,6.21-2.13,7.58-4.55.62-1.1.67-1.86.35-2.41h0l0,0a.6.6,0,0,0-.09-.13L372.2,121a1.19,1.19,0,0,0-.28.69,9.73,9.73,0,0,0-1.58-.34c-2.14-.31-4.24-.21-3.5-1.52a2.18,2.18,0,0,1,.43-.53c-1.31-.15-2.19-.38-1.67-1.3a3.35,3.35,0,0,1,2.75-1.35c2-.15,2.18.8,1.93,1.53h0l.22.32,1,1.51,5.36-1.32-1.24-1.82a3.26,3.26,0,0,0,.14-.86,6.71,6.71,0,0,0-2.64-.51l.47-.83-3.07-.93-1.16,2.05c-3.46.62-6.51,2.2-7.9,4.67a3.78,3.78,0,0,0-.5,1.32A11.68,11.68,0,0,0,363.93,122.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M365.43,129.59a14,14,0,0,0,5.4-2.29,7.74,7.74,0,0,0,2-2.08,4.61,4.61,0,0,0,.62-1.26,1.75,1.75,0,0,0-.05-1.33,1.71,1.71,0,0,1,.17,1.35,4.8,4.8,0,0,1-.57,1.32,7.6,7.6,0,0,1-2,2.18,10.65,10.65,0,0,1-2.64,1.41A13.42,13.42,0,0,1,365.43,129.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M361,121.75a11.68,11.68,0,0,0,2.95.64c2.29.27,3.33.4,2.76,1.41a2,2,0,0,1-.47.55,4.27,4.27,0,0,1-2.32.75c-1.67.13-2.29-.36-2-1.23l-5.12,1.27a2,2,0,0,0,1.18,2.42,6.3,6.3,0,0,0,2.46.5l-1.16,2.05,2.38-.19,1.41-.11,1.16-2c3.42-.6,6.21-2.14,7.58-4.55a4,4,0,0,0,.53-1.42c.19-1.54-1.39-2-3.2-2.31-.63-.09-1.27-.15-1.83-.22-1.31-.15-2.19-.38-1.67-1.3a3.35,3.35,0,0,1,2.75-1.35c2-.15,2.18.8,1.93,1.53l5.36-1.31a3.26,3.26,0,0,0,.14-.86c0-1.08-.71-1.71-1.78-2a7.87,7.87,0,0,0-2.1-.3l1.16-2-3.75.28-1.17,2.06c-3.46.62-6.51,2.2-7.9,4.67C359.23,120.37,359.83,121.26,361,121.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,121.75a11.68,11.68,0,0,0,2.95.64c2.29.27,3.33.4,2.76,1.41a2,2,0,0,1-.47.55,4.27,4.27,0,0,1-2.32.75c-1.67.13-2.29-.36-2-1.23l-5.12,1.27a2,2,0,0,0,1.18,2.42,6.3,6.3,0,0,0,2.46.5l-1.16,2.05,2.38-.19,1.41-.11,1.16-2c3.42-.6,6.21-2.14,7.58-4.55a4,4,0,0,0,.53-1.42c.19-1.54-1.39-2-3.2-2.31-.63-.09-1.27-.15-1.83-.22-1.31-.15-2.19-.38-1.67-1.3a3.35,3.35,0,0,1,2.75-1.35c2-.15,2.18.8,1.93,1.53l5.36-1.31a3.26,3.26,0,0,0,.14-.86c0-1.08-.71-1.71-1.78-2a7.87,7.87,0,0,0-2.1-.3l1.16-2-3.75.28-1.17,2.06c-3.46.62-6.51,2.2-7.9,4.67C359.23,120.37,359.83,121.26,361,121.75Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.65,118.06l3.29-.81-1.14-3.54a8.64,8.64,0,0,0-.9-.07l.56-1-.32-1-2.83.21-.42.73Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,121.75a11.68,11.68,0,0,0,2.95.64l.74.09-2.06-6.39a7.64,7.64,0,0,0-2.37,2.51,4.53,4.53,0,0,0-.39.87l.65,2A3.62,3.62,0,0,0,361,121.75Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.41,124.79a5.27,5.27,0,0,1-1.51.31c-1.67.13-2.29-.36-2-1.23l-.57.14,1.82,5.64,1.06-1.88a18.23,18.23,0,0,0,2-.49Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.26,127.94a7.67,7.67,0,0,0,1.14.12l-.7,1.24.24.75,1.68-.13.29,0-1.8-5.59-1.87.46Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.31,120.09l.79,2.45a3.59,3.59,0,0,0,.2-.74A1.6,1.6,0,0,0,371.31,120.09Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.19 127.77 365.43 129.59 364.27 131.64 363.03 129.81 364.19 127.77",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.19 127.77 365.43 129.59 364.27 131.64 363.03 129.81 364.19 127.77",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.14,113.93l-.4.09-.46.11-.59.15-.69.21-.37.13-.38.14-.4.16-.4.17c-.26.13-.53.25-.79.4s-.51.29-.76.44-.48.33-.69.5-.42.35-.61.51l-.26.26-.13.12-.11.12c-.14.17-.28.32-.38.46s-.2.26-.27.37l-.21.33.2-.34a3.75,3.75,0,0,1,.26-.38,3.39,3.39,0,0,1,.37-.46l.1-.13.13-.13.25-.26a6.38,6.38,0,0,1,.61-.52c.21-.18.45-.34.69-.51s.5-.32.77-.45.53-.27.8-.4l.4-.17.4-.16.39-.14.38-.11c.24-.09.48-.14.69-.2s.42-.1.6-.14l.46-.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.03 129.81 359.24 130.11 360.4 128.06 359.63 129.87 363.03 129.81",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.9 113.64 372.75 111.8 369.31 111.87 373.06 111.59 371.9 113.64",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.05,68.58l-2.73,2,4.13,5.57h0a9.4,9.4,0,0,0,1.73,1.78c.23.18.48.35.73.51a12.38,12.38,0,0,0,4.15,1.63,14.11,14.11,0,0,0,1.68.25,17.62,17.62,0,0,0,1.82.11,23.31,23.31,0,0,0,2.46-.1c.89-.08,1.8-.21,2.72-.38.69-.13,1.38-.28,2.09-.46C72.12,76.91,83.27,69.25,90,60.19c.46-.62.89-1.24,1.3-1.87.6-.9,1.14-1.81,1.64-2.73.4-.75.77-1.49,1.09-2.22s.52-1.25.74-1.85.39-1.2.54-1.79h0a16.08,16.08,0,0,0,.56-4.86c0-.33,0-.65-.08-1a10,10,0,0,0-1.17-3.67,7.74,7.74,0,0,0-.64-1h0L90.08,34l-2.5,1.83c-.36-.07-.73-.13-1.11-.17a21.31,21.31,0,0,0-4.68,0,28.89,28.89,0,0,0-3,.43,35.26,35.26,0,0,0-4,1A55.07,55.07,0,0,0,50.29,53.89a41.66,41.66,0,0,0-2.59,3.47c-.66,1-1.26,2-1.81,3a29.35,29.35,0,0,0-2,4.48A20.13,20.13,0,0,0,43.05,68.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.54,65.35,77.17,54l-3.82,3.5,8.38,11.32Q83.73,67.18,85.54,65.35Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.45,76.15h0a9.4,9.4,0,0,0,1.73,1.78c.23.18.48.35.73.51a12.38,12.38,0,0,0,4.15,1.63l.61.11L43.06,68.54v0l-2.73,2Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4,60.73,51.9,61.8,64.47,78.73c.84-.28,1.68-.59,2.53-.93Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.28,74.76,62.41,60.07,58.5,63.44,68.62,77.12C70.19,76.42,71.75,75.63,73.28,74.76Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.08,34l-2.5,1.83c-.36-.07-.73-.13-1.11-.17a21.31,21.31,0,0,0-4.68,0,28.89,28.89,0,0,0-3,.43,35.26,35.26,0,0,0-4,1c-1.25.39-2.51.86-3.76,1.39L88.54,62c.5-.61,1-1.22,1.44-1.84s.89-1.24,1.3-1.87c.6-.9,1.14-1.81,1.64-2.73.4-.75.77-1.49,1.09-2.22s.52-1.25.74-1.85.39-1.2.54-1.79h0a16.08,16.08,0,0,0,.56-4.86c0-.33,0-.65-.08-1a10,10,0,0,0-1.17-3.67,7.74,7.74,0,0,0-.64-1h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.86,44.87c0-.33,0-.65-.08-1a10,10,0,0,0-1.17-3.67,7.74,7.74,0,0,0-.64-1h0L90.08,34l-2.5,1.83h-.06l-.61.93,8.67,11.72A14.65,14.65,0,0,0,95.86,44.87Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.51,58.88a18.66,18.66,0,0,0-1,4.87,10.93,10.93,0,0,0,1.19,5.88,8.94,8.94,0,0,0,2.41,2.83q.34.27.72.51A12.38,12.38,0,0,0,47,74.6a14.75,14.75,0,0,0,1.68.25,17.62,17.62,0,0,0,1.82.11,23.21,23.21,0,0,0,2.46-.1c.9-.08,1.8-.21,2.72-.38.69-.13,1.39-.28,2.09-.46,10.29-2.58,21.44-10.24,28.15-19.3.46-.62.89-1.24,1.31-1.87.59-.9,1.14-1.81,1.63-2.73.41-.75.77-1.49,1.09-2.22s.52-1.25.74-1.85.39-1.2.55-1.79h0a16.11,16.11,0,0,0,.57-4.86c0-.33,0-.65-.08-1a10,10,0,0,0-1.18-3.67,9.23,9.23,0,0,0-4.17-3.84,13.48,13.48,0,0,0-4.33-1.23,22,22,0,0,0-4.68-.05,28.89,28.89,0,0,0-3,.43,35.26,35.26,0,0,0-3.95,1A55,55,0,0,0,45.88,47.93a41.66,41.66,0,0,0-2.59,3.47c-.66,1-1.27,2-1.81,3A28.09,28.09,0,0,0,39.51,58.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.48,56.57c.5-.61,1-1.23,1.45-1.85s.89-1.24,1.31-1.87c.59-.9,1.14-1.81,1.63-2.73.41-.75.77-1.49,1.09-2.22s.52-1.25.74-1.85.39-1.2.55-1.79h0a16.11,16.11,0,0,0,.57-4.86c0-.33,0-.65-.08-1a10,10,0,0,0-1.18-3.67,9.23,9.23,0,0,0-4.17-3.84,13.48,13.48,0,0,0-4.33-1.23,22,22,0,0,0-4.68-.05c-.88.08-1.77.21-2.66.37Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.54,43a15.23,15.23,0,0,0,.28-3.55c0-.33,0-.65-.08-1a10,10,0,0,0-1.18-3.67,9,9,0,0,0-3.25-3.33Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.69,63.39q2-1.68,3.8-3.51L70.86,31l-.43.13a42.66,42.66,0,0,0-4.05,1.52Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.58,71.65c1.56-.7,3.12-1.49,4.65-2.36L57.53,37.46c-1.49,1-2.94,2.09-4.34,3.23Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.41,73.26q1.28-.42,2.55-.93L51.77,41.9c-.74.64-1.46,1.31-2.16,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.71,55.92h0q-.28.61-.54,1.23c-.06.13-.12.27-.17.4s-.11.28-.16.42c-.12.3-.23.61-.33.91a18.66,18.66,0,0,0-1,4.87,10.93,10.93,0,0,0,1.19,5.88,8.94,8.94,0,0,0,2.41,2.83q.34.27.72.51A12.38,12.38,0,0,0,47,74.6l.61.11Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.56,53.77c4.86-8.93,16.09-16.85,25.58-18.23l1.21-.14c9.73-.83,13.51,6,8.44,15.34S65.74,68.27,56,69.11l-1.16.06C46,69.38,42.7,62.7,47.56,53.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.34,53.7c.16-.28.32-.57.5-.86,4.87-8.17,15.18-15.28,24-16.55l.24,0,.91-.1a13.57,13.57,0,0,1,4.85.36A6.82,6.82,0,0,1,84.14,43a13.69,13.69,0,0,1-1.44,6.47c-.21.45-.44.91-.69,1.37s-.48.85-.74,1.27a29.86,29.86,0,0,1-1.82,2.61A38.87,38.87,0,0,1,60.67,67.55a22.59,22.59,0,0,1-2.9.64c-.46.07-.91.13-1.35.16s-.75.06-1.11.07H55a10.34,10.34,0,0,1-5.83-1.49c-2.48-1.65-3.49-4.57-2.74-8.24A18.11,18.11,0,0,1,48.34,53.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.34,53.7c.16-.28.32-.57.5-.86,4.87-8.17,15.18-15.28,24-16.55l.24,0,.91-.1a13.57,13.57,0,0,1,4.85.36A6.82,6.82,0,0,1,84.14,43a13.69,13.69,0,0,1-1.44,6.47c-.21.45-.44.91-.69,1.37s-.48.85-.74,1.27a29.86,29.86,0,0,1-1.82,2.61A38.87,38.87,0,0,1,60.67,67.55a22.59,22.59,0,0,1-2.9.64c-.46.07-.91.13-1.35.16s-.75.06-1.11.07H55a10.34,10.34,0,0,1-5.83-1.49c-2.48-1.65-3.49-4.57-2.74-8.24A18.11,18.11,0,0,1,48.34,53.7Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.37,54.92c-.18.29-.34.58-.5.86a18.11,18.11,0,0,0-1.9,5,8.91,8.91,0,0,0,.43,5.55,5.83,5.83,0,0,0,.78.61A10.34,10.34,0,0,0,55,68.42h.3c.36,0,.73,0,1.11-.07s.89-.09,1.35-.16a22.59,22.59,0,0,0,2.9-.64A38.87,38.87,0,0,0,79.45,54.68a29.86,29.86,0,0,0,1.82-2.61c.26-.42.51-.84.74-1.27s.48-.92.69-1.37A13.69,13.69,0,0,0,84.14,43a7.44,7.44,0,0,0-.65-2.69,7.83,7.83,0,0,0-3.17-1.68,13.8,13.8,0,0,0-4.85-.36c-.3,0-.61.06-.91.11l-.24,0C65.55,39.64,55.24,46.75,50.37,54.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.86,73c7.43,4.16,17.13.83,24.37-2.79,10.77-5.82,20.5-14.85,23.92-26v0c.84-3.13,1-6.58-.58-9.47,1.65,2.88,1.61,6.37.79,9.54v0c-2.58,9.19-9.84,16.93-18,22.66C64.87,72.47,52.49,78.28,42.86,73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--money-sign--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "58.86 55.85 60.61 58.42 53.4 60.21 51.65 57.64 58.86 55.85",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.82,54.21c.8,1.47,3.45,1.84,5.69,2.13l1.47.18a2.63,2.63,0,0,0,.67-.77c.81-1.42-.67-1.6-3.89-2a22.7,22.7,0,0,1-3.23-.57c.33-.76.18-1.66-2.45-1.56Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.62 38.55 76.37 41.12 74.73 44.01 72.99 41.43 74.62 38.55",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.11,47.53c.65-1.14,2.13-1.75,3.88-1.89,2.79-.22,3.07,1.12,2.71,2.15l.31.45a5.8,5.8,0,0,0-1.28,0,5.71,5.71,0,0,0-3.26,1.16C64.62,49.15,63.38,48.83,64.11,47.53Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.58,44.78a1.71,1.71,0,0,0,.8.64c0,.17-.07.34-.12.52L80,48.51a3.11,3.11,0,0,0-.25-2.74h0L78,43.2S77.07,43.93,77.58,44.78Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.76,53.76c3.22.39,4.7.57,3.89,2a2.63,2.63,0,0,1-.67.77c2.18.3,3.09.62,2.42,1.81-.49.87-1.71,1.66-3.93,1.83s-3.24-.51-2.86-1.74L53.4,60.21l0,.21a3.64,3.64,0,0,0-1.06-.08l1.38,2.09.13.2,0,0h0a3.7,3.7,0,0,0,1.76,1.18,10,10,0,0,0,2.93.49l0,0-3.35.26,1.75,2.58h0L59.17,67l3.07-.24h0l1.63-2.88c4.82-.84,8.76-3,10.68-6.42.88-1.55.94-2.63.49-3.4h0l0,0-.13-.19-1.48-2.12a1.68,1.68,0,0,0-.4,1,13.61,13.61,0,0,0-2.23-.49c-3-.43-6-.3-4.93-2.14a2.54,2.54,0,0,1,.61-.74c-1.85-.22-3.09-.54-2.36-1.84.65-1.14,2.13-1.75,3.88-1.89,2.79-.22,3.07,1.12,2.72,2.15h0l.3.45,1.44,2.12L80,48.51l-1.75-2.57a4.83,4.83,0,0,0,.2-1.22A9.61,9.61,0,0,0,74.73,44l.67-1.17-4.33-1.31-1.63,2.88c-4.88.88-9.17,3.11-11.14,6.58a5.37,5.37,0,0,0-.7,1.88A16.67,16.67,0,0,0,61.76,53.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.76,53.76c3.22.39,4.7.57,3.89,2a2.63,2.63,0,0,1-.67.77c2.18.3,3.09.62,2.42,1.81-.49.87-1.71,1.66-3.93,1.83s-3.24-.51-2.86-1.74L53.4,60.21l0,.21a3.64,3.64,0,0,0-1.06-.08l1.38,2.09.13.2,0,0h0a3.7,3.7,0,0,0,1.76,1.18,10,10,0,0,0,2.93.49l0,0-3.35.26,1.75,2.58h0L59.17,67l3.07-.24h0l1.63-2.88c4.82-.84,8.76-3,10.68-6.42.88-1.55.94-2.63.49-3.4h0l0,0-.13-.19-1.48-2.12a1.68,1.68,0,0,0-.4,1,13.61,13.61,0,0,0-2.23-.49c-3-.43-6-.3-4.93-2.14a2.54,2.54,0,0,1,.61-.74c-1.85-.22-3.09-.54-2.36-1.84.65-1.14,2.13-1.75,3.88-1.89,2.79-.22,3.07,1.12,2.72,2.15h0l.3.45,1.44,2.12L80,48.51l-1.75-2.57a4.83,4.83,0,0,0,.2-1.22A9.61,9.61,0,0,0,74.73,44l.67-1.17-4.33-1.31-1.63,2.88c-4.88.88-9.17,3.11-11.14,6.58a5.37,5.37,0,0,0-.7,1.88A16.67,16.67,0,0,0,61.76,53.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.87,63.92a19.84,19.84,0,0,0,7.62-3.24,11.13,11.13,0,0,0,2.76-2.93A7,7,0,0,0,75.12,56,2.43,2.43,0,0,0,75,54.1a2.42,2.42,0,0,1,.25,1.9,6.67,6.67,0,0,1-.8,1.86,11,11,0,0,1-2.79,3.08,15.37,15.37,0,0,1-3.73,2A19.46,19.46,0,0,1,63.87,63.92Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M57.6,52.87a16.67,16.67,0,0,0,4.16.89c3.22.39,4.7.57,3.89,2a2.63,2.63,0,0,1-.67.77,5.93,5.93,0,0,1-3.26,1.07c-2.36.18-3.24-.52-2.86-1.74l-7.21,1.79a2.85,2.85,0,0,0,1.67,3.41,8.87,8.87,0,0,0,3.46.71l-1.63,2.88,3.35-.26,2-.15,1.63-2.89c4.82-.84,8.76-3,10.69-6.41a5.51,5.51,0,0,0,.74-2c.27-2.17-2-2.87-4.5-3.25-.9-.13-1.8-.21-2.58-.31-1.85-.22-3.09-.54-2.36-1.84.65-1.14,2.13-1.75,3.88-1.89,2.79-.22,3.07,1.12,2.71,2.15l7.56-1.85a4.83,4.83,0,0,0,.2-1.22c0-1.52-1-2.4-2.51-2.86a11.11,11.11,0,0,0-3-.43l1.63-2.88-5.29.39-1.64,2.9c-4.88.88-9.17,3.11-11.13,6.58C55.14,50.92,56,52.18,57.6,52.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6,52.87a16.67,16.67,0,0,0,4.16.89c3.22.39,4.7.57,3.89,2a2.63,2.63,0,0,1-.67.77,5.93,5.93,0,0,1-3.26,1.07c-2.36.18-3.24-.52-2.86-1.74l-7.21,1.79a2.85,2.85,0,0,0,1.67,3.41,8.87,8.87,0,0,0,3.46.71l-1.63,2.88,3.35-.26,2-.15,1.63-2.89c4.82-.84,8.76-3,10.69-6.41a5.51,5.51,0,0,0,.74-2c.27-2.17-2-2.87-4.5-3.25-.9-.13-1.8-.21-2.58-.31-1.85-.22-3.09-.54-2.36-1.84.65-1.14,2.13-1.75,3.88-1.89,2.79-.22,3.07,1.12,2.71,2.15l7.56-1.85a4.83,4.83,0,0,0,.2-1.22c0-1.52-1-2.4-2.51-2.86a11.11,11.11,0,0,0-3-.43l1.63-2.88-5.29.39-1.64,2.9c-4.88.88-9.17,3.11-11.13,6.58C55.14,50.92,56,52.18,57.6,52.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.23,47.66l4.64-1.14-1.62-5c-.41,0-.83-.08-1.26-.09L73.78,40l-.46-1.4-4,.3-.58,1Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6,52.87a16.67,16.67,0,0,0,4.16.89l1,.13-2.9-9a10.91,10.91,0,0,0-3.34,3.54A6.44,6.44,0,0,0,56,49.65l.92,2.86A6.23,6.23,0,0,0,57.6,52.87Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.85,57.14a7.7,7.7,0,0,1-2.13.45c-2.36.18-3.24-.52-2.86-1.74l-.79.2L60.63,64l1.49-2.65A21,21,0,0,0,65,60.65Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.18,61.59a14.3,14.3,0,0,0,1.6.17l-1,1.74.35,1.06,2.36-.18.41,0-2.54-7.88-2.63.65Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.16,50.53,73.27,54a4.34,4.34,0,0,0,.28-1A2.22,2.22,0,0,0,72.16,50.53Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.13 61.34 63.87 63.92 62.24 66.8 60.49 64.23 62.13 61.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.13 61.34 63.87 63.92 62.24 66.8 60.49 64.23 62.13 61.34",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69,41.84l-.56.12-.65.16c-.24.06-.53.12-.83.22s-.63.17-1,.29l-.53.18-.54.2-.55.22-.57.25c-.37.17-.75.35-1.11.56s-.72.41-1.08.63-.67.45-1,.69-.59.49-.86.72l-.37.36-.17.18-.16.17c-.2.23-.39.44-.53.64s-.29.37-.38.52l-.3.47.28-.48c.09-.15.22-.33.36-.53a8.22,8.22,0,0,1,.52-.66l.15-.18.18-.18.36-.37c.27-.23.53-.5.85-.73s.64-.48,1-.71.71-.45,1.08-.64.75-.38,1.13-.56c.19-.09.38-.16.57-.24a5.42,5.42,0,0,1,.56-.22l.54-.2.54-.17c.34-.11.67-.19,1-.28s.59-.14.84-.19.46-.1.64-.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.49 64.23 55.15 64.64 56.78 61.76 55.69 64.3 60.49 64.23",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.99 41.43 74.19 38.83 69.33 38.94 74.62 38.55 72.99 41.43",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.08,214.22l-2.26,1.67,3.42,4.61h0A7.64,7.64,0,0,0,41.67,222a6.42,6.42,0,0,0,.6.42,10.1,10.1,0,0,0,3.44,1.35,11.89,11.89,0,0,0,1.39.21,12.09,12.09,0,0,0,1.5.09c.66,0,1.34,0,2-.08s1.49-.17,2.25-.31c.57-.11,1.14-.24,1.73-.38,8.52-2.14,17.76-8.48,23.31-16,.38-.51.74-1,1.08-1.55.49-.74,1-1.5,1.35-2.26s.64-1.23.91-1.84.43-1,.61-1.53.33-1,.45-1.48h0a13.31,13.31,0,0,0,.47-4c0-.27,0-.53-.06-.79a8.35,8.35,0,0,0-1-3,8.67,8.67,0,0,0-.53-.81h0L78,185.59,76,187.11c-.29-.06-.6-.11-.91-.15a17.8,17.8,0,0,0-3.88,0,22,22,0,0,0-2.49.36,31.18,31.18,0,0,0-3.26.83,45.64,45.64,0,0,0-20.34,13.95,35.73,35.73,0,0,0-2.14,2.88c-.55.81-1,1.64-1.5,2.47a24,24,0,0,0-1.63,3.72A15.92,15.92,0,0,0,39.08,214.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.26,211.55l-6.93-9.36-3.16,2.9,6.94,9.37C72.21,213.53,73.27,212.56,74.26,211.55Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.24,220.5h0A7.64,7.64,0,0,0,41.67,222a6.42,6.42,0,0,0,.6.42,10.1,10.1,0,0,0,3.44,1.35c.16,0,.33.06.5.09l-7.13-9.63v0l-2.26,1.67Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.47,207.73l-2.06.88,10.4,14c.7-.23,1.4-.49,2.1-.76Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.11,219.34l-9-12.16L51.87,210l8.38,11.33A42.43,42.43,0,0,0,64.11,219.34Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,185.59,76,187.11c-.29-.06-.6-.11-.91-.15a17.8,17.8,0,0,0-3.88,0,22,22,0,0,0-2.49.36,31.18,31.18,0,0,0-3.26.83c-1,.33-2.08.72-3.12,1.16l14.45,19.54q.63-.76,1.2-1.53c.38-.51.74-1,1.08-1.55.49-.74,1-1.5,1.35-2.26s.64-1.23.91-1.84.43-1,.61-1.53.33-1,.45-1.48h0a13.31,13.31,0,0,0,.47-4c0-.27,0-.53-.06-.79a8.35,8.35,0,0,0-1-3,8.67,8.67,0,0,0-.53-.81h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.81,194.59c0-.27,0-.53-.06-.79a8.35,8.35,0,0,0-1-3,8.67,8.67,0,0,0-.53-.81h0L78,185.59,76,187.11h0l-.51.77,7.18,9.7A12.44,12.44,0,0,0,82.81,194.59Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15,206.19a15.39,15.39,0,0,0-.81,4,9,9,0,0,0,1,4.87,7.44,7.44,0,0,0,2,2.34,6.42,6.42,0,0,0,.6.42,10,10,0,0,0,3.44,1.35,11.58,11.58,0,0,0,1.39.21,12.09,12.09,0,0,0,1.5.09c.65,0,1.33,0,2-.08s1.49-.17,2.25-.31c.58-.11,1.15-.24,1.73-.38,8.53-2.14,17.76-8.48,23.32-16,.38-.51.74-1,1.08-1.55.49-.74.94-1.5,1.35-2.26s.64-1.23.91-1.84.43-1,.61-1.53.32-1,.45-1.48h0a13.31,13.31,0,0,0,.47-4c0-.27,0-.53-.06-.79a8.36,8.36,0,0,0-1-3A7.68,7.68,0,0,0,75,183.05a11.18,11.18,0,0,0-3.59-1,17.7,17.7,0,0,0-3.87,0,24.42,24.42,0,0,0-2.49.35,29.11,29.11,0,0,0-3.27.84,45.47,45.47,0,0,0-20.33,13.95A33.5,33.5,0,0,0,39.27,200c-.54.82-1,1.64-1.49,2.47A22.56,22.56,0,0,0,36.15,206.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.38,204.28c.42-.5.82-1,1.21-1.53s.74-1,1.08-1.55c.49-.74.94-1.5,1.35-2.26s.64-1.23.91-1.84.43-1,.61-1.53.32-1,.45-1.48h0a13.31,13.31,0,0,0,.47-4c0-.27,0-.53-.06-.79a8.36,8.36,0,0,0-1-3A7.68,7.68,0,0,0,75,183.05a11.18,11.18,0,0,0-3.59-1,17.7,17.7,0,0,0-3.87,0,21.34,21.34,0,0,0-2.21.31Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.24,193a12.6,12.6,0,0,0,.22-2.94c0-.27,0-.53-.06-.79a8.36,8.36,0,0,0-1-3,7.48,7.48,0,0,0-2.69-2.76Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.77,209.93q1.65-1.4,3.14-2.91l-8.8-24-.36.11c-1.11.35-2.24.78-3.36,1.26Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9,216.77a42.43,42.43,0,0,0,3.86-2l-9.69-26.36q-1.86,1.26-3.59,2.68Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.45,218.1c.7-.23,1.41-.49,2.12-.77l-9.27-25.2c-.61.54-1.21,1.08-1.79,1.65Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14,203.74h0c-.16.35-.31.68-.45,1,0,.11-.1.23-.14.34s-.09.23-.13.34-.19.5-.27.75a15.39,15.39,0,0,0-.81,4,9,9,0,0,0,1,4.87,7.44,7.44,0,0,0,2,2.34,6.42,6.42,0,0,0,.6.42,10,10,0,0,0,3.44,1.35c.16,0,.33.06.5.09Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.81,202c4-7.39,13.32-14,21.19-15.09.33-.05.67-.09,1-.12,8.06-.69,11.19,5,7,12.7S57.87,214,49.81,214.66l-1,.06C41.51,214.89,38.79,209.36,42.81,202Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.46,201.91c.13-.24.26-.48.41-.72,4-6.76,12.57-12.66,19.83-13.71l.2,0c.25,0,.51-.07.76-.09a11.32,11.32,0,0,1,4,.3A5.66,5.66,0,0,1,73.11,193a11.48,11.48,0,0,1-1.2,5.36q-.25.56-.57,1.14c-.19.35-.39.7-.61,1.05a25.33,25.33,0,0,1-1.51,2.15,32.17,32.17,0,0,1-15.55,10.67,19.7,19.7,0,0,1-2.41.53c-.37.06-.74.1-1.11.13s-.63,0-.92.05H49a8.42,8.42,0,0,1-4.83-1.23c-2-1.37-2.89-3.79-2.27-6.82A14.84,14.84,0,0,1,43.46,201.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.46,201.91c.13-.24.26-.48.41-.72,4-6.76,12.57-12.66,19.83-13.71l.2,0c.25,0,.51-.07.76-.09a11.32,11.32,0,0,1,4,.3A5.66,5.66,0,0,1,73.11,193a11.48,11.48,0,0,1-1.2,5.36q-.25.56-.57,1.14c-.19.35-.39.7-.61,1.05a25.33,25.33,0,0,1-1.51,2.15,32.17,32.17,0,0,1-15.55,10.67,19.7,19.7,0,0,1-2.41.53c-.37.06-.74.1-1.11.13s-.63,0-.92.05H49a8.42,8.42,0,0,1-4.83-1.23c-2-1.37-2.89-3.79-2.27-6.82A14.84,14.84,0,0,1,43.46,201.91Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.14,202.92c-.15.24-.28.47-.41.71a14.84,14.84,0,0,0-1.58,4.13,7.35,7.35,0,0,0,.36,4.6,5.23,5.23,0,0,0,.64.5A8.42,8.42,0,0,0,49,214.09h.25c.29,0,.6,0,.92-.05s.74-.07,1.11-.13a19.7,19.7,0,0,0,2.41-.53,32.17,32.17,0,0,0,15.55-10.67,25.33,25.33,0,0,0,1.51-2.15c.22-.35.42-.7.61-1.05s.4-.77.57-1.14a11.48,11.48,0,0,0,1.2-5.36,6.35,6.35,0,0,0-.54-2.23,6.49,6.49,0,0,0-2.63-1.39,11.17,11.17,0,0,0-4-.29l-.75.08-.2,0C57.71,190.26,49.17,196.15,45.14,202.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.92,217.86c6.16,3.45,14.19.69,20.18-2.31,8.92-4.82,17-12.29,19.81-21.5v0a10.61,10.61,0,0,0-.48-7.84,10.54,10.54,0,0,1,.66,7.9v0c-2.13,7.61-8.14,14-14.93,18.76C57.15,217.45,46.89,222.26,38.92,217.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--money-sign--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "52.17 203.69 53.62 205.82 47.65 207.3 46.2 205.17 52.17 203.69",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.31,202.32c.66,1.23,2.85,1.53,4.71,1.77l1.22.15a2.26,2.26,0,0,0,.55-.63c.67-1.18-.55-1.34-3.22-1.65a19.35,19.35,0,0,1-2.67-.48c.27-.63.14-1.37-2-1.29Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.22 189.36 66.67 191.49 65.31 193.88 63.87 191.74 65.22 189.36",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.52,196.8a3.86,3.86,0,0,1,3.21-1.57c2.31-.18,2.54.93,2.25,1.78l.25.37a5.14,5.14,0,0,0-1.06,0,4.67,4.67,0,0,0-2.7,1C56.94,198.14,55.91,197.87,56.52,196.8Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.67,194.52a1.5,1.5,0,0,0,.67.53c0,.14-.06.28-.1.43l1.44,2.13a2.55,2.55,0,0,0-.2-2.27h0L68,193.21S67.25,193.81,67.67,194.52Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.57,202c2.67.31,3.89.47,3.22,1.65a2.26,2.26,0,0,1-.55.63c1.8.25,2.55.52,2,1.5-.41.72-1.42,1.37-3.25,1.52s-2.69-.43-2.38-1.44l-6,1.48,0,.17a3.11,3.11,0,0,0-.87-.07l1.14,1.73a1.63,1.63,0,0,0,.11.17v0h0a3,3,0,0,0,1.46,1,8.27,8.27,0,0,0,2.43.41l0,0L49.1,211l1.44,2.13h0l1.88-.15,2.55-.2h0l1.35-2.38c4-.7,7.25-2.49,8.85-5.32.72-1.28.77-2.17.4-2.81h0l0,0-.11-.15-1.23-1.76a1.43,1.43,0,0,0-.32.81,11.75,11.75,0,0,0-1.85-.41c-2.49-.35-4.95-.24-4.09-1.77a2.27,2.27,0,0,1,.51-.61c-1.53-.18-2.56-.45-1.95-1.52a3.86,3.86,0,0,1,3.21-1.57c2.31-.18,2.54.93,2.25,1.78h0l.25.37,1.19,1.76,6.26-1.53-1.44-2.13a4,4,0,0,0,.16-1,7.86,7.86,0,0,0-3.08-.59l.54-1-3.58-1.08-1.35,2.39c-4,.72-7.6,2.57-9.22,5.44a4.26,4.26,0,0,0-.58,1.56A13.87,13.87,0,0,0,54.57,202Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.57,202c2.67.31,3.89.47,3.22,1.65a2.26,2.26,0,0,1-.55.63c1.8.25,2.55.52,2,1.5-.41.72-1.42,1.37-3.25,1.52s-2.69-.43-2.38-1.44l-6,1.48,0,.17a3.11,3.11,0,0,0-.87-.07l1.14,1.73a1.63,1.63,0,0,0,.11.17v0h0a3,3,0,0,0,1.46,1,8.27,8.27,0,0,0,2.43.41l0,0L49.1,211l1.44,2.13h0l1.88-.15,2.55-.2h0l1.35-2.38c4-.7,7.25-2.49,8.85-5.32.72-1.28.77-2.17.4-2.81h0l0,0-.11-.15-1.23-1.76a1.43,1.43,0,0,0-.32.81,11.75,11.75,0,0,0-1.85-.41c-2.49-.35-4.95-.24-4.09-1.77a2.27,2.27,0,0,1,.51-.61c-1.53-.18-2.56-.45-1.95-1.52a3.86,3.86,0,0,1,3.21-1.57c2.31-.18,2.54.93,2.25,1.78h0l.25.37,1.19,1.76,6.26-1.53-1.44-2.13a4,4,0,0,0,.16-1,7.86,7.86,0,0,0-3.08-.59l.54-1-3.58-1.08-1.35,2.39c-4,.72-7.6,2.57-9.22,5.44a4.26,4.26,0,0,0-.58,1.56A13.87,13.87,0,0,0,54.57,202Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.32,210.37a16.66,16.66,0,0,0,6.31-2.68,9.43,9.43,0,0,0,2.29-2.43,5.85,5.85,0,0,0,.71-1.47,2,2,0,0,0-.06-1.55,2,2,0,0,1,.2,1.57,5.51,5.51,0,0,1-.66,1.54,9,9,0,0,1-2.31,2.55,12.56,12.56,0,0,1-3.09,1.64A15.4,15.4,0,0,1,56.32,210.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M51.13,201.22a14,14,0,0,0,3.44.74c2.67.31,3.89.47,3.22,1.65a2.26,2.26,0,0,1-.55.63,4.86,4.86,0,0,1-2.7.88c-2,.16-2.68-.42-2.37-1.43l-6,1.48A2.35,2.35,0,0,0,47.58,208a7.38,7.38,0,0,0,2.87.59L49.1,211l2.77-.22,1.65-.13,1.35-2.39c4-.69,7.25-2.49,8.85-5.3a4.85,4.85,0,0,0,.62-1.66c.22-1.8-1.62-2.38-3.73-2.7-.75-.1-1.49-.17-2.14-.25-1.53-.18-2.56-.45-1.95-1.52a3.86,3.86,0,0,1,3.21-1.57c2.31-.18,2.54.93,2.25,1.78l6.26-1.53a4,4,0,0,0,.16-1c0-1.26-.83-2-2.08-2.37a9.5,9.5,0,0,0-2.45-.36l1.35-2.38-4.38.32-1.36,2.41c-4,.72-7.59,2.57-9.22,5.44C49.09,199.61,49.79,200.64,51.13,201.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.13,201.22a14,14,0,0,0,3.44.74c2.67.31,3.89.47,3.22,1.65a2.26,2.26,0,0,1-.55.63,4.86,4.86,0,0,1-2.7.88c-2,.16-2.68-.42-2.37-1.43l-6,1.48A2.35,2.35,0,0,0,47.58,208a7.38,7.38,0,0,0,2.87.59L49.1,211l2.77-.22,1.65-.13,1.35-2.39c4-.69,7.25-2.49,8.85-5.3a4.85,4.85,0,0,0,.62-1.66c.22-1.8-1.62-2.38-3.73-2.7-.75-.1-1.49-.17-2.14-.25-1.53-.18-2.56-.45-1.95-1.52a3.86,3.86,0,0,1,3.21-1.57c2.31-.18,2.54.93,2.25,1.78l6.26-1.53a4,4,0,0,0,.16-1c0-1.26-.83-2-2.08-2.37a9.5,9.5,0,0,0-2.45-.36l1.35-2.38-4.38.32-1.36,2.41c-4,.72-7.59,2.57-9.22,5.44C49.09,199.61,49.79,200.64,51.13,201.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.41,196.9l3.84-.94-1.33-4.14c-.34,0-.69-.06-1.05-.08l.65-1.15-.37-1.15-3.31.24-.48.86Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.13,201.22a13.87,13.87,0,0,0,3.44.74l.86.1L53,194.6a9.07,9.07,0,0,0-2.77,2.93,5.82,5.82,0,0,0-.46,1l.77,2.37A3.69,3.69,0,0,0,51.13,201.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3,204.76a6.19,6.19,0,0,1-1.76.36c-2,.16-2.68-.42-2.37-1.43l-.66.16,2.12,6.58,1.24-2.2a17.45,17.45,0,0,0,2.37-.57Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.12,208.44a10.07,10.07,0,0,0,1.33.14L49.63,210l.28.88,2-.15.34,0-2.1-6.52-2.18.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.18,199.28l.92,2.85a4.17,4.17,0,0,0,.24-.86A1.84,1.84,0,0,0,63.18,199.28Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.87 208.23 56.32 210.37 54.97 212.75 53.52 210.62 54.87 208.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.87 208.23 56.32 210.37 54.97 212.75 53.52 210.62 54.87 208.23",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.48,192.09l-.46.1-.54.12-.69.18c-.25.08-.52.15-.8.25l-.44.14a4.7,4.7,0,0,1-.45.17l-.46.19-.46.2c-.31.14-.62.29-.92.46s-.6.35-.89.52-.56.38-.81.58-.49.41-.71.59l-.31.3-.14.15-.13.14c-.17.2-.33.37-.45.54s-.23.3-.31.43l-.25.38.24-.39c.07-.13.18-.27.29-.44a6.22,6.22,0,0,1,.44-.55l.12-.15.14-.15.3-.3c.23-.2.45-.42.71-.61a9.9,9.9,0,0,1,.81-.59c.29-.18.59-.37.9-.53s.62-.32.93-.46l.47-.2.46-.18.46-.17.44-.14c.28-.09.56-.16.81-.23s.49-.11.7-.16l.53-.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.52 210.62 49.1 210.97 50.45 208.58 49.54 210.68 53.52 210.62",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.87 191.74 64.87 189.59 60.84 189.68 65.22 189.36 63.87 191.74",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins-1--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.81,339.2l8.47,0V356.5h0a22.78,22.78,0,0,1-.83,6.15c-.2.71-.44,1.41-.7,2.11a30.56,30.56,0,0,1-5.91,9.45,38.51,38.51,0,0,1-3,3,43.27,43.27,0,0,1-3.5,2.92,56.72,56.72,0,0,1-5.1,3.47c-1.92,1.17-3.92,2.27-6,3.29-1.58.78-3.2,1.51-4.88,2.19C225.83,399.23,192,400.46,165,392.23c-1.84-.55-3.64-1.16-5.4-1.81-2.53-.92-5-1.93-7.35-3-1.93-.91-3.77-1.85-5.5-2.84-1.49-.85-2.91-1.73-4.24-2.63s-2.59-1.82-3.76-2.77h0a40.4,40.4,0,0,1-8.38-8.92c-.45-.68-.87-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0l0-16.39,7.75,0c.62-.67,1.27-1.34,2-2a54.76,54.76,0,0,1,9.33-7.08,74.22,74.22,0,0,1,6.67-3.6,88.62,88.62,0,0,1,9.44-3.84c22.17-7.67,50.41-8.7,74.41-2.74a106.84,106.84,0,0,1,10.37,3.11c2.79,1,5.49,2.1,8.08,3.32A71.33,71.33,0,0,1,264.49,333,48.27,48.27,0,0,1,271.81,339.2Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.65,396l0-35.18,12.88,1.35,0,35.21C190.19,397.11,185.88,396.65,181.65,396Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28,356.5h0a22.78,22.78,0,0,1-.83,6.15c-.2.71-.44,1.41-.7,2.11a30.56,30.56,0,0,1-5.91,9.45c-.34.38-.7.75-1,1.12l0-36.19.06.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.33,340.33l6.61-1.56,0,52.71q-3.16,1-6.47,1.92Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.29,396.63l0-45.69,12.88.95,0,42.55A129.86,129.86,0,0,1,220.29,396.63Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84,339.76l7.75,0c.62-.67,1.27-1.34,2-2a54.76,54.76,0,0,1,9.33-7.08,74.22,74.22,0,0,1,6.67-3.6,88.62,88.62,0,0,1,9.44-3.84c3.1-1.08,6.33-2,9.64-2.82l.06,73.4c-1.91-.48-3.8-1-5.65-1.56s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.93-7.35-3-1.93-.91-3.77-1.85-5.5-2.84-1.49-.85-2.91-1.73-4.24-2.63s-2.59-1.82-3.76-2.77h0a40.4,40.4,0,0,1-8.38-8.92c-.45-.68-.87-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4,370.22c-.45-.68-.87-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0l0-16.39,7.75,0,.1-.1,2.61.95,0,36.46A38.45,38.45,0,0,1,130.4,370.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.84,308.35c-2.59-1.21-5.29-2.31-8.08-3.31a106.84,106.84,0,0,0-10.37-3.11c-24-6-52.24-4.93-74.42,2.73a91.52,91.52,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93A23.2,23.2,0,0,0,126,342a24.9,24.9,0,0,0,3.11,9.13c.38.68.8,1.36,1.25,2a40.46,40.46,0,0,0,8.39,8.92h0q1.75,1.41,3.75,2.76c1.34.9,2.75,1.78,4.25,2.63,1.73,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.11-1,4.11-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a42.44,42.44,0,0,0,3-3,30.82,30.82,0,0,0,5.91-9.45c.26-.7.5-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26,27.44,27.44,0,0,0-6.37-13.59,46.48,46.48,0,0,0-9.21-8.34A71.35,71.35,0,0,0,253.84,308.35Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.84,308.35c-2.59-1.21-5.29-2.31-8.08-3.31a106.84,106.84,0,0,0-10.37-3.11c-24-6-52.24-4.93-74.42,2.73a91.52,91.52,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93A23.2,23.2,0,0,0,126,342a24.9,24.9,0,0,0,3.11,9.13c.38.68.8,1.36,1.25,2a40.46,40.46,0,0,0,8.39,8.92h0q1.75,1.41,3.75,2.76c1.34.9,2.75,1.78,4.25,2.63,1.73,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.11-1,4.11-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a42.44,42.44,0,0,0,3-3,30.82,30.82,0,0,0,5.91-9.45c.26-.7.5-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26,27.44,27.44,0,0,0-6.37-13.59,46.48,46.48,0,0,0-9.21-8.34A71.35,71.35,0,0,0,253.84,308.35Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.84,308.35c-2.59-1.21-5.29-2.31-8.08-3.31a106.84,106.84,0,0,0-10.37-3.11c-24-6-52.24-4.93-74.42,2.73a91.52,91.52,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93A23.2,23.2,0,0,0,126,342a24.9,24.9,0,0,0,3.11,9.13c.38.68.8,1.36,1.25,2a40.46,40.46,0,0,0,8.39,8.92h0q1.75,1.41,3.75,2.76c1.34.9,2.75,1.78,4.25,2.63,1.73,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.11-1,4.11-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a42.44,42.44,0,0,0,3-3,30.82,30.82,0,0,0,5.91-9.45c.26-.7.5-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26,27.44,27.44,0,0,0-6.37-13.59,46.48,46.48,0,0,0-9.21-8.34A71.35,71.35,0,0,0,253.84,308.35Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.71,376.78c-1.92-.48-3.82-1-5.68-1.56s-3.64-1.16-5.41-1.82c-2.53-.92-5-1.93-7.35-3-1.93-.91-3.76-1.85-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.75-2.76h0a40.46,40.46,0,0,1-8.39-8.92c-.45-.67-.87-1.35-1.25-2A24.9,24.9,0,0,1,126,342a23.2,23.2,0,0,1,2.65-13.93,34.35,34.35,0,0,1,6.87-8.93,54.74,54.74,0,0,1,9.33-7.07c1.88-1.14,3.86-2.21,5.91-3.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.22,359.93a38.17,38.17,0,0,1-5.84-6.73c-.45-.67-.87-1.35-1.25-2A24.9,24.9,0,0,1,126,342a22.66,22.66,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.49,380.36c-4.34-.26-8.64-.73-12.86-1.39L159.92,305l1.05-.38c3.34-1.15,6.83-2.14,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.15,377.43c-4.18.93-8.5,1.66-12.88,2.19l-23.89-81.38c4.49-.2,9-.18,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.92,374.45c-2.13.71-4.3,1.35-6.52,1.94l-22.84-77.81c2.45.2,4.89.45,7.31.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.66,310.29h0c1,.54,2,1.09,2.93,1.65l.94.57.94.59c.69.44,1.36.89,2,1.34a46.48,46.48,0,0,1,9.21,8.34,27.44,27.44,0,0,1,6.37,13.59,22.36,22.36,0,0,1-.63,9.26c-.19.71-.43,1.41-.69,2.11a30.82,30.82,0,0,1-5.91,9.45c-.34.38-.7.76-1.06,1.13Z",
    style: {
      fill: "#1976D2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.71,316.17c-23.06-10.71-57.42-9.91-78.55,1.48-.89.48-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.38s60.37,9.83,81.17-3c.84-.52,1.66-1.06,2.43-1.6C267.12,345.18,263.76,326.87,240.71,316.17Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.71,316.17c-23.06-10.71-57.42-9.91-78.55,1.48-.89.48-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.38s60.37,9.83,81.17-3c.84-.52,1.66-1.06,2.43-1.6C267.12,345.18,263.76,326.87,240.71,316.17Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,317.2c-.74-.35-1.5-.68-2.27-1-22-9.16-53.27-8.1-72.78,2.42l-.52.28c-.68.37-1.34.76-2,1.16a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.93,2.57,4,6.76,7.69,12.54,10.85,1.09.61,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a74.24,74.24,0,0,0,7.55,2.52c18.18,5,40.22,4.2,56.88-2.1a59.16,59.16,0,0,0,6.79-3c1-.53,2-1.09,3-1.68s1.59-1,2.32-1.53l.61-.44c4.86-3.57,8-7.55,9.49-11.67,2.52-7,.2-14.39-6.76-20.64A45.77,45.77,0,0,0,239,317.2Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,317.2c-.74-.35-1.5-.68-2.27-1-22-9.16-53.27-8.1-72.78,2.42l-.52.28c-.68.37-1.34.76-2,1.16a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.93,2.57,4,6.76,7.69,12.54,10.85,1.09.61,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a74.24,74.24,0,0,0,7.55,2.52c18.18,5,40.22,4.2,56.88-2.1a59.16,59.16,0,0,0,6.79-3c1-.53,2-1.09,3-1.68s1.59-1,2.32-1.53l.61-.44c4.86-3.57,8-7.55,9.49-11.67,2.52-7,.2-14.39-6.76-20.64A45.77,45.77,0,0,0,239,317.2Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.79,322.66c.77.32,1.53.66,2.27,1a45.51,45.51,0,0,1,11.25,7.18c4.07,3.65,6.54,7.68,7.4,11.8a17.21,17.21,0,0,1-.66,2.38c-1.48,4.12-4.63,8.1-9.49,11.67l-.61.44c-.73.52-1.51,1-2.32,1.53s-1.94,1.15-3,1.68a59.16,59.16,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.1a74.24,74.24,0,0,1-7.55-2.52c-1.15-.45-2.28-.94-3.38-1.45s-2.34-1.13-3.43-1.74c-5.78-3.16-10-6.89-12.54-10.85a18.94,18.94,0,0,1-2.69-6.36,19.57,19.57,0,0,1,3.87-8.11,34.43,34.43,0,0,1,9.22-7.93c.64-.4,1.31-.78,2-1.16l.53-.28C183.52,314.56,214.82,313.5,236.79,322.66Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.79,322.66c.77.32,1.53.66,2.27,1a45.51,45.51,0,0,1,11.25,7.18c4.07,3.65,6.54,7.68,7.4,11.8a17.21,17.21,0,0,1-.66,2.38c-1.48,4.12-4.63,8.1-9.49,11.67l-.61.44c-.73.52-1.51,1-2.32,1.53s-1.94,1.15-3,1.68a59.16,59.16,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.1a74.24,74.24,0,0,1-7.55-2.52c-1.15-.45-2.28-.94-3.38-1.45s-2.34-1.13-3.43-1.74c-5.78-3.16-10-6.89-12.54-10.85a18.94,18.94,0,0,1-2.69-6.36,19.57,19.57,0,0,1,3.87-8.11,34.43,34.43,0,0,1,9.22-7.93c.64-.4,1.31-.78,2-1.16l.53-.28C183.52,314.56,214.82,313.5,236.79,322.66Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.74,347.74c-8.74,19.43-33.19,27.18-53.12,30.68-30.3,4.35-63.28.71-86.71-16.54l.05,0c-6.37-5-11.8-11.74-12.94-19.88,1,8.23,6.24,15.18,12.61,20.33l0,0c18.87,14.63,45,19.37,70,18.67C233.78,379.53,267.31,372.75,278.74,347.74Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.29,353.68c8.56,3.58,17,2,24.77-.74L194,355.06V364a37.08,37.08,0,0,0,5.29.86,38.06,38.06,0,0,0,9.21-.35,49.21,49.21,0,0,0,14.35-4.72l7.54,3.17,10.18-6.27v-8.89l-1.91-.81-.42-.18a8.08,8.08,0,0,0,.21-2.07,5.22,5.22,0,0,0-.06-.71c-.13-1.09.1-6.11.06-8.18,0-.25,0-.48-.07-.7-.29-2.49-2.36-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.8l-1.14.15h-.13l-1.2.19c-.35.06-.7.12-1.05.21-.14,0-.29.05-.42.09s-.55.1-.8.17a62.61,62.61,0,0,0-6.49,1.91c-.93.33-1.86.68-2.78,1l2.69-2.8V318.9c-8.67-1.65-17.92-.25-27,4.2L172.45,320l-10.07,6.43v8.89l2.36,1a5.51,5.51,0,0,0-.22,1.68V338c.08,1.38-.06,7.26,0,8.82v.07C164.68,349.5,166.83,351.81,171.29,353.68Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.46,336.21c0,2.28-.17,6.75-.05,7.77,0,.24,0,.46.06.7a8.33,8.33,0,0,1-.22,2.09l-5.42-2.28S238.3,341.85,238.46,336.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.73,336.07c-2.26-.94-2.64-2.71,1.52-5.39,4.46-2.82,9.05-3.56,12.95-2.58l8.82-9.19v8.87l-2.67,2.81-.27.1c-1.45.56-2.85,1.13-4.19,1.68-.54.24-1.07.47-1.59.67a55.34,55.34,0,0,1-8.89,3.27,10,10,0,0,1-3.86.26A7.16,7.16,0,0,1,183.73,336.07Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.73,336.24l-2.34-1v-8.87l7.51,3.15C167.11,331.85,165.32,334.11,164.73,336.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.39,354l10.19-6.26v8.88l-10.2,6.29-7.52-3.18a48.78,48.78,0,0,1-14.36,4.71A36.47,36.47,0,0,1,194,364v-8.89a36.15,36.15,0,0,0,14.5.51,48.79,48.79,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.87,359.74a37.16,37.16,0,0,1-11.44,4.68,30.51,30.51,0,0,1-12.13.39,57.88,57.88,0,0,0,12-1.39c2-.43,3.9-1,5.84-1.61S220.94,360.47,222.87,359.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.53,346.88v-.05c-.06-1.57.07-7.44,0-8.84.15,2.63,2.28,4.94,6.74,6.81,9.94,4.14,19.61,1.41,28.46-2.13,8.21-3.33,14.18-6.86,19-4.86,3,1.26,2.15,3.26-1.13,5.36a18.14,18.14,0,0,1-14.2,2.23L196.07,353h0c-7.84,2.77-16.22,4.3-24.76.72C166.82,351.82,164.69,349.5,164.53,346.88Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.21 336.99 198.2 328.1 207.01 318.9 207.02 327.79 198.21 336.99",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.21 336.99 198.2 328.1 207.01 318.9 207.02 327.79 198.21 336.99",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.38 326.38 169.92 329.52 164.75 336.25 162.39 335.27 162.38 326.38",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.38 326.38 169.92 329.52 164.75 336.25 162.39 335.27 162.38 326.38",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.67,346.93l-5.83-2.45s5.73-2.77,5.62-8.68c0-.25,0-.48-.07-.7-.29-2.49-2.36-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.8l-1.14.15h-.13l-1.2.19c-.35.06-.7.12-1.05.21-.14,0-.29.05-.42.09s-.55.1-.8.17a62.61,62.61,0,0,0-6.49,1.91c-1,.36-2,.74-3,1.14-1.44.57-2.86,1.15-4.2,1.7l-1.59.67a55.79,55.79,0,0,1-8.9,3.26,10,10,0,0,1-3.84.27,7.82,7.82,0,0,1-1.81-.5c-2.28-.95-2.66-2.72,1.52-5.39,4.45-2.85,9-3.58,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2L172.45,320l-10.07,6.43,7.54,3.14c-3.59,3-5.49,5.84-5.39,8.41V338c.15,2.61,2.29,4.93,6.76,6.79,9.91,4.16,19.59,1.43,28.43-2.13,8.22-3.33,14.19-6.85,19-4.84,3,1.26,2.13,3.25-1.16,5.35a18.19,18.19,0,0,1-14.19,2.24L194,355.06a37.45,37.45,0,0,0,5.3.86,38.08,38.08,0,0,0,9.21-.34,49.26,49.26,0,0,0,14.34-4.73l7.54,3.17,10.19-6.27Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.67,346.93l-5.83-2.45s5.73-2.77,5.62-8.68c0-.25,0-.48-.07-.7-.29-2.49-2.36-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.8l-1.14.15h-.13l-1.2.19c-.35.06-.7.12-1.05.21-.14,0-.29.05-.42.09s-.55.1-.8.17a62.61,62.61,0,0,0-6.49,1.91c-1,.36-2,.74-3,1.14-1.44.57-2.86,1.15-4.2,1.7l-1.59.67a55.79,55.79,0,0,1-8.9,3.26,10,10,0,0,1-3.84.27,7.82,7.82,0,0,1-1.81-.5c-2.28-.95-2.66-2.72,1.52-5.39,4.45-2.85,9-3.58,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2L172.45,320l-10.07,6.43,7.54,3.14c-3.59,3-5.49,5.84-5.39,8.41V338c.15,2.61,2.29,4.93,6.76,6.79,9.91,4.16,19.59,1.43,28.43-2.13,8.22-3.33,14.19-6.85,19-4.84,3,1.26,2.13,3.25-1.16,5.35a18.19,18.19,0,0,1-14.19,2.24L194,355.06a37.45,37.45,0,0,0,5.3.86,38.08,38.08,0,0,0,9.21-.34,49.26,49.26,0,0,0,14.34-4.73l7.54,3.17,10.19-6.27Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.29,344.79a28.41,28.41,0,0,0,11.8,1.84,43.44,43.44,0,0,0,12-2.55c4-1.3,7.74-3,11.61-4.63a40,40,0,0,1,6-2,9.88,9.88,0,0,1,6,.35,9.91,9.91,0,0,0-6-.09,41.33,41.33,0,0,0-5.85,2.12c-3.82,1.66-7.63,3.4-11.6,4.76a42.34,42.34,0,0,1-12.23,2.45,28.27,28.27,0,0,1-6.11-.46A28.62,28.62,0,0,1,171.29,344.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.39 354.02 230.4 362.91 222.86 359.74 222.85 350.85 230.39 354.02",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.39 354.02 230.4 362.91 222.86 359.74 222.85 350.85 230.39 354.02",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.58 347.75 230.43 353.02 222.85 350.85 230.39 354.02 240.58 347.75",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.99 323.1 172.49 320.88 162.38 326.38 172.45 319.95 179.99 323.1",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,318.9a37.45,37.45,0,0,0-4.73-.56l1.23,4.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.63,344.92a27.57,27.57,0,0,0,13,1.83L177.35,322l-4.9-2.05-6.87,4.39,1.14,3.85,3.2,1.33a26.31,26.31,0,0,0-2.21,2.05Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.29,328a26,26,0,0,0-7.49-1.37l8,27.12,6-3.69-1.33-4.52-2.6-1.1a11,11,0,0,0,1.9-1.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07,327l-1.2.19c-.35.06-.7.12-1.05.21-.14,0-.29.05-.42.09s-.55.1-.8.17a62.61,62.61,0,0,0-6.49,1.91l-1.39.53,2.63,9c4.05-1.6,7.43-2.44,10.38-1.21s2.13,3.25-1.15,5.35a17.71,17.71,0,0,1-7.25,2.62l2.6,8.84a52,52,0,0,0,9.92-3.78l2.84,1.2-7.4-25.23-1.09.14Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.69,318.15l8.47,0v17.33h0a23.25,23.25,0,0,1-.83,6.16c-.2.7-.44,1.4-.7,2.1a30.6,30.6,0,0,1-5.91,9.46,42.34,42.34,0,0,1-3,3,45.44,45.44,0,0,1-3.5,2.92,58.9,58.9,0,0,1-5.1,3.47c-1.92,1.17-3.92,2.26-6,3.29-1.58.77-3.2,1.5-4.88,2.19-24.52,10.13-58.33,11.36-85.31,3.14q-2.76-.84-5.4-1.81c-2.53-.92-5-1.94-7.35-3.05q-2.91-1.36-5.5-2.83c-1.49-.86-2.91-1.73-4.24-2.64s-2.59-1.82-3.76-2.76h0a40.66,40.66,0,0,1-8.38-8.93c-.45-.67-.88-1.35-1.26-2a24.91,24.91,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0l0-16.39,7.75,0c.62-.68,1.27-1.35,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,89.34,89.34,0,0,1,9.43-3.85c22.18-7.67,50.42-8.7,74.42-2.74a106.86,106.86,0,0,1,10.37,3.12c2.79,1,5.49,2.1,8.08,3.31a71.33,71.33,0,0,1,10.64,6.08A49.44,49.44,0,0,1,261.69,318.15Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.53,374.94l0-35.18,12.88,1.35,0,35.22C180.07,376.06,175.76,375.6,171.53,374.94Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.16,335.45h0a23.25,23.25,0,0,1-.83,6.16c-.2.7-.44,1.4-.7,2.1a30.6,30.6,0,0,1-5.91,9.46c-.34.37-.7.75-1.06,1.12l0-36.2.06.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.21,319.28l6.61-1.56,0,52.72c-2.11.7-4.27,1.33-6.47,1.91Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.17,375.59l0-45.7,12.88.95,0,42.55A129.86,129.86,0,0,1,210.17,375.59Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72,318.72l7.75,0c.62-.68,1.27-1.35,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,89.34,89.34,0,0,1,9.43-3.85q4.66-1.61,9.65-2.81l.06,73.39c-1.91-.47-3.8-1-5.65-1.55s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.94-7.35-3.05q-2.91-1.36-5.5-2.83c-1.49-.86-2.91-1.73-4.24-2.64s-2.59-1.82-3.76-2.76h0a40.66,40.66,0,0,1-8.38-8.93c-.45-.67-.88-1.35-1.26-2a24.91,24.91,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.28,349.17c-.45-.67-.88-1.35-1.26-2a24.91,24.91,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0l0-16.39,7.75,0,.1-.1,2.61,1,0,36.45A38.1,38.1,0,0,1,120.28,349.17Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.72,287.31c-2.59-1.21-5.29-2.32-8.08-3.31a107.71,107.71,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.19,34.19,0,0,0-6.87,8.93A23.13,23.13,0,0,0,115.9,321a25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40.28,40.28,0,0,0,8.39,8.93h0q1.77,1.43,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.1,4.82,2.12,7.35,3q2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.53,6-3.29t5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a38.34,38.34,0,0,0,3-3,30.71,30.71,0,0,0,5.92-9.46q.39-1.05.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.28,46.28,0,0,0-9.22-8.34A70.71,70.71,0,0,0,243.72,287.31Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.72,287.31c-2.59-1.21-5.29-2.32-8.08-3.31a107.71,107.71,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.19,34.19,0,0,0-6.87,8.93A23.13,23.13,0,0,0,115.9,321a25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40.28,40.28,0,0,0,8.39,8.93h0q1.77,1.43,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.1,4.82,2.12,7.35,3q2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.53,6-3.29t5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a38.34,38.34,0,0,0,3-3,30.71,30.71,0,0,0,5.92-9.46q.39-1.05.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.28,46.28,0,0,0-9.22-8.34A70.71,70.71,0,0,0,243.72,287.31Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.72,287.31c-2.59-1.21-5.29-2.32-8.08-3.31a107.71,107.71,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.19,34.19,0,0,0-6.87,8.93A23.13,23.13,0,0,0,115.9,321a25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40.28,40.28,0,0,0,8.39,8.93h0q1.77,1.43,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.1,4.82,2.12,7.35,3q2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.53,6-3.29t5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a38.34,38.34,0,0,0,3-3,30.71,30.71,0,0,0,5.92-9.46q.39-1.05.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.28,46.28,0,0,0-9.22-8.34A70.71,70.71,0,0,0,243.72,287.31Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.59,355.74c-1.92-.48-3.82-1-5.68-1.57s-3.64-1.16-5.41-1.81c-2.53-.92-5-1.94-7.35-3-1.93-.91-3.77-1.86-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.77h0a40.28,40.28,0,0,1-8.39-8.93c-.45-.67-.87-1.35-1.25-2A24.91,24.91,0,0,1,115.9,321a23.13,23.13,0,0,1,2.65-13.93,34.19,34.19,0,0,1,6.87-8.93,54.74,54.74,0,0,1,9.33-7.07c1.88-1.15,3.86-2.21,5.91-3.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.1,338.88a37.82,37.82,0,0,1-5.84-6.73c-.45-.67-.87-1.35-1.25-2A24.91,24.91,0,0,1,115.9,321a22.66,22.66,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.37,359.32c-4.34-.27-8.64-.73-12.86-1.39L149.8,284l1-.38a107.42,107.42,0,0,1,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,356.38a127,127,0,0,1-12.87,2.19L186.26,277.2c4.49-.2,9-.19,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,353.41c-2.13.7-4.3,1.35-6.52,1.93l-22.84-77.8c2.45.2,4.89.45,7.31.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.54,289.24h0c1,.54,2,1.1,2.93,1.66l.94.56.94.6c.68.44,1.36.88,2,1.33a46.48,46.48,0,0,1,9.21,8.34,27.47,27.47,0,0,1,6.37,13.6,22.37,22.37,0,0,1-.63,9.26q-.3,1.05-.69,2.1a30.71,30.71,0,0,1-5.92,9.46c-.33.38-.69.75-1.06,1.13Z",
    style: {
      fill: "#1976D2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.58,295.12c-23.05-10.7-57.41-9.9-78.54,1.48-.89.49-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.84-.53,1.66-1.07,2.42-1.61C257,324.13,253.64,305.82,230.58,295.12Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.58,295.12c-23.05-10.7-57.41-9.9-78.54,1.48-.89.49-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.84-.53,1.66-1.07,2.42-1.61C257,324.13,253.64,305.82,230.58,295.12Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.91,296.15c-.74-.34-1.5-.67-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.52.29c-.68.37-1.34.75-2,1.15a34.4,34.4,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.94,2.57,4,6.76,7.68,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a71.05,71.05,0,0,0,7.55,2.51c18.18,5,40.22,4.21,56.88-2.09a60.94,60.94,0,0,0,6.79-3c1-.54,2-1.1,3-1.69s1.59-1,2.32-1.52l.61-.45c4.86-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.39-6.76-20.64A45.49,45.49,0,0,0,228.91,296.15Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.91,296.15c-.74-.34-1.5-.67-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.52.29c-.68.37-1.34.75-2,1.15a34.4,34.4,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.94,2.57,4,6.76,7.68,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a71.05,71.05,0,0,0,7.55,2.51c18.18,5,40.22,4.21,56.88-2.09a60.94,60.94,0,0,0,6.79-3c1-.54,2-1.1,3-1.69s1.59-1,2.32-1.52l.61-.45c4.86-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.39-6.76-20.64A45.49,45.49,0,0,0,228.91,296.15Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.66,301.62c.78.32,1.53.65,2.27,1a45.12,45.12,0,0,1,11.26,7.19c4.07,3.64,6.54,7.68,7.4,11.79a17.34,17.34,0,0,1-.66,2.39c-1.48,4.11-4.63,8.1-9.49,11.66l-.61.45c-.73.51-1.51,1-2.32,1.52s-1.94,1.15-3,1.69a60.94,60.94,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.09a71.05,71.05,0,0,1-7.55-2.51c-1.15-.46-2.28-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.78-3.17-10-6.89-12.54-10.85a19,19,0,0,1-2.69-6.37,19.54,19.54,0,0,1,3.87-8.1,34.45,34.45,0,0,1,9.22-7.94c.64-.4,1.3-.78,2-1.15l.53-.29C173.4,293.52,204.7,292.45,226.66,301.62Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.66,301.62c.78.32,1.53.65,2.27,1a45.12,45.12,0,0,1,11.26,7.19c4.07,3.64,6.54,7.68,7.4,11.79a17.34,17.34,0,0,1-.66,2.39c-1.48,4.11-4.63,8.1-9.49,11.66l-.61.45c-.73.51-1.51,1-2.32,1.52s-1.94,1.15-3,1.69a60.94,60.94,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.09a71.05,71.05,0,0,1-7.55-2.51c-1.15-.46-2.28-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.78-3.17-10-6.89-12.54-10.85a19,19,0,0,1-2.69-6.37,19.54,19.54,0,0,1,3.87-8.1,34.45,34.45,0,0,1,9.22-7.94c.64-.4,1.3-.78,2-1.15l.53-.29C173.4,293.52,204.7,292.45,226.66,301.62Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.62,326.69c-8.74,19.44-33.19,27.19-53.12,30.69-30.3,4.35-63.28.7-86.71-16.54l.05,0c-6.37-5-11.8-11.73-12.94-19.87,1,8.22,6.24,15.18,12.61,20.32l0,0c18.87,14.62,45,19.36,70,18.66C223.66,358.48,257.19,351.71,268.62,326.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.17,332.63c8.56,3.59,17,2,24.77-.73L183.88,334v8.89a37.08,37.08,0,0,0,5.29.86,38.08,38.08,0,0,0,9.21-.34,49.22,49.22,0,0,0,14.35-4.73l7.54,3.17,10.18-6.27v-8.88l-1.91-.82-.42-.17a8.2,8.2,0,0,0,.21-2.08,5.07,5.07,0,0,0-.06-.7c-.13-1.1.1-6.11.06-8.19,0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.58-6.47v0a27.27,27.27,0,0,0-13.47-1.79l-1.15.14-.12,0-1.2.19c-.35.06-.7.12-1.05.2-.14,0-.29.05-.42.09a6.66,6.66,0,0,0-.8.18A60.25,60.25,0,0,0,197,308.5c-.94.33-1.87.68-2.78,1l2.69-2.8v-8.89c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.43v8.88l2.36,1a5.18,5.18,0,0,0-.22,1.68V317c.07,1.37-.06,7.25,0,8.81v.07C154.56,328.46,156.71,330.77,161.17,332.63Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.33,315.17c0,2.27-.16,6.74-.05,7.76,0,.24.05.47.07.71a8.25,8.25,0,0,1-.22,2.08l-5.42-2.28S228.18,320.8,228.33,315.17Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.61,315c-2.26-.95-2.64-2.71,1.52-5.39,4.46-2.83,9.05-3.56,13-2.59l8.82-9.19,0,8.88-2.66,2.8c-.1,0-.17.08-.27.11-1.45.55-2.85,1.12-4.19,1.68q-.81.36-1.59.66a55,55,0,0,1-8.9,3.27,10,10,0,0,1-3.85.27A7.16,7.16,0,0,1,173.61,315Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.61,315.19l-2.34-1v-8.88l7.51,3.15C157,310.8,155.2,313.07,154.61,315.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.27,333l10.19-6.26v8.89l-10.2,6.28-7.52-3.18a48.79,48.79,0,0,1-14.36,4.72,36.15,36.15,0,0,1-14.5-.51V334a36.47,36.47,0,0,0,14.5.5,48.5,48.5,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.75,338.69a37.16,37.16,0,0,1-11.44,4.68,30.33,30.33,0,0,1-12.13.4,58.41,58.41,0,0,0,11.95-1.4c2-.43,3.91-1,5.85-1.6S210.82,339.42,212.75,338.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.41,325.83v-.05c-.07-1.56.07-7.44,0-8.83.16,2.62,2.29,4.94,6.75,6.8,9.94,4.14,19.61,1.42,28.46-2.13,8.21-3.32,14.18-6.86,19-4.86,3,1.27,2.15,3.27-1.13,5.36a18.15,18.15,0,0,1-14.2,2.24L186,331.9h0c-7.84,2.77-16.22,4.3-24.76.73C156.69,330.77,154.57,328.46,154.41,325.83Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.08 315.94 188.08 307.05 196.89 297.86 196.9 306.74 188.08 315.94",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.08 315.94 188.08 307.05 196.89 297.86 196.9 306.74 188.08 315.94",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.26 305.34 159.8 308.48 154.63 315.21 152.27 314.22 152.26 305.34",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.26 305.34 159.8 308.48 154.63 315.21 152.27 314.22 152.26 305.34",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.55,325.89l-5.83-2.45s5.73-2.78,5.62-8.69c0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.58-6.47v0a27.27,27.27,0,0,0-13.47-1.79l-1.15.14-.12,0-1.2.19c-.35.06-.7.12-1.05.2-.15,0-.29.05-.42.09a6.66,6.66,0,0,0-.8.18A60.25,60.25,0,0,0,197,308.5c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.7l-1.59.67a57.86,57.86,0,0,1-8.9,3.26,10.18,10.18,0,0,1-3.85.26,8.08,8.08,0,0,1-1.81-.49c-2.27-1-2.65-2.72,1.53-5.4,4.45-2.84,9-3.57,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.43,7.54,3.14c-3.6,3-5.49,5.83-5.39,8.41V317c.15,2.62,2.29,4.93,6.76,6.8,9.91,4.15,19.59,1.42,28.43-2.13,8.22-3.33,14.19-6.86,19-4.85,3,1.27,2.14,3.25-1.15,5.36a18.19,18.19,0,0,1-14.19,2.24L183.88,334a35.9,35.9,0,0,0,5.3.87,38.08,38.08,0,0,0,9.21-.35,49.25,49.25,0,0,0,14.34-4.72l7.54,3.16,10.19-6.26Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.55,325.89l-5.83-2.45s5.73-2.78,5.62-8.69c0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.58-6.47v0a27.27,27.27,0,0,0-13.47-1.79l-1.15.14-.12,0-1.2.19c-.35.06-.7.12-1.05.2-.15,0-.29.05-.42.09a6.66,6.66,0,0,0-.8.18A60.25,60.25,0,0,0,197,308.5c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.7l-1.59.67a57.86,57.86,0,0,1-8.9,3.26,10.18,10.18,0,0,1-3.85.26,8.08,8.08,0,0,1-1.81-.49c-2.27-1-2.65-2.72,1.53-5.4,4.45-2.84,9-3.57,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.43,7.54,3.14c-3.6,3-5.49,5.83-5.39,8.41V317c.15,2.62,2.29,4.93,6.76,6.8,9.91,4.15,19.59,1.42,28.43-2.13,8.22-3.33,14.19-6.86,19-4.85,3,1.27,2.14,3.25-1.15,5.36a18.19,18.19,0,0,1-14.19,2.24L183.88,334a35.9,35.9,0,0,0,5.3.87,38.08,38.08,0,0,0,9.21-.35,49.25,49.25,0,0,0,14.34-4.72l7.54,3.16,10.19-6.26Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.17,323.75a28.41,28.41,0,0,0,11.8,1.83A43.09,43.09,0,0,0,185,323c4-1.3,7.74-3,11.61-4.62a39,39,0,0,1,6-2,9.84,9.84,0,0,1,6,.35,9.8,9.8,0,0,0-6-.08,40.08,40.08,0,0,0-5.85,2.11c-3.82,1.67-7.63,3.41-11.6,4.76A42.35,42.35,0,0,1,173,326a28.91,28.91,0,0,1-6.11-.46A29.29,29.29,0,0,1,161.17,323.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.27 332.98 220.28 341.86 212.74 338.69 212.73 329.81 220.27 332.98",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.27 332.98 220.28 341.86 212.74 338.69 212.73 329.81 220.27 332.98",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.46 326.71 220.31 331.98 212.73 329.81 220.27 332.98 230.46 326.71",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.87 302.05 162.37 299.83 152.26 305.34 162.32 298.91 169.87 302.05",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.89,297.86a37.46,37.46,0,0,0-4.73-.57l1.23,4.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.51,323.88a27.56,27.56,0,0,0,13,1.82L167.23,301l-4.9-2-6.87,4.38,1.14,3.85,3.2,1.34a28.06,28.06,0,0,0-2.21,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.17,307a26,26,0,0,0-7.49-1.36l8,27.11,6-3.69-1.33-4.52-2.6-1.09a10.71,10.71,0,0,0,1.9-1.28Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,305.93l-1.2.19c-.35.06-.7.12-1.05.2-.14,0-.29.05-.42.09a6.66,6.66,0,0,0-.8.18A60.25,60.25,0,0,0,197,308.5c-.47.16-.93.35-1.39.52l2.63,9c4.05-1.6,7.43-2.45,10.37-1.22s2.14,3.25-1.15,5.36a17.59,17.59,0,0,1-7.24,2.61l2.6,8.84a51.31,51.31,0,0,0,9.92-3.77l2.84,1.19-7.4-25.22c-.36,0-.74.1-1.1.13Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.13,297.11l8.47,0v17.34h0a23.18,23.18,0,0,1-.83,6.15c-.2.71-.44,1.41-.7,2.11a30.56,30.56,0,0,1-5.91,9.45,40.34,40.34,0,0,1-3,3,43.27,43.27,0,0,1-3.5,2.92,56.72,56.72,0,0,1-5.1,3.47c-1.92,1.17-3.92,2.27-6,3.29-1.58.78-3.2,1.51-4.88,2.19-24.52,10.14-58.33,11.37-85.31,3.14-1.84-.55-3.64-1.16-5.4-1.81-2.53-.92-5-1.93-7.35-3-1.94-.91-3.77-1.85-5.5-2.84-1.49-.85-2.91-1.73-4.24-2.63s-2.59-1.82-3.76-2.77h0a40.4,40.4,0,0,1-8.38-8.92c-.45-.68-.88-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0l0-16.39,7.75,0c.62-.67,1.27-1.34,2-2a54.76,54.76,0,0,1,9.33-7.08,74.22,74.22,0,0,1,6.67-3.6,89.3,89.3,0,0,1,9.43-3.84c22.18-7.67,50.42-8.7,74.42-2.74a106.84,106.84,0,0,1,10.37,3.11c2.79,1,5.49,2.1,8.08,3.32a71.33,71.33,0,0,1,10.64,6.08A48.76,48.76,0,0,1,265.13,297.11Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,353.9l0-35.18,12.88,1.35,0,35.21C183.51,355,179.2,354.56,175,353.9Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6,314.41h0a23.18,23.18,0,0,1-.83,6.15c-.2.71-.44,1.41-.7,2.11a30.56,30.56,0,0,1-5.91,9.45c-.34.38-.7.75-1.06,1.12l0-36.19.06.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.65,298.24l6.61-1.56,0,52.71q-3.16,1-6.47,1.92Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.61,354.54l0-45.69,12.88.95,0,42.55A129.86,129.86,0,0,1,213.61,354.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,297.67l7.75,0c.62-.67,1.27-1.34,2-2a54.76,54.76,0,0,1,9.33-7.08,74.22,74.22,0,0,1,6.67-3.6,89.3,89.3,0,0,1,9.43-3.84c3.11-1.08,6.33-2,9.64-2.82l.07,73.4c-1.91-.48-3.8-1-5.65-1.56s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.93-7.35-3-1.94-.91-3.77-1.85-5.5-2.84-1.49-.85-2.91-1.73-4.24-2.63s-2.59-1.82-3.76-2.77h0a40.4,40.4,0,0,1-8.38-8.92c-.45-.68-.88-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.72,328.13c-.45-.68-.88-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0l0-16.39,7.75,0,.1-.1,2.61.95,0,36.46A38.45,38.45,0,0,1,123.72,328.13Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.16,266.26c-2.59-1.21-5.29-2.31-8.08-3.31a107.69,107.69,0,0,0-10.37-3.11c-24-6-52.24-4.93-74.42,2.73a90.62,90.62,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07A34.35,34.35,0,0,0,122,286,23.13,23.13,0,0,0,119.34,300a25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.36,1.26,2a40.23,40.23,0,0,0,8.39,8.92h0q1.77,1.41,3.76,2.76c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.1-1,4.11-2.12,6-3.29a60.27,60.27,0,0,0,5.09-3.47c1.26-1,2.43-1.93,3.51-2.92a40.23,40.23,0,0,0,3-3,30.67,30.67,0,0,0,5.92-9.45c.26-.7.49-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26A27.44,27.44,0,0,0,267,280.69a46.28,46.28,0,0,0-9.22-8.34A70.72,70.72,0,0,0,247.16,266.26Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.16,266.26c-2.59-1.21-5.29-2.31-8.08-3.31a107.69,107.69,0,0,0-10.37-3.11c-24-6-52.24-4.93-74.42,2.73a90.62,90.62,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07A34.35,34.35,0,0,0,122,286,23.13,23.13,0,0,0,119.34,300a25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.36,1.26,2a40.23,40.23,0,0,0,8.39,8.92h0q1.77,1.41,3.76,2.76c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.1-1,4.11-2.12,6-3.29a60.27,60.27,0,0,0,5.09-3.47c1.26-1,2.43-1.93,3.51-2.92a40.23,40.23,0,0,0,3-3,30.67,30.67,0,0,0,5.92-9.45c.26-.7.49-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26A27.44,27.44,0,0,0,267,280.69a46.28,46.28,0,0,0-9.22-8.34A70.72,70.72,0,0,0,247.16,266.26Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.16,266.26c-2.59-1.21-5.29-2.31-8.08-3.31a107.69,107.69,0,0,0-10.37-3.11c-24-6-52.24-4.93-74.42,2.73a90.62,90.62,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07A34.35,34.35,0,0,0,122,286,23.13,23.13,0,0,0,119.34,300a25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.36,1.26,2a40.23,40.23,0,0,0,8.39,8.92h0q1.77,1.41,3.76,2.76c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.1-1,4.11-2.12,6-3.29a60.27,60.27,0,0,0,5.09-3.47c1.26-1,2.43-1.93,3.51-2.92a40.23,40.23,0,0,0,3-3,30.67,30.67,0,0,0,5.92-9.45c.26-.7.49-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26A27.44,27.44,0,0,0,267,280.69a46.28,46.28,0,0,0-9.22-8.34A70.72,70.72,0,0,0,247.16,266.26Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,334.69c-1.92-.48-3.82-1-5.68-1.56s-3.64-1.16-5.41-1.81c-2.53-.93-5-1.94-7.35-3.05-1.93-.91-3.77-1.85-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.76h0a40.23,40.23,0,0,1-8.39-8.92c-.45-.67-.87-1.35-1.26-2a25.06,25.06,0,0,1-3.1-9.13A23.13,23.13,0,0,1,122,286a34.35,34.35,0,0,1,6.87-8.93,54.34,54.34,0,0,1,9.33-7.07c1.88-1.14,3.86-2.21,5.91-3.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.53,317.84a38.51,38.51,0,0,1-5.83-6.73c-.45-.67-.87-1.35-1.26-2a25.06,25.06,0,0,1-3.1-9.13,22.66,22.66,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.81,338.27c-4.34-.26-8.64-.73-12.87-1.39L153.24,263l1-.38c3.34-1.15,6.83-2.14,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.46,335.34c-4.18.93-8.49,1.66-12.87,2.19L189.7,256.15c4.49-.2,9-.18,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.24,332.36c-2.13.71-4.3,1.35-6.52,1.94l-22.84-77.81c2.45.2,4.89.45,7.31.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,268.2h0c1,.54,2,1.09,2.93,1.65l.94.57.94.59c.68.44,1.36.89,2,1.34a46.28,46.28,0,0,1,9.22,8.34,27.44,27.44,0,0,1,6.37,13.59,22.36,22.36,0,0,1-.63,9.26c-.2.71-.43,1.41-.69,2.11a30.67,30.67,0,0,1-5.92,9.45c-.33.38-.69.76-1.06,1.13Z",
    style: {
      fill: "#1976D2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,274.08c-23.05-10.71-57.41-9.91-78.54,1.48-.89.48-1.78,1-2.63,1.51-20.79,12.81-18.17,32.23,5.86,43.38s60.38,9.83,81.18-3c.84-.52,1.66-1.06,2.42-1.6C260.44,303.09,257.08,284.78,234,274.08Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,274.08c-23.05-10.71-57.41-9.91-78.54,1.48-.89.48-1.78,1-2.63,1.51-20.79,12.81-18.17,32.23,5.86,43.38s60.38,9.83,81.18-3c.84-.52,1.66-1.06,2.42-1.6C260.44,303.09,257.08,284.78,234,274.08Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.35,275.11c-.74-.35-1.5-.68-2.27-1-22-9.16-53.27-8.1-72.78,2.42l-.53.28c-.67.37-1.34.76-2,1.16a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.93,2.57,4,6.76,7.69,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a73.42,73.42,0,0,0,7.55,2.52c18.18,5,40.22,4.2,56.88-2.1a59.16,59.16,0,0,0,6.79-3c1-.53,2-1.09,3-1.68s1.59-1,2.32-1.53l.61-.44c4.86-3.57,8-7.55,9.49-11.67,2.52-7,.2-14.39-6.76-20.64A45.77,45.77,0,0,0,232.35,275.11Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.35,275.11c-.74-.35-1.5-.68-2.27-1-22-9.16-53.27-8.1-72.78,2.42l-.53.28c-.67.37-1.34.76-2,1.16a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.93,2.57,4,6.76,7.69,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a73.42,73.42,0,0,0,7.55,2.52c18.18,5,40.22,4.2,56.88-2.1a59.16,59.16,0,0,0,6.79-3c1-.53,2-1.09,3-1.68s1.59-1,2.32-1.53l.61-.44c4.86-3.57,8-7.55,9.49-11.67,2.52-7,.2-14.39-6.76-20.64A45.77,45.77,0,0,0,232.35,275.11Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.1,280.57c.78.32,1.53.66,2.27,1a45.39,45.39,0,0,1,11.26,7.18c4.07,3.65,6.54,7.68,7.4,11.8a17.21,17.21,0,0,1-.66,2.38c-1.48,4.12-4.63,8.1-9.49,11.67l-.61.44c-.73.52-1.51,1-2.32,1.53s-1.94,1.15-3,1.68a59.16,59.16,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.1a73.42,73.42,0,0,1-7.55-2.52c-1.15-.45-2.28-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.78-3.16-10-6.89-12.54-10.85a18.94,18.94,0,0,1-2.69-6.36,19.57,19.57,0,0,1,3.87-8.11,34.43,34.43,0,0,1,9.22-7.93c.64-.4,1.3-.78,2-1.16l.53-.28C176.84,272.47,208.14,271.41,230.1,280.57Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.1,280.57c.78.32,1.53.66,2.27,1a45.39,45.39,0,0,1,11.26,7.18c4.07,3.65,6.54,7.68,7.4,11.8a17.21,17.21,0,0,1-.66,2.38c-1.48,4.12-4.63,8.1-9.49,11.67l-.61.44c-.73.52-1.51,1-2.32,1.53s-1.94,1.15-3,1.68a59.16,59.16,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.1a73.42,73.42,0,0,1-7.55-2.52c-1.15-.45-2.28-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.78-3.16-10-6.89-12.54-10.85a18.94,18.94,0,0,1-2.69-6.36,19.57,19.57,0,0,1,3.87-8.11,34.43,34.43,0,0,1,9.22-7.93c.64-.4,1.3-.78,2-1.16l.53-.28C176.84,272.47,208.14,271.41,230.1,280.57Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.06,305.65c-8.74,19.43-33.19,27.18-53.12,30.68-30.3,4.35-63.28.71-86.71-16.54l.05,0c-6.37-5-11.8-11.74-12.94-19.88,1,8.23,6.24,15.18,12.61,20.33l0,0c18.87,14.63,45,19.37,70,18.66C227.1,337.44,260.63,330.66,272.06,305.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.61,311.59c8.56,3.58,16.95,2,24.77-.74L187.32,313v8.89a37.08,37.08,0,0,0,5.29.86,38.08,38.08,0,0,0,9.21-.35,49,49,0,0,0,14.34-4.72l7.55,3.17,10.18-6.27v-8.89l-1.92-.81-.41-.18a8.08,8.08,0,0,0,.21-2.07,5.22,5.22,0,0,0-.06-.71c-.13-1.09.09-6.11.06-8.18,0-.25,0-.48-.07-.7-.3-2.49-2.36-4.72-6.58-6.47v0a27.18,27.18,0,0,0-13.47-1.8l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.21-.15,0-.29.05-.42.09s-.55.1-.8.17a62.61,62.61,0,0,0-6.49,1.91c-.94.33-1.87.68-2.78,1.05l2.69-2.8v-8.89c-8.67-1.65-17.92-.25-27,4.2l-7.55-3.15-10.06,6.43v8.89l2.36,1a5.22,5.22,0,0,0-.22,1.68v.07c.07,1.38-.06,7.26,0,8.82v.07C158,307.41,160.15,309.72,164.61,311.59Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.77,294.12c0,2.28-.16,6.75-.05,7.77,0,.24.05.46.07.7a8.33,8.33,0,0,1-.22,2.09l-5.42-2.28S231.62,299.76,231.77,294.12Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.05,294c-2.26-.94-2.64-2.71,1.52-5.39,4.46-2.82,9.05-3.56,13-2.58l8.82-9.19,0,8.87-2.66,2.81-.27.1c-1.45.56-2.85,1.13-4.19,1.68-.54.24-1.07.47-1.59.67a55,55,0,0,1-8.9,3.27,10,10,0,0,1-3.85.26A7.16,7.16,0,0,1,177.05,294Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.05,294.15l-2.35-1,0-8.87,7.51,3.15C160.43,289.76,158.64,292,158.05,294.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.71,311.92l10.19-6.26v8.88l-10.2,6.29-7.52-3.18a48.78,48.78,0,0,1-14.36,4.71,36.47,36.47,0,0,1-14.5-.5V313a36.15,36.15,0,0,0,14.5.51,48.79,48.79,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.19,317.65a37.16,37.16,0,0,1-11.44,4.68,30.51,30.51,0,0,1-12.13.39,57.79,57.79,0,0,0,11.95-1.39c2-.43,3.91-1,5.85-1.61S214.26,318.38,216.19,317.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.85,304.79v-.05c-.07-1.57.07-7.44,0-8.84.16,2.63,2.29,4.94,6.75,6.81,9.94,4.14,19.61,1.41,28.46-2.13,8.21-3.33,14.18-6.86,19-4.86,3,1.26,2.15,3.26-1.13,5.36a18.14,18.14,0,0,1-14.2,2.23l-7.32,7.55h0c-7.83,2.77-16.21,4.3-24.75.72C160.13,309.73,158,307.41,157.85,304.79Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.52 294.89 191.52 286.01 200.33 276.81 200.34 285.7 191.52 294.89",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.52 294.89 191.52 286.01 200.33 276.81 200.34 285.7 191.52 294.89",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.7 284.29 163.24 287.44 158.07 294.16 155.71 293.18 155.7 284.29",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.7 284.29 163.24 287.44 158.07 294.16 155.71 293.18 155.7 284.29",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,304.84l-5.82-2.45s5.73-2.77,5.62-8.68c0-.25,0-.48-.07-.7-.3-2.49-2.36-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.8l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.21-.15,0-.29.05-.42.09s-.55.1-.8.17a62.61,62.61,0,0,0-6.49,1.91c-1,.36-2,.74-3,1.14-1.44.57-2.86,1.15-4.2,1.7l-1.59.67a55.79,55.79,0,0,1-8.9,3.26,10.2,10.2,0,0,1-3.85.27,8.1,8.1,0,0,1-1.81-.5c-2.27-.95-2.65-2.72,1.53-5.39,4.45-2.85,9-3.58,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.15-10.07,6.43,7.54,3.14c-3.6,3-5.49,5.84-5.39,8.41v.07c.14,2.61,2.29,4.93,6.76,6.79,9.91,4.16,19.59,1.43,28.43-2.13,8.22-3.33,14.19-6.85,19-4.84,3,1.26,2.14,3.25-1.15,5.35a18.19,18.19,0,0,1-14.19,2.24L187.32,313a37.22,37.22,0,0,0,5.3.86,38,38,0,0,0,9.2-.34,49.22,49.22,0,0,0,14.35-4.73l7.54,3.17,10.19-6.27Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,304.84l-5.82-2.45s5.73-2.77,5.62-8.68c0-.25,0-.48-.07-.7-.3-2.49-2.36-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.8l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.21-.15,0-.29.05-.42.09s-.55.1-.8.17a62.61,62.61,0,0,0-6.49,1.91c-1,.36-2,.74-3,1.14-1.44.57-2.86,1.15-4.2,1.7l-1.59.67a55.79,55.79,0,0,1-8.9,3.26,10.2,10.2,0,0,1-3.85.27,8.1,8.1,0,0,1-1.81-.5c-2.27-.95-2.65-2.72,1.53-5.39,4.45-2.85,9-3.58,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.15-10.07,6.43,7.54,3.14c-3.6,3-5.49,5.84-5.39,8.41v.07c.14,2.61,2.29,4.93,6.76,6.79,9.91,4.16,19.59,1.43,28.43-2.13,8.22-3.33,14.19-6.85,19-4.84,3,1.26,2.14,3.25-1.15,5.35a18.19,18.19,0,0,1-14.19,2.24L187.32,313a37.22,37.22,0,0,0,5.3.86,38,38,0,0,0,9.2-.34,49.22,49.22,0,0,0,14.35-4.73l7.54,3.17,10.19-6.27Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.61,302.7a28.41,28.41,0,0,0,11.8,1.84,43.44,43.44,0,0,0,12-2.55c4-1.3,7.74-3,11.61-4.63a40,40,0,0,1,6-2,9.84,9.84,0,0,1,6,.35,9.88,9.88,0,0,0-6-.09,41.33,41.33,0,0,0-5.85,2.12c-3.82,1.66-7.63,3.4-11.6,4.76A42.34,42.34,0,0,1,176.39,305a28.27,28.27,0,0,1-6.11-.46A28.62,28.62,0,0,1,164.61,302.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.71 311.93 223.72 320.82 216.18 317.65 216.17 308.76 223.71 311.93",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.71 311.93 223.72 320.82 216.18 317.65 216.17 308.76 223.71 311.93",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.9 305.66 223.75 310.93 216.17 308.76 223.71 311.93 233.9 305.66",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.31 281.01 165.81 278.79 155.7 284.29 165.76 277.87 173.31 281.01",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.33,276.81a37.39,37.39,0,0,0-4.74-.56l1.24,4.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,302.83a27.57,27.57,0,0,0,13,1.83l-7.27-24.75-4.9-2.05-6.87,4.39L160,286.1l3.21,1.33a24.84,24.84,0,0,0-2.21,2.05Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.61,286a26,26,0,0,0-7.49-1.37l8,27.12,6-3.69-1.33-4.52-2.6-1.1a11,11,0,0,0,1.9-1.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.39,284.88l-1.2.19c-.35.06-.7.12-1.05.21-.15,0-.29.05-.42.09s-.55.1-.8.17a62.61,62.61,0,0,0-6.49,1.91L199,288l2.63,9c4.05-1.6,7.43-2.44,10.37-1.21s2.14,3.25-1.15,5.35a17.62,17.62,0,0,1-7.24,2.62l2.6,8.84a52,52,0,0,0,9.92-3.78L219,310l-7.4-25.23-1.1.14Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.69,269l8.47,0v17.33h0a22.46,22.46,0,0,1-.83,6.16c-.2.7-.43,1.4-.7,2.1a30.45,30.45,0,0,1-5.91,9.45,38.43,38.43,0,0,1-3,3c-1.08,1-2.25,2-3.51,2.92a60.27,60.27,0,0,1-5.09,3.47c-1.92,1.17-3.93,2.26-6,3.29-1.57.77-3.2,1.5-4.87,2.19-24.53,10.13-58.34,11.36-85.31,3.14q-2.77-.84-5.41-1.81c-2.53-.93-5-1.94-7.35-3.05-1.93-.91-3.77-1.85-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.76h0a40.23,40.23,0,0,1-8.39-8.92c-.45-.67-.87-1.35-1.26-2a25.06,25.06,0,0,1-3.1-9.13,21.66,21.66,0,0,1-.18-2.91h0l0-16.39,7.76,0c.61-.67,1.26-1.34,2-2a54.44,54.44,0,0,1,9.34-7.07,71.59,71.59,0,0,1,6.67-3.6,87.63,87.63,0,0,1,9.43-3.85c22.17-7.67,50.42-8.7,74.41-2.74a105.14,105.14,0,0,1,10.38,3.12c2.78,1,5.48,2.1,8.07,3.31a71.33,71.33,0,0,1,10.64,6.08A48.35,48.35,0,0,1,281.69,269Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.53,325.8l0-35.18L204.38,292l0,35.21Q197.9,326.79,191.53,325.8Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.16,286.31h0a22.46,22.46,0,0,1-.83,6.16c-.2.7-.43,1.4-.7,2.1a30.45,30.45,0,0,1-5.91,9.45c-.33.38-.69.75-1.05,1.13l0-36.2.05.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.21,270.14l6.61-1.56,0,52.72c-2.1.69-4.26,1.33-6.46,1.91Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.17,326.45l0-45.7,12.88.95,0,42.55A129.56,129.56,0,0,1,230.17,326.45Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.72,269.57l7.76,0c.61-.67,1.26-1.34,2-2a54.44,54.44,0,0,1,9.34-7.07,71.59,71.59,0,0,1,6.67-3.6,87.63,87.63,0,0,1,9.43-3.85c3.1-1.07,6.33-2,9.64-2.81l.06,73.39q-2.87-.71-5.64-1.55t-5.41-1.81c-2.53-.93-5-1.94-7.35-3.05-1.93-.91-3.77-1.85-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.76h0a40.23,40.23,0,0,1-8.39-8.92c-.45-.67-.87-1.35-1.26-2a25.06,25.06,0,0,1-3.1-9.13,21.66,21.66,0,0,1-.18-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.28,300c-.45-.67-.87-1.35-1.26-2a25.06,25.06,0,0,1-3.1-9.13,21.66,21.66,0,0,1-.18-2.91h0l0-16.39,7.76,0,.09-.1,2.61.95,0,36.46A38.1,38.1,0,0,1,140.28,300Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.72,238.17c-2.59-1.21-5.29-2.32-8.07-3.31a105.14,105.14,0,0,0-10.38-3.12c-24-6-52.24-4.93-74.41,2.74a90.76,90.76,0,0,0-9.44,3.84,75.26,75.26,0,0,0-6.66,3.61,54.44,54.44,0,0,0-9.34,7.07,34.46,34.46,0,0,0-6.87,8.93,23.25,23.25,0,0,0-2.65,13.93A24.91,24.91,0,0,0,139,281c.38.68.81,1.36,1.25,2a40.5,40.5,0,0,0,8.39,8.93h0c1.17.94,2.42,1.87,3.75,2.77s2.75,1.77,4.25,2.63c1.73,1,3.56,1.93,5.5,2.83,2.36,1.11,4.82,2.13,7.35,3.05q2.64,1,5.4,1.81c27,8.22,60.79,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a58.9,58.9,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,40.34,40.34,0,0,0,3-3,30.49,30.49,0,0,0,5.91-9.46c.26-.7.5-1.4.7-2.1a22.55,22.55,0,0,0,.62-9.26,27.38,27.38,0,0,0-6.37-13.6,45.93,45.93,0,0,0-9.21-8.34A71.33,71.33,0,0,0,263.72,238.17Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.72,238.17c-2.59-1.21-5.29-2.32-8.07-3.31a105.14,105.14,0,0,0-10.38-3.12c-24-6-52.24-4.93-74.41,2.74a90.76,90.76,0,0,0-9.44,3.84,75.26,75.26,0,0,0-6.66,3.61,54.44,54.44,0,0,0-9.34,7.07,34.46,34.46,0,0,0-6.87,8.93,23.25,23.25,0,0,0-2.65,13.93A24.91,24.91,0,0,0,139,281c.38.68.81,1.36,1.25,2a40.5,40.5,0,0,0,8.39,8.93h0c1.17.94,2.42,1.87,3.75,2.77s2.75,1.77,4.25,2.63c1.73,1,3.56,1.93,5.5,2.83,2.36,1.11,4.82,2.13,7.35,3.05q2.64,1,5.4,1.81c27,8.22,60.79,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a58.9,58.9,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,40.34,40.34,0,0,0,3-3,30.49,30.49,0,0,0,5.91-9.46c.26-.7.5-1.4.7-2.1a22.55,22.55,0,0,0,.62-9.26,27.38,27.38,0,0,0-6.37-13.6,45.93,45.93,0,0,0-9.21-8.34A71.33,71.33,0,0,0,263.72,238.17Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.72,238.17c-2.59-1.21-5.29-2.32-8.07-3.31a105.14,105.14,0,0,0-10.38-3.12c-24-6-52.24-4.93-74.41,2.74a90.76,90.76,0,0,0-9.44,3.84,75.26,75.26,0,0,0-6.66,3.61,54.44,54.44,0,0,0-9.34,7.07,34.46,34.46,0,0,0-6.87,8.93,23.25,23.25,0,0,0-2.65,13.93A24.91,24.91,0,0,0,139,281c.38.68.81,1.36,1.25,2a40.5,40.5,0,0,0,8.39,8.93h0c1.17.94,2.42,1.87,3.75,2.77s2.75,1.77,4.25,2.63c1.73,1,3.56,1.93,5.5,2.83,2.36,1.11,4.82,2.13,7.35,3.05q2.64,1,5.4,1.81c27,8.22,60.79,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a58.9,58.9,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,40.34,40.34,0,0,0,3-3,30.49,30.49,0,0,0,5.91-9.46c.26-.7.5-1.4.7-2.1a22.55,22.55,0,0,0,.62-9.26,27.38,27.38,0,0,0-6.37-13.6,45.93,45.93,0,0,0-9.21-8.34A71.33,71.33,0,0,0,263.72,238.17Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.59,306.59c-1.92-.47-3.82-1-5.68-1.56s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.94-7.35-3.05-1.94-.9-3.77-1.85-5.5-2.83-1.5-.86-2.91-1.73-4.25-2.63s-2.58-1.83-3.75-2.77h0a40.5,40.5,0,0,1-8.39-8.93c-.44-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.25,23.25,0,0,1,2.65-13.93,34.46,34.46,0,0,1,6.87-8.93,54.44,54.44,0,0,1,9.34-7.07c1.87-1.15,3.85-2.21,5.9-3.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.1,289.74a37.82,37.82,0,0,1-5.84-6.73c-.44-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,22.77,22.77,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.37,310.17c-4.33-.26-8.63-.73-12.86-1.38L169.8,234.86l1.06-.38a107.42,107.42,0,0,1,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,307.24a129.56,129.56,0,0,1-12.88,2.19l-23.89-81.37c4.5-.2,9-.19,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8,304.27c-2.12.7-4.3,1.34-6.52,1.93l-22.84-77.8c2.45.2,4.89.45,7.31.77Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.55,240.1h0c1,.54,2,1.09,2.92,1.66.32.18.63.37.94.56l.94.6c.69.44,1.36.88,2,1.33a45.93,45.93,0,0,1,9.21,8.34,27.38,27.38,0,0,1,6.37,13.6,22.55,22.55,0,0,1-.62,9.26c-.2.7-.44,1.4-.7,2.1a30.49,30.49,0,0,1-5.91,9.46c-.34.38-.7.75-1.06,1.12Z",
    style: {
      fill: "#1976D2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.59,246c-23.06-10.7-57.42-9.91-78.54,1.48-.9.48-1.78,1-2.63,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.85-.52,1.66-1.06,2.43-1.6C277,275,273.64,256.68,250.59,246Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.59,246c-23.06-10.7-57.42-9.91-78.54,1.48-.9.48-1.78,1-2.63,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.85-.52,1.66-1.06,2.43-1.6C277,275,273.64,256.68,250.59,246Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.91,247c-.74-.34-1.49-.68-2.27-1-22-9.17-53.27-8.11-72.78,2.41l-.52.28c-.68.38-1.34.76-2,1.16a34.38,34.38,0,0,0-9.21,7.93c-5.21,6.7-5.53,14.17-1.16,20.93,2.58,4,6.77,7.69,12.55,10.86,1.08.6,2.22,1.18,3.42,1.73s2.23,1,3.39,1.46a73.21,73.21,0,0,0,7.54,2.51c18.19,5,40.23,4.2,56.88-2.09a59.36,59.36,0,0,0,6.8-3.05c1-.53,2-1.09,2.95-1.68s1.59-1,2.32-1.53c.21-.14.42-.29.61-.44,4.87-3.56,8-7.55,9.49-11.67,2.52-7,.21-14.39-6.76-20.64A45.39,45.39,0,0,0,248.91,247Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.91,247c-.74-.34-1.49-.68-2.27-1-22-9.17-53.27-8.11-72.78,2.41l-.52.28c-.68.38-1.34.76-2,1.16a34.38,34.38,0,0,0-9.21,7.93c-5.21,6.7-5.53,14.17-1.16,20.93,2.58,4,6.77,7.69,12.55,10.86,1.08.6,2.22,1.18,3.42,1.73s2.23,1,3.39,1.46a73.21,73.21,0,0,0,7.54,2.51c18.19,5,40.23,4.2,56.88-2.09a59.36,59.36,0,0,0,6.8-3.05c1-.53,2-1.09,2.95-1.68s1.59-1,2.32-1.53c.21-.14.42-.29.61-.44,4.87-3.56,8-7.55,9.49-11.67,2.52-7,.21-14.39-6.76-20.64A45.39,45.39,0,0,0,248.91,247Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.67,252.48c.77.31,1.53.65,2.27,1a45.49,45.49,0,0,1,11.26,7.19c4.06,3.64,6.53,7.67,7.39,11.79a15.92,15.92,0,0,1-.66,2.38c-1.47,4.12-4.62,8.11-9.49,11.67-.19.15-.4.3-.61.44-.73.52-1.51,1-2.32,1.53s-1.93,1.15-2.95,1.68a59.36,59.36,0,0,1-6.8,3.05c-16.65,6.29-38.69,7.1-56.88,2.09a73.21,73.21,0,0,1-7.54-2.51c-1.16-.46-2.28-.94-3.39-1.46s-2.34-1.13-3.42-1.73c-5.78-3.17-10-6.89-12.55-10.86a18.83,18.83,0,0,1-2.68-6.36,19.39,19.39,0,0,1,3.87-8.11,34.22,34.22,0,0,1,9.21-7.93c.64-.4,1.31-.78,2-1.15l.53-.29C193.4,244.37,224.71,243.31,246.67,252.48Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.67,252.48c.77.31,1.53.65,2.27,1a45.49,45.49,0,0,1,11.26,7.19c4.06,3.64,6.53,7.67,7.39,11.79a15.92,15.92,0,0,1-.66,2.38c-1.47,4.12-4.62,8.11-9.49,11.67-.19.15-.4.3-.61.44-.73.52-1.51,1-2.32,1.53s-1.93,1.15-2.95,1.68a59.36,59.36,0,0,1-6.8,3.05c-16.65,6.29-38.69,7.1-56.88,2.09a73.21,73.21,0,0,1-7.54-2.51c-1.16-.46-2.28-.94-3.39-1.46s-2.34-1.13-3.42-1.73c-5.78-3.17-10-6.89-12.55-10.86a18.83,18.83,0,0,1-2.68-6.36,19.39,19.39,0,0,1,3.87-8.11,34.22,34.22,0,0,1,9.21-7.93c.64-.4,1.31-.78,2-1.15l.53-.29C193.4,244.37,224.71,243.31,246.67,252.48Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.62,277.55c-8.74,19.43-33.18,27.18-53.12,30.68-30.3,4.36-63.28.71-86.71-16.53l.06,0c-6.38-5-11.8-11.73-12.95-19.87,1,8.22,6.24,15.17,12.62,20.32l-.05,0c18.88,14.63,45,19.37,70,18.67C243.66,309.34,277.2,302.56,288.62,277.55Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.18,283.49c8.55,3.59,16.94,2,24.76-.74l-2.06,2.12v8.89a37.45,37.45,0,0,0,5.3.86,38.59,38.59,0,0,0,9.21-.34,49.26,49.26,0,0,0,14.34-4.73l7.54,3.17,10.19-6.27v-8.88l-1.91-.82-.41-.18a9.08,9.08,0,0,0,.21-2.07c0-.25,0-.48-.07-.7-.13-1.1.1-6.12.06-8.19,0-.25,0-.47-.06-.7-.3-2.48-2.37-4.71-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.79l-1.15.14H227l-1.19.2c-.35.06-.7.12-1,.2-.15,0-.3.05-.43.09s-.54.1-.79.17a62.82,62.82,0,0,0-6.5,1.92c-.93.33-1.86.68-2.78,1l2.69-2.8v-8.89c-8.66-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.42v8.89l2.36,1a5.88,5.88,0,0,0-.22,1.68v.07c.08,1.38,0,7.26,0,8.82v.07C174.57,279.31,176.71,281.63,181.18,283.49Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.34,266c0,2.28-.17,6.75-.05,7.77,0,.24.05.46.06.71a8.3,8.3,0,0,1-.22,2.08l-5.41-2.28S248.19,271.66,248.34,266Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.61,265.88c-2.26-.94-2.63-2.7,1.53-5.38,4.46-2.83,9-3.57,12.94-2.59l8.82-9.19v8.88l-2.66,2.8-.28.11c-1.44.55-2.85,1.12-4.18,1.67-.54.25-1.07.47-1.59.67a55.38,55.38,0,0,1-8.9,3.27,10.05,10.05,0,0,1-3.86.27A6.79,6.79,0,0,1,193.61,265.88Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.62,266.05l-2.35-1v-8.88l7.51,3.15C177,261.66,175.2,263.93,174.62,266.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28,283.82l10.18-6.26v8.88l-10.2,6.29-7.52-3.18a48.79,48.79,0,0,1-14.36,4.72,36.15,36.15,0,0,1-14.5-.51v-8.89a36.15,36.15,0,0,0,14.5.51,48.5,48.5,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.75,289.55a37.16,37.16,0,0,1-11.44,4.68,30.51,30.51,0,0,1-12.13.4,58.58,58.58,0,0,0,12-1.4c2-.43,3.91-1,5.84-1.6S230.82,290.28,232.75,289.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.42,276.69v-.05c-.06-1.57.07-7.44,0-8.84.16,2.63,2.28,4.94,6.74,6.81,9.94,4.14,19.61,1.42,28.46-2.13,8.22-3.33,14.18-6.86,19-4.86,3,1.27,2.15,3.26-1.14,5.36a18.15,18.15,0,0,1-14.2,2.24L206,282.76h0c-7.84,2.77-16.21,4.3-24.76.72C176.7,281.63,174.58,279.32,174.42,276.69Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.09 266.8 208.08 257.91 216.89 248.71 216.9 257.6 208.09 266.8",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.09 266.8 208.08 257.91 216.89 248.71 216.9 257.6 208.09 266.8",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.26 256.19 179.81 259.34 174.63 266.06 172.27 265.08 172.26 256.19",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.26 256.19 179.81 259.34 174.63 266.06 172.27 265.08 172.26 256.19",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.55,276.75l-5.83-2.46s5.73-2.77,5.62-8.68c0-.25,0-.47-.06-.7-.3-2.48-2.37-4.71-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.79l-1.15.14H227l-1.19.2c-.35.06-.7.12-1,.2-.15,0-.3.05-.43.09s-.54.1-.79.17a62.82,62.82,0,0,0-6.5,1.92c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.69-.54.24-1.06.46-1.59.67a57.37,57.37,0,0,1-8.89,3.27,10.21,10.21,0,0,1-3.85.26,7.94,7.94,0,0,1-1.81-.49c-2.27-1-2.66-2.72,1.52-5.4,4.45-2.84,9-3.58,12.94-2.59l8.81-9.2c-8.66-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.42,7.55,3.15c-3.6,3-5.5,5.83-5.4,8.4v.07c.15,2.62,2.29,4.93,6.76,6.8,9.91,4.15,19.59,1.42,28.44-2.13,8.22-3.33,14.18-6.86,19-4.85,3,1.26,2.14,3.25-1.15,5.36a18.22,18.22,0,0,1-14.2,2.24l-9.38,9.64a39,39,0,0,0,5.3.87,38.59,38.59,0,0,0,9.21-.35,49,49,0,0,0,14.34-4.72l7.54,3.16,10.19-6.26Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.55,276.75l-5.83-2.46s5.73-2.77,5.62-8.68c0-.25,0-.47-.06-.7-.3-2.48-2.37-4.71-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.79l-1.15.14H227l-1.19.2c-.35.06-.7.12-1,.2-.15,0-.3.05-.43.09s-.54.1-.79.17a62.82,62.82,0,0,0-6.5,1.92c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.69-.54.24-1.06.46-1.59.67a57.37,57.37,0,0,1-8.89,3.27,10.21,10.21,0,0,1-3.85.26,7.94,7.94,0,0,1-1.81-.49c-2.27-1-2.66-2.72,1.52-5.4,4.45-2.84,9-3.58,12.94-2.59l8.81-9.2c-8.66-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.42,7.55,3.15c-3.6,3-5.5,5.83-5.4,8.4v.07c.15,2.62,2.29,4.93,6.76,6.8,9.91,4.15,19.59,1.42,28.44-2.13,8.22-3.33,14.18-6.86,19-4.85,3,1.26,2.14,3.25-1.15,5.36a18.22,18.22,0,0,1-14.2,2.24l-9.38,9.64a39,39,0,0,0,5.3.87,38.59,38.59,0,0,0,9.21-.35,49,49,0,0,0,14.34-4.72l7.54,3.16,10.19-6.26Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.17,274.61a28.46,28.46,0,0,0,11.8,1.83A43.16,43.16,0,0,0,205,273.89c3.94-1.3,7.74-3,11.61-4.62a39.21,39.21,0,0,1,6-2,9.88,9.88,0,0,1,6,.35,9.83,9.83,0,0,0-6-.08,40,40,0,0,0-5.84,2.11c-3.82,1.66-7.64,3.41-11.61,4.76A42.62,42.62,0,0,1,193,276.88a28.77,28.77,0,0,1-6.1-.46A29.17,29.17,0,0,1,181.17,274.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.27 283.83 240.28 292.72 232.74 289.55 232.73 280.67 240.27 283.83",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.27 283.83 240.28 292.72 232.74 289.55 232.73 280.67 240.27 283.83",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.46 277.56 240.31 282.84 232.73 280.67 240.27 283.83 250.46 277.56",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.87 252.91 182.38 250.69 172.26 256.19 182.33 249.77 189.87 252.91",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.89,248.71a39.38,39.38,0,0,0-4.73-.56l1.24,4.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.51,274.73a27.46,27.46,0,0,0,13,1.83l-7.26-24.75-4.91-2-6.86,4.38L176.6,258l3.21,1.34a25,25,0,0,0-2.22,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.17,257.85a26.33,26.33,0,0,0-7.48-1.37l8,27.12,6-3.69-1.33-4.52-2.6-1.1a11.22,11.22,0,0,0,1.91-1.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,256.78l-1.19.2c-.35.06-.7.12-1,.2-.15,0-.3.05-.43.09s-.54.1-.79.17a62.82,62.82,0,0,0-6.5,1.92c-.47.16-.92.35-1.39.52l2.63,9c4.06-1.59,7.43-2.44,10.38-1.21s2.14,3.25-1.15,5.36a17.64,17.64,0,0,1-7.24,2.61l2.59,8.84a51.72,51.72,0,0,0,9.92-3.77l2.85,1.19-7.41-25.23-1.09.14Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,247.86l8.47,0v17.34h0a23.18,23.18,0,0,1-.83,6.15c-.2.7-.44,1.41-.7,2.1a30.49,30.49,0,0,1-5.91,9.46,40.34,40.34,0,0,1-3,3,43.27,43.27,0,0,1-3.5,2.92,56.72,56.72,0,0,1-5.1,3.47c-1.92,1.17-3.92,2.27-6,3.29-1.58.77-3.2,1.51-4.88,2.19-24.52,10.14-58.33,11.37-85.31,3.14-1.84-.55-3.64-1.16-5.4-1.81-2.53-.92-5-1.94-7.35-3-1.94-.91-3.77-1.85-5.5-2.84-1.49-.85-2.91-1.73-4.24-2.63s-2.59-1.82-3.76-2.77h0a40.4,40.4,0,0,1-8.38-8.92c-.45-.68-.88-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0l0-16.39,7.75,0c.62-.67,1.27-1.34,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,91.52,91.52,0,0,1,9.43-3.85c22.18-7.66,50.42-8.7,74.42-2.73A106.84,106.84,0,0,1,224,232.24c2.79,1,5.49,2.1,8.08,3.31a71.35,71.35,0,0,1,10.64,6.09A48.27,48.27,0,0,1,250,247.86Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.87,304.65l0-35.18,12.88,1.35,0,35.21C168.41,305.77,164.1,305.31,159.87,304.65Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.5,265.16h0a23.18,23.18,0,0,1-.83,6.15c-.2.7-.44,1.41-.7,2.1a30.49,30.49,0,0,1-5.91,9.46c-.34.38-.7.75-1.06,1.12l0-36.19.06.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.55,249l6.61-1.57,0,52.72q-3.16,1-6.47,1.92Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.51,305.29l0-45.69,12.88.95,0,42.55A129.86,129.86,0,0,1,198.51,305.29Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.06,248.42l7.75,0c.62-.67,1.27-1.34,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,91.52,91.52,0,0,1,9.43-3.85q4.67-1.61,9.65-2.81l.06,73.4c-1.91-.48-3.8-1-5.65-1.56s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.94-7.35-3-1.94-.91-3.77-1.85-5.5-2.84-1.49-.85-2.91-1.73-4.24-2.63s-2.59-1.82-3.76-2.77h0a40.4,40.4,0,0,1-8.38-8.92c-.45-.68-.88-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.62,278.88c-.45-.68-.88-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0l0-16.39,7.75,0,.1-.1,2.61,1,0,36.45A38.06,38.06,0,0,1,108.62,278.88Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.06,217c-2.59-1.21-5.29-2.31-8.08-3.31q-5-1.78-10.37-3.12c-24-6-52.24-4.92-74.42,2.74a90.62,90.62,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93,23.13,23.13,0,0,0-2.65,13.93,25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.35,1.26,2a40.46,40.46,0,0,0,8.39,8.92h0q1.77,1.41,3.76,2.76c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.55,6-3.29t5.1-3.47q1.88-1.44,3.5-2.92a40.23,40.23,0,0,0,3-3A30.67,30.67,0,0,0,257,256.4c.26-.7.49-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26,27.51,27.51,0,0,0-6.37-13.6,46.55,46.55,0,0,0-9.22-8.33A70.72,70.72,0,0,0,232.06,217Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.06,217c-2.59-1.21-5.29-2.31-8.08-3.31q-5-1.78-10.37-3.12c-24-6-52.24-4.92-74.42,2.74a90.62,90.62,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93,23.13,23.13,0,0,0-2.65,13.93,25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.35,1.26,2a40.46,40.46,0,0,0,8.39,8.92h0q1.77,1.41,3.76,2.76c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.55,6-3.29t5.1-3.47q1.88-1.44,3.5-2.92a40.23,40.23,0,0,0,3-3A30.67,30.67,0,0,0,257,256.4c.26-.7.49-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26,27.51,27.51,0,0,0-6.37-13.6,46.55,46.55,0,0,0-9.22-8.33A70.72,70.72,0,0,0,232.06,217Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.06,217c-2.59-1.21-5.29-2.31-8.08-3.31q-5-1.78-10.37-3.12c-24-6-52.24-4.92-74.42,2.74a90.62,90.62,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93,23.13,23.13,0,0,0-2.65,13.93,25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.35,1.26,2a40.46,40.46,0,0,0,8.39,8.92h0q1.77,1.41,3.76,2.76c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.55,6-3.29t5.1-3.47q1.88-1.44,3.5-2.92a40.23,40.23,0,0,0,3-3A30.67,30.67,0,0,0,257,256.4c.26-.7.49-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26,27.51,27.51,0,0,0-6.37-13.6,46.55,46.55,0,0,0-9.22-8.33A70.72,70.72,0,0,0,232.06,217Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.93,285.44c-1.92-.48-3.82-1-5.68-1.56s-3.64-1.16-5.41-1.82c-2.53-.92-5-1.93-7.35-3-1.93-.91-3.77-1.85-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.76h0a40.46,40.46,0,0,1-8.39-8.92c-.45-.68-.87-1.35-1.25-2a24.9,24.9,0,0,1-3.11-9.13,23.13,23.13,0,0,1,2.65-13.93,34.35,34.35,0,0,1,6.87-8.93,54.74,54.74,0,0,1,9.33-7.07c1.88-1.14,3.86-2.21,5.91-3.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.44,268.59a38.17,38.17,0,0,1-5.84-6.73c-.45-.68-.87-1.35-1.25-2a24.9,24.9,0,0,1-3.11-9.13,22.66,22.66,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.71,289c-4.34-.26-8.64-.73-12.86-1.39L138.14,213.7l1.05-.38c3.34-1.15,6.83-2.14,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.36,286.09c-4.18.93-8.49,1.66-12.87,2.19L174.6,206.9c4.49-.2,9-.18,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.14,283.11c-2.13.71-4.3,1.35-6.52,1.94l-22.84-77.81c2.45.2,4.89.45,7.31.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.88,219h0c1,.54,2,1.09,2.93,1.65l.94.57.94.59c.68.44,1.36.89,2,1.34a46.76,46.76,0,0,1,9.21,8.33,27.51,27.51,0,0,1,6.37,13.6,22.36,22.36,0,0,1-.63,9.26c-.2.71-.43,1.41-.69,2.11a30.67,30.67,0,0,1-5.92,9.45c-.33.38-.69.76-1.06,1.13Z",
    style: {
      fill: "#1976D2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.92,224.83c-23-10.71-57.41-9.91-78.54,1.48-.89.48-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.38s60.37,9.83,81.17-3c.84-.52,1.66-1.06,2.42-1.6C245.34,253.84,242,235.53,218.92,224.83Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.92,224.83c-23-10.71-57.41-9.91-78.54,1.48-.89.48-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.38s60.37,9.83,81.17-3c.84-.52,1.66-1.06,2.42-1.6C245.34,253.84,242,235.53,218.92,224.83Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.25,225.86c-.74-.35-1.5-.68-2.27-1-22-9.17-53.27-8.1-72.78,2.42l-.52.28c-.68.37-1.34.76-2,1.16a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.93,2.57,4,6.76,7.69,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a73.42,73.42,0,0,0,7.55,2.52c18.18,5,40.22,4.2,56.88-2.1a59.16,59.16,0,0,0,6.79-3c1-.53,2-1.1,3-1.68s1.59-1,2.32-1.53l.61-.44c4.86-3.57,8-7.56,9.49-11.67,2.52-7,.2-14.39-6.76-20.64A45.77,45.77,0,0,0,217.25,225.86Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.25,225.86c-.74-.35-1.5-.68-2.27-1-22-9.17-53.27-8.1-72.78,2.42l-.52.28c-.68.37-1.34.76-2,1.16a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.93,2.57,4,6.76,7.69,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a73.42,73.42,0,0,0,7.55,2.52c18.18,5,40.22,4.2,56.88-2.1a59.16,59.16,0,0,0,6.79-3c1-.53,2-1.1,3-1.68s1.59-1,2.32-1.53l.61-.44c4.86-3.57,8-7.56,9.49-11.67,2.52-7,.2-14.39-6.76-20.64A45.77,45.77,0,0,0,217.25,225.86Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,231.32c.78.32,1.53.65,2.27,1a45.39,45.39,0,0,1,11.26,7.18c4.07,3.65,6.54,7.68,7.4,11.8a17.21,17.21,0,0,1-.66,2.38c-1.48,4.11-4.63,8.1-9.49,11.67l-.61.44c-.73.51-1.51,1-2.32,1.53s-1.94,1.15-3,1.68a59.16,59.16,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.1a73.42,73.42,0,0,1-7.55-2.52c-1.15-.45-2.28-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.78-3.16-10-6.89-12.54-10.85a18.94,18.94,0,0,1-2.69-6.36,19.57,19.57,0,0,1,3.87-8.11,34.43,34.43,0,0,1,9.22-7.93c.64-.4,1.3-.79,2-1.16l.53-.28C161.74,223.22,193,222.16,215,231.32Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,231.32c.78.32,1.53.65,2.27,1a45.39,45.39,0,0,1,11.26,7.18c4.07,3.65,6.54,7.68,7.4,11.8a17.21,17.21,0,0,1-.66,2.38c-1.48,4.11-4.63,8.1-9.49,11.67l-.61.44c-.73.51-1.51,1-2.32,1.53s-1.94,1.15-3,1.68a59.16,59.16,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.1a73.42,73.42,0,0,1-7.55-2.52c-1.15-.45-2.28-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.78-3.16-10-6.89-12.54-10.85a18.94,18.94,0,0,1-2.69-6.36,19.57,19.57,0,0,1,3.87-8.11,34.43,34.43,0,0,1,9.22-7.93c.64-.4,1.3-.79,2-1.16l.53-.28C161.74,223.22,193,222.16,215,231.32Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,256.4c-8.74,19.43-33.19,27.18-53.12,30.68-30.3,4.35-63.28.7-86.71-16.54l.05,0c-6.37-5-11.8-11.74-12.94-19.88,1,8.23,6.24,15.18,12.61,20.33l0,0c18.87,14.63,45,19.36,70,18.66C212,288.19,245.53,281.41,257,256.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.51,262.34c8.56,3.58,17,2,24.77-.74l-2.06,2.12v8.89a37.08,37.08,0,0,0,5.29.86,38.08,38.08,0,0,0,9.21-.35,49.21,49.21,0,0,0,14.35-4.72l7.54,3.17,10.18-6.27v-8.89l-1.91-.82-.42-.17a8.08,8.08,0,0,0,.21-2.07,5.22,5.22,0,0,0-.06-.71c-.13-1.09.1-6.11.06-8.18,0-.25,0-.48-.07-.7-.29-2.49-2.36-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.8l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.2l-.42.09c-.27.06-.55.11-.8.18a62.61,62.61,0,0,0-6.49,1.91c-.94.33-1.87.68-2.78,1.05l2.69-2.8v-8.89c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.15L140.6,235v8.89l2.36,1a5.18,5.18,0,0,0-.22,1.68v.07c.07,1.38-.06,7.26,0,8.82v.07C142.9,258.16,145.05,260.47,149.51,262.34Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.67,244.87c0,2.28-.16,6.75,0,7.77,0,.24,0,.46.07.7a8.33,8.33,0,0,1-.22,2.09l-5.42-2.28S216.52,250.5,216.67,244.87Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,244.73c-2.26-.95-2.64-2.71,1.52-5.39,4.46-2.82,9.05-3.56,12.95-2.58l8.82-9.19,0,8.87-2.66,2.81-.27.1c-1.45.56-2.85,1.13-4.19,1.68-.54.24-1.07.47-1.59.67a53.88,53.88,0,0,1-8.9,3.26,9.81,9.81,0,0,1-3.85.27A7.16,7.16,0,0,1,162,244.73Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,244.9l-2.35-1,0-8.87,7.51,3.15C145.33,240.5,143.54,242.77,143,244.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.61,262.67l10.19-6.27v8.89l-10.2,6.28-7.52-3.18a48.5,48.5,0,0,1-14.36,4.72,38.07,38.07,0,0,1-9.21.36,38.8,38.8,0,0,1-5.29-.86v-8.89a36.15,36.15,0,0,0,14.5.51,48.79,48.79,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.09,268.4a37.16,37.16,0,0,1-11.44,4.68,30.51,30.51,0,0,1-12.13.39,57,57,0,0,0,11.95-1.4c2-.42,3.91-1,5.85-1.6S199.16,269.13,201.09,268.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.75,255.54v0c-.07-1.57.07-7.45,0-8.84.16,2.63,2.29,4.94,6.75,6.81,9.94,4.14,19.61,1.41,28.46-2.14,8.21-3.32,14.18-6.85,19-4.85,3,1.26,2.15,3.26-1.13,5.36a18.18,18.18,0,0,1-14.2,2.23l-7.32,7.55h0c-7.84,2.77-16.22,4.3-24.76.72C145,260.48,142.91,258.16,142.75,255.54Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.42 245.64 176.42 236.76 185.23 227.56 185.24 236.44 176.42 245.64",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.42 245.64 176.42 236.76 185.23 227.56 185.24 236.44 176.42 245.64",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.6 235.04 148.14 238.18 142.97 244.91 140.61 243.93 140.6 235.04",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.6 235.04 148.14 238.18 142.97 244.91 140.61 243.93 140.6 235.04",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.89,255.59l-5.83-2.45s5.73-2.77,5.62-8.68c0-.25,0-.48-.07-.7-.29-2.49-2.36-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.8l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.2l-.42.09c-.27.06-.55.11-.8.18a62.61,62.61,0,0,0-6.49,1.91c-1,.36-2,.74-3,1.14-1.44.57-2.86,1.15-4.2,1.7l-1.59.67a55.79,55.79,0,0,1-8.9,3.26,10.2,10.2,0,0,1-3.85.27,8.1,8.1,0,0,1-1.81-.5c-2.27-1-2.65-2.72,1.53-5.39,4.45-2.85,9-3.58,12.94-2.59l8.81-9.2c-8.67-1.66-17.92-.25-27,4.2l-7.54-3.15L140.6,235l7.54,3.14c-3.6,3-5.49,5.84-5.39,8.41v.07c.15,2.61,2.29,4.93,6.76,6.79,9.91,4.15,19.59,1.43,28.43-2.13,8.22-3.33,14.19-6.85,19-4.84,3,1.26,2.14,3.25-1.15,5.35a18.19,18.19,0,0,1-14.19,2.24l-9.38,9.65a37.22,37.22,0,0,0,5.3.86,38.59,38.59,0,0,0,9.21-.34,49.26,49.26,0,0,0,14.34-4.73l7.54,3.17,10.19-6.27Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.89,255.59l-5.83-2.45s5.73-2.77,5.62-8.68c0-.25,0-.48-.07-.7-.29-2.49-2.36-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.8l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.2l-.42.09c-.27.06-.55.11-.8.18a62.61,62.61,0,0,0-6.49,1.91c-1,.36-2,.74-3,1.14-1.44.57-2.86,1.15-4.2,1.7l-1.59.67a55.79,55.79,0,0,1-8.9,3.26,10.2,10.2,0,0,1-3.85.27,8.1,8.1,0,0,1-1.81-.5c-2.27-1-2.65-2.72,1.53-5.39,4.45-2.85,9-3.58,12.94-2.59l8.81-9.2c-8.67-1.66-17.92-.25-27,4.2l-7.54-3.15L140.6,235l7.54,3.14c-3.6,3-5.49,5.84-5.39,8.41v.07c.15,2.61,2.29,4.93,6.76,6.79,9.91,4.15,19.59,1.43,28.43-2.13,8.22-3.33,14.19-6.85,19-4.84,3,1.26,2.14,3.25-1.15,5.35a18.19,18.19,0,0,1-14.19,2.24l-9.38,9.65a37.22,37.22,0,0,0,5.3.86,38.59,38.59,0,0,0,9.21-.34,49.26,49.26,0,0,0,14.34-4.73l7.54,3.17,10.19-6.27Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.51,253.45a28.41,28.41,0,0,0,11.8,1.84,43.44,43.44,0,0,0,12-2.55c4-1.3,7.74-3,11.61-4.63a41.26,41.26,0,0,1,6-2,9.92,9.92,0,0,1,6,.36,9.88,9.88,0,0,0-6-.09,40.13,40.13,0,0,0-5.85,2.12c-3.82,1.66-7.63,3.4-11.6,4.76a42.34,42.34,0,0,1-12.23,2.45,28.27,28.27,0,0,1-6.11-.46A29.29,29.29,0,0,1,149.51,253.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.61 262.68 208.62 271.56 201.07 268.4 201.07 259.51 208.61 262.68",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.61 262.68 208.62 271.56 201.07 268.4 201.07 259.51 208.61 262.68",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.79 256.41 208.65 261.68 201.07 259.51 208.61 262.68 218.79 256.41",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.21 231.76 150.71 229.53 140.6 235.04 150.66 228.61 158.21 231.76",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.23,227.56a37.45,37.45,0,0,0-4.73-.56l1.23,4.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.85,253.58a27.57,27.57,0,0,0,13,1.83l-7.27-24.75-4.9-2L143.8,233l1.14,3.85,3.2,1.33a26.31,26.31,0,0,0-2.21,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.51,236.69a26.31,26.31,0,0,0-7.49-1.36l8,27.12,6-3.69-1.33-4.52-2.6-1.1a11,11,0,0,0,1.9-1.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.29,235.63l-1.2.19c-.35.06-.7.12-1.05.2l-.42.09c-.27.06-.55.11-.8.18a62.61,62.61,0,0,0-6.49,1.91l-1.39.53,2.63,9c4.05-1.6,7.43-2.44,10.37-1.21s2.14,3.25-1.15,5.35a17.76,17.76,0,0,1-7.24,2.62l2.6,8.83a51.31,51.31,0,0,0,9.92-3.77l2.84,1.2-7.4-25.23-1.1.14Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.37,218.58l8.46,0v17.33h0A22.74,22.74,0,0,1,287,242c-.19.71-.43,1.41-.69,2.11a30.67,30.67,0,0,1-5.92,9.45,40.23,40.23,0,0,1-3,3q-1.62,1.49-3.5,2.92a60.48,60.48,0,0,1-5.1,3.47q-2.88,1.74-6,3.29c-1.57.77-3.2,1.5-4.87,2.19-24.53,10.13-58.34,11.36-85.31,3.14-1.84-.56-3.64-1.16-5.41-1.82-2.53-.92-5-1.93-7.35-3-1.93-.91-3.77-1.85-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.76h0A40.46,40.46,0,0,1,138,249.6c-.45-.68-.87-1.35-1.25-2a24.9,24.9,0,0,1-3.11-9.13,21.76,21.76,0,0,1-.18-2.91h0V219.14l7.75,0c.61-.67,1.26-1.34,1.95-2a54.44,54.44,0,0,1,9.34-7.07,74.07,74.07,0,0,1,6.67-3.61,90.59,90.59,0,0,1,9.43-3.84c22.18-7.67,50.42-8.7,74.41-2.74A105.14,105.14,0,0,1,253.33,203c2.78,1,5.49,2.1,8.07,3.31A70.34,70.34,0,0,1,272,212.36,49,49,0,0,1,279.37,218.58Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.2,275.37l0-35.18,12.88,1.35,0,35.21C197.75,276.49,193.44,276,189.2,275.37Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.84,235.88h0A22.74,22.74,0,0,1,287,242c-.19.71-.43,1.41-.69,2.11a30.67,30.67,0,0,1-5.92,9.45c-.33.38-.69.75-1.05,1.13l0-36.2.06.06,8.46,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.88,219.71l6.62-1.56,0,52.71c-2.1.7-4.26,1.34-6.46,1.92Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.84,276l0-45.69,12.88,1,0,42.55A126.72,126.72,0,0,1,227.84,276Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.4,219.14l7.75,0c.61-.67,1.26-1.34,1.95-2a54.44,54.44,0,0,1,9.34-7.07,74.07,74.07,0,0,1,6.67-3.61,90.59,90.59,0,0,1,9.43-3.84c3.1-1.07,6.33-2,9.64-2.81l.06,73.39q-2.87-.71-5.64-1.55c-1.84-.56-3.64-1.16-5.41-1.82-2.53-.92-5-1.93-7.35-3-1.93-.91-3.77-1.85-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.76h0A40.46,40.46,0,0,1,138,249.6c-.45-.68-.87-1.35-1.25-2a24.9,24.9,0,0,1-3.11-9.13,21.76,21.76,0,0,1-.18-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,249.6c-.45-.68-.87-1.35-1.25-2a24.9,24.9,0,0,1-3.11-9.13,21.76,21.76,0,0,1-.18-2.91h0V219.14l7.75,0,.09-.1,2.61,1,0,36.46A38.1,38.1,0,0,1,138,249.6Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.39,187.74c-2.59-1.22-5.29-2.32-8.07-3.31a105.14,105.14,0,0,0-10.38-3.12c-24-6-52.24-4.93-74.41,2.74a90.59,90.59,0,0,0-9.43,3.84q-3.51,1.68-6.67,3.6a54.47,54.47,0,0,0-9.34,7.08,34.58,34.58,0,0,0-6.87,8.92,23.29,23.29,0,0,0-2.65,13.94,24.91,24.91,0,0,0,3.11,9.12c.39.68.81,1.36,1.26,2a40.66,40.66,0,0,0,8.38,8.93h0c1.17.94,2.43,1.87,3.76,2.76s2.75,1.78,4.24,2.64c1.73,1,3.57,1.92,5.5,2.83,2.36,1.11,4.82,2.13,7.35,3q2.64,1,5.4,1.81c27,8.22,60.79,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a58.9,58.9,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,42.34,42.34,0,0,0,3-3,30.6,30.6,0,0,0,5.91-9.46c.26-.7.5-1.4.7-2.1a22.55,22.55,0,0,0,.62-9.26,27.26,27.26,0,0,0-6.37-13.6,45.93,45.93,0,0,0-9.21-8.34A71.33,71.33,0,0,0,261.39,187.74Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.39,187.74c-2.59-1.22-5.29-2.32-8.07-3.31a105.14,105.14,0,0,0-10.38-3.12c-24-6-52.24-4.93-74.41,2.74a90.59,90.59,0,0,0-9.43,3.84q-3.51,1.68-6.67,3.6a54.47,54.47,0,0,0-9.34,7.08,34.58,34.58,0,0,0-6.87,8.92,23.29,23.29,0,0,0-2.65,13.94,24.91,24.91,0,0,0,3.11,9.12c.39.68.81,1.36,1.26,2a40.66,40.66,0,0,0,8.38,8.93h0c1.17.94,2.43,1.87,3.76,2.76s2.75,1.78,4.24,2.64c1.73,1,3.57,1.92,5.5,2.83,2.36,1.11,4.82,2.13,7.35,3q2.64,1,5.4,1.81c27,8.22,60.79,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a58.9,58.9,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,42.34,42.34,0,0,0,3-3,30.6,30.6,0,0,0,5.91-9.46c.26-.7.5-1.4.7-2.1a22.55,22.55,0,0,0,.62-9.26,27.26,27.26,0,0,0-6.37-13.6,45.93,45.93,0,0,0-9.21-8.34A71.33,71.33,0,0,0,261.39,187.74Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.39,187.74c-2.59-1.22-5.29-2.32-8.07-3.31a105.14,105.14,0,0,0-10.38-3.12c-24-6-52.24-4.93-74.41,2.74a90.59,90.59,0,0,0-9.43,3.84q-3.51,1.68-6.67,3.6a54.47,54.47,0,0,0-9.34,7.08,34.58,34.58,0,0,0-6.87,8.92,23.29,23.29,0,0,0-2.65,13.94,24.91,24.91,0,0,0,3.11,9.12c.39.68.81,1.36,1.26,2a40.66,40.66,0,0,0,8.38,8.93h0c1.17.94,2.43,1.87,3.76,2.76s2.75,1.78,4.24,2.64c1.73,1,3.57,1.92,5.5,2.83,2.36,1.11,4.82,2.13,7.35,3q2.64,1,5.4,1.81c27,8.22,60.79,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a58.9,58.9,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,42.34,42.34,0,0,0,3-3,30.6,30.6,0,0,0,5.91-9.46c.26-.7.5-1.4.7-2.1a22.55,22.55,0,0,0,.62-9.26,27.26,27.26,0,0,0-6.37-13.6,45.93,45.93,0,0,0-9.21-8.34A71.33,71.33,0,0,0,261.39,187.74Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.26,256.16c-1.92-.48-3.81-1-5.68-1.56s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.94-7.35-3-1.93-.91-3.77-1.85-5.5-2.83-1.49-.86-2.91-1.73-4.24-2.64s-2.59-1.82-3.76-2.76h0a40.66,40.66,0,0,1-8.38-8.93c-.45-.67-.87-1.35-1.26-2a24.91,24.91,0,0,1-3.11-9.12,23.29,23.29,0,0,1,2.65-13.94,34.58,34.58,0,0,1,6.87-8.92,54.47,54.47,0,0,1,9.34-7.08c1.88-1.14,3.85-2.2,5.9-3.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.77,239.31a37.74,37.74,0,0,1-5.83-6.73c-.45-.67-.87-1.35-1.26-2a24.91,24.91,0,0,1-3.11-9.12,22.75,22.75,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,259.74c-4.33-.26-8.63-.73-12.86-1.39l-21.7-73.92c.35-.13.69-.26,1.05-.38,3.34-1.16,6.83-2.14,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.7,256.81A129.56,129.56,0,0,1,227.82,259l-23.89-81.37c4.5-.2,9-.19,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.47,253.84c-2.12.7-4.3,1.34-6.52,1.93L222.11,178c2.45.2,4.9.45,7.32.77Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.22,189.67h0c1,.54,2,1.09,2.92,1.66.32.18.64.37.94.56l.95.6c.68.44,1.36.88,2,1.33a45.93,45.93,0,0,1,9.21,8.34,27.26,27.26,0,0,1,6.37,13.6A22.55,22.55,0,0,1,287,225c-.2.7-.44,1.4-.7,2.1a30.6,30.6,0,0,1-5.91,9.46c-.34.37-.7.75-1.06,1.12Z",
    style: {
      fill: "#1976D2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.26,195.55c-23-10.7-57.42-9.91-78.54,1.48-.9.48-1.78,1-2.63,1.51-20.8,12.81-18.17,32.23,5.86,43.39s60.37,9.82,81.17-3c.85-.52,1.66-1.06,2.43-1.6C274.67,224.56,271.31,206.25,248.26,195.55Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.26,195.55c-23-10.7-57.42-9.91-78.54,1.48-.9.48-1.78,1-2.63,1.51-20.8,12.81-18.17,32.23,5.86,43.39s60.37,9.82,81.17-3c.85-.52,1.66-1.06,2.43-1.6C274.67,224.56,271.31,206.25,248.26,195.55Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.58,196.58c-.74-.34-1.49-.68-2.27-1-22-9.17-53.27-8.11-72.77,2.41l-.53.28c-.68.38-1.34.76-2,1.16a34.53,34.53,0,0,0-9.21,7.93c-5.21,6.7-5.53,14.17-1.15,20.93,2.57,4,6.76,7.69,12.54,10.86,1.08.6,2.22,1.18,3.42,1.73s2.23,1,3.39,1.46a74,74,0,0,0,7.54,2.51c18.19,5,40.23,4.2,56.89-2.1a58.23,58.23,0,0,0,6.79-3c1-.53,2-1.09,3-1.68s1.59-1,2.32-1.53l.62-.44c4.86-3.57,8-7.55,9.48-11.67,2.53-7,.21-14.39-6.76-20.64A45.39,45.39,0,0,0,246.58,196.58Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.58,196.58c-.74-.34-1.49-.68-2.27-1-22-9.17-53.27-8.11-72.77,2.41l-.53.28c-.68.38-1.34.76-2,1.16a34.53,34.53,0,0,0-9.21,7.93c-5.21,6.7-5.53,14.17-1.15,20.93,2.57,4,6.76,7.69,12.54,10.86,1.08.6,2.22,1.18,3.42,1.73s2.23,1,3.39,1.46a74,74,0,0,0,7.54,2.51c18.19,5,40.23,4.2,56.89-2.1a58.23,58.23,0,0,0,6.79-3c1-.53,2-1.09,3-1.68s1.59-1,2.32-1.53l.62-.44c4.86-3.57,8-7.55,9.48-11.67,2.53-7,.21-14.39-6.76-20.64A45.39,45.39,0,0,0,246.58,196.58Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.34,202.05c.77.31,1.53.65,2.27,1a45.77,45.77,0,0,1,11.26,7.18c4.06,3.65,6.53,7.68,7.39,11.8a15.92,15.92,0,0,1-.66,2.38c-1.47,4.12-4.62,8.1-9.48,11.67l-.62.44c-.73.52-1.51,1-2.32,1.53s-1.93,1.15-3,1.68a58.23,58.23,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.89,2.1a74,74,0,0,1-7.54-2.51c-1.16-.46-2.28-.94-3.39-1.46s-2.34-1.13-3.42-1.73c-5.78-3.17-10-6.9-12.54-10.86a18.74,18.74,0,0,1-2.69-6.36,19.39,19.39,0,0,1,3.87-8.11,34.22,34.22,0,0,1,9.21-7.93c.65-.4,1.31-.78,2-1.16l.52-.28C191.07,193.94,222.38,192.88,244.34,202.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.34,202.05c.77.31,1.53.65,2.27,1a45.77,45.77,0,0,1,11.26,7.18c4.06,3.65,6.53,7.68,7.39,11.8a15.92,15.92,0,0,1-.66,2.38c-1.47,4.12-4.62,8.1-9.48,11.67l-.62.44c-.73.52-1.51,1-2.32,1.53s-1.93,1.15-3,1.68a58.23,58.23,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.89,2.1a74,74,0,0,1-7.54-2.51c-1.16-.46-2.28-.94-3.39-1.46s-2.34-1.13-3.42-1.73c-5.78-3.17-10-6.9-12.54-10.86a18.74,18.74,0,0,1-2.69-6.36,19.39,19.39,0,0,1,3.87-8.11,34.22,34.22,0,0,1,9.21-7.93c.65-.4,1.31-.78,2-1.16l.52-.28C191.07,193.94,222.38,192.88,244.34,202.05Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.29,227.12c-8.74,19.43-33.18,27.18-53.12,30.68-30.3,4.35-63.28.71-86.7-16.53l.05,0c-6.37-5-11.8-11.73-13-19.87,1,8.22,6.25,15.17,12.62,20.32l-.05,0c18.88,14.63,45,19.37,70,18.67C241.33,258.91,274.87,252.13,286.29,227.12Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.85,233.06c8.56,3.59,16.94,2,24.76-.74l-2.06,2.12v8.89a37.45,37.45,0,0,0,5.3.86,38.08,38.08,0,0,0,9.21-.35,48.85,48.85,0,0,0,14.34-4.72l7.54,3.17L248.14,236v-8.89l-1.91-.81-.41-.18a9.08,9.08,0,0,0,.21-2.07c0-.25,0-.48-.07-.71-.13-1.09.1-6.11.06-8.18a5.07,5.07,0,0,0-.06-.7c-.3-2.48-2.37-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.79l-1.15.14h-.13l-1.19.2c-.35.06-.7.11-1.05.2-.15,0-.3.05-.42.09-.28,0-.55.1-.8.17a60.45,60.45,0,0,0-6.5,1.92c-.93.32-1.86.68-2.77,1l2.68-2.8v-8.89c-8.66-1.65-17.92-.25-27,4.2L180,199.34l-10.06,6.42v8.89l2.36,1a5.84,5.84,0,0,0-.22,1.68v.07c.08,1.38-.05,7.26,0,8.82v.07C172.24,228.88,174.38,231.2,178.85,233.06Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,215.59c0,2.28-.17,6.75,0,7.77,0,.24,0,.46.06.7a8.82,8.82,0,0,1-.21,2.09l-5.42-2.28S245.86,221.23,246,215.59Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.28,215.45c-2.26-.94-2.63-2.7,1.53-5.38,4.46-2.83,9-3.57,12.94-2.59l8.82-9.19v8.88L211.9,210l-.28.1c-1.44.56-2.84,1.13-4.18,1.68-.54.25-1.07.47-1.59.67a55.38,55.38,0,0,1-8.9,3.27,10,10,0,0,1-3.86.26A6.42,6.42,0,0,1,191.28,215.45Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.29,215.62l-2.35-1v-8.88l7.52,3.15C174.66,211.23,172.87,213.5,172.29,215.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,233.39l10.18-6.26V236l-10.2,6.29-7.52-3.18a48.78,48.78,0,0,1-14.36,4.71,38,38,0,0,1-9.21.37,38.85,38.85,0,0,1-5.29-.87v-8.89a36.19,36.19,0,0,0,14.5.51,48.5,48.5,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.42,239.12A37.16,37.16,0,0,1,219,243.8a30.69,30.69,0,0,1-12.13.4,58.5,58.5,0,0,0,12-1.4c2-.43,3.91-1,5.84-1.6S228.49,239.85,230.42,239.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.09,226.26v0c-.06-1.57.07-7.44,0-8.84.16,2.63,2.28,4.94,6.75,6.81,9.93,4.14,19.6,1.42,28.45-2.13,8.22-3.33,14.19-6.86,19-4.86,3,1.27,2.15,3.26-1.14,5.36a18.15,18.15,0,0,1-14.2,2.24l-7.32,7.54h0c-7.83,2.77-16.21,4.3-24.75.72C174.37,231.2,172.25,228.89,172.09,226.26Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.76 216.37 205.75 207.48 214.56 198.28 214.57 207.17 205.76 216.37",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.76 216.37 205.75 207.48 214.56 198.28 214.57 207.17 205.76 216.37",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.94 205.76 177.48 208.91 172.3 215.63 169.94 214.65 169.94 205.76",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.94 205.76 177.48 208.91 172.3 215.63 169.94 214.65 169.94 205.76",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.22,226.32l-5.83-2.46s5.73-2.77,5.62-8.68a5.07,5.07,0,0,0-.06-.7c-.3-2.49-2.37-4.72-6.58-6.47v0a27.06,27.06,0,0,0-13.47-1.79l-1.15.14h-.13l-1.19.2c-.35.06-.7.11-1.05.2-.15,0-.3.05-.42.09-.28,0-.55.1-.8.17a60.45,60.45,0,0,0-6.5,1.92c-1,.35-2,.74-3,1.14-1.44.56-2.85,1.14-4.2,1.69-.54.24-1.06.46-1.58.67a57.78,57.78,0,0,1-8.9,3.27,10.21,10.21,0,0,1-3.85.26,7.47,7.47,0,0,1-1.81-.5c-2.27-1-2.65-2.71,1.52-5.39,4.46-2.84,9.05-3.58,12.94-2.59l8.81-9.2c-8.66-1.65-17.92-.25-27,4.2L180,199.34l-10.06,6.42,7.54,3.15c-3.6,3-5.5,5.83-5.4,8.4v.07c.15,2.62,2.3,4.93,6.76,6.79,9.91,4.16,19.6,1.43,28.44-2.12,8.22-3.33,14.18-6.86,19-4.85,3,1.26,2.14,3.25-1.15,5.36a18.22,18.22,0,0,1-14.2,2.24l-9.38,9.64a39,39,0,0,0,5.3.87,38.59,38.59,0,0,0,9.21-.35,49,49,0,0,0,14.34-4.72l7.54,3.16,10.19-6.27Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.22,226.32l-5.83-2.46s5.73-2.77,5.62-8.68a5.07,5.07,0,0,0-.06-.7c-.3-2.49-2.37-4.72-6.58-6.47v0a27.06,27.06,0,0,0-13.47-1.79l-1.15.14h-.13l-1.19.2c-.35.06-.7.11-1.05.2-.15,0-.3.05-.42.09-.28,0-.55.1-.8.17a60.45,60.45,0,0,0-6.5,1.92c-1,.35-2,.74-3,1.14-1.44.56-2.85,1.14-4.2,1.69-.54.24-1.06.46-1.58.67a57.78,57.78,0,0,1-8.9,3.27,10.21,10.21,0,0,1-3.85.26,7.47,7.47,0,0,1-1.81-.5c-2.27-1-2.65-2.71,1.52-5.39,4.46-2.84,9.05-3.58,12.94-2.59l8.81-9.2c-8.66-1.65-17.92-.25-27,4.2L180,199.34l-10.06,6.42,7.54,3.15c-3.6,3-5.5,5.83-5.4,8.4v.07c.15,2.62,2.3,4.93,6.76,6.79,9.91,4.16,19.6,1.43,28.44-2.12,8.22-3.33,14.18-6.86,19-4.85,3,1.26,2.14,3.25-1.15,5.36a18.22,18.22,0,0,1-14.2,2.24l-9.38,9.64a39,39,0,0,0,5.3.87,38.59,38.59,0,0,0,9.21-.35,49,49,0,0,0,14.34-4.72l7.54,3.16,10.19-6.27Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.84,224.17a28.47,28.47,0,0,0,11.8,1.84,43.16,43.16,0,0,0,12.05-2.55c3.94-1.3,7.74-3,11.61-4.62a39.21,39.21,0,0,1,5.95-2,9.88,9.88,0,0,1,6,.35,9.83,9.83,0,0,0-6-.08,40,40,0,0,0-5.84,2.11c-3.82,1.66-7.64,3.41-11.61,4.76a42.27,42.27,0,0,1-12.23,2.45,28.13,28.13,0,0,1-6.1-.45A29.19,29.19,0,0,1,178.84,224.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.94 233.4 237.95 242.29 230.41 239.12 230.4 230.24 237.94 233.4",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.94 233.4 237.95 242.29 230.41 239.12 230.4 230.24 237.94 233.4",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.13 227.13 237.98 232.41 230.4 230.24 237.94 233.4 248.13 227.13",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.54 202.48 180.05 200.26 169.94 205.76 180 199.34 187.54 202.48",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.56,198.28a37.23,37.23,0,0,0-4.73-.56l1.24,4.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.18,224.3a27.48,27.48,0,0,0,13,1.83l-7.26-24.75-4.91-2-6.86,4.38,1.13,3.85,3.21,1.34a23.56,23.56,0,0,0-2.22,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.84,207.42a26.33,26.33,0,0,0-7.48-1.37l8,27.12,6-3.69L243,225l-2.6-1.1a11.22,11.22,0,0,0,1.91-1.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.62,206.35l-1.19.2c-.35.06-.7.11-1.05.2-.15,0-.3.05-.42.09-.28,0-.55.1-.8.17a60.45,60.45,0,0,0-6.5,1.92c-.46.16-.92.35-1.39.52l2.64,9c4.05-1.6,7.43-2.44,10.37-1.21s2.14,3.25-1.15,5.36a17.59,17.59,0,0,1-7.24,2.61l2.59,8.84a51.47,51.47,0,0,0,9.92-3.77l2.85,1.19-7.41-25.23-1.09.14Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "139.37 221.26 140.6 211.94 141.83 221.26 157.97 221.97 141.83 222.68 140.6 232 139.37 222.68 123.23 221.97 139.37 221.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.73 228.27 153.32 223.75 153.92 228.27 161.74 228.61 153.92 228.96 153.32 233.48 152.73 228.96 144.9 228.61 152.73 228.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.92 274.35 119.15 265.03 120.38 274.35 136.53 275.06 120.38 275.77 119.15 285.09 117.92 275.77 101.78 275.06 117.92 274.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.65 281.58 127.24 277.06 127.84 281.58 135.66 281.92 127.84 282.26 127.24 286.78 126.65 282.26 118.82 281.92 126.65 281.58",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.46,137a78.38,78.38,0,0,0,.61,10.1,76.92,76.92,0,0,0,55,64.16,77.47,77.47,0,0,0,21,3,77.49,77.49,0,0,0,16.08-1.61,77.17,77.17,0,0,0,49.28-34.2c.71-1.12,1.39-2.27,2.05-3.42a76.55,76.55,0,0,0,7.09-17.19h0c.56-2,1-4.1,1.44-6.2s.71-4.23.93-6.4q.39-3.75.4-7.59a76,76,0,0,0-.51-9.23q-.36-3.18-1-6.27a77,77,0,0,0-60.26-60.26c-2.06-.42-4.16-.75-6.28-1a75.74,75.74,0,0,0-8.58-.51,74.73,74.73,0,0,0-8.23.4c-2.16.21-4.3.53-6.4.93s-4.17.87-6.21,1.43a76.12,76.12,0,0,0-17.19,7.1c-1.16.65-2.31,1.33-3.43,2a77.42,77.42,0,0,0-28.46,32.2,76,76,0,0,0-5.73,17.09A77.55,77.55,0,0,0,115.46,137Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.46,137a78.38,78.38,0,0,0,.61,10.1,76.92,76.92,0,0,0,55,64.16,77.47,77.47,0,0,0,21,3,77.49,77.49,0,0,0,16.08-1.61,77.17,77.17,0,0,0,49.28-34.2c.71-1.12,1.39-2.27,2.05-3.42a76.55,76.55,0,0,0,7.09-17.19h0c.56-2,1-4.1,1.44-6.2s.71-4.23.93-6.4q.39-3.75.4-7.59a76,76,0,0,0-.51-9.23q-.36-3.18-1-6.27a77,77,0,0,0-60.26-60.26c-2.06-.42-4.16-.75-6.28-1a75.74,75.74,0,0,0-8.58-.51,74.73,74.73,0,0,0-8.23.4c-2.16.21-4.3.53-6.4.93s-4.17.87-6.21,1.43a76.12,76.12,0,0,0-17.19,7.1c-1.16.65-2.31,1.33-3.43,2a77.42,77.42,0,0,0-28.46,32.2,76,76,0,0,0-5.73,17.09A77.55,77.55,0,0,0,115.46,137Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.33,116c.58,2,1.09,4.08,1.51,6.18s.75,4.15,1,6.27a76,76,0,0,1,.51,9.23q0,3.84-.4,7.59-.33,3.26-.93,6.4c-.4,2.1-.88,4.16-1.44,6.2h0A76.55,76.55,0,0,1,259.48,175c-.66,1.15-1.34,2.3-2.05,3.42a76.76,76.76,0,0,1-65.36,35.81,77.63,77.63,0,0,1-8.4-.51Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.14,162.44A75.86,75.86,0,0,1,259.48,175c-.66,1.15-1.34,2.3-2.05,3.42a77.19,77.19,0,0,1-28.11,26.37Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.81,93.73a75.63,75.63,0,0,1,6.46,11.36l-90,106.49-1.22-.33a76.1,76.1,0,0,1-11-4.17Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,68.27a77.92,77.92,0,0,1,11.52,7L138.81,192.49A77.23,77.23,0,0,1,130,182.28Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.14,63.8q3.57,1.11,7,2.54L127.39,178.42c-1.32-2.09-2.57-4.23-3.69-6.45Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.68,131.76h0c.1-1.42.25-2.83.42-4.22.06-.47.11-.94.18-1.4s.14-1,.22-1.43c.18-1,.36-2.1.57-3.14A76.78,76.78,0,0,1,137.8,83.11a77.27,77.27,0,0,1,13.46-10.83c1.12-.71,2.27-1.39,3.43-2a76.12,76.12,0,0,1,17.19-7.1c.76-.21,1.52-.39,2.29-.58Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.07,137.32a57.32,57.32,0,0,0,53.49,57.2c1.26.08,2.56.13,3.85.13a57.34,57.34,0,0,0,0-114.67c-1.29,0-2.59,0-3.85.13A57.34,57.34,0,0,0,135.07,137.32Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.07,137.32a57.32,57.32,0,0,0,53.49,57.2c1.26.08,2.56.13,3.85.13a57.34,57.34,0,0,0,0-114.67c-1.29,0-2.59,0-3.85.13A57.34,57.34,0,0,0,135.07,137.32Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.62,137.32c0,1,0,2,.08,2.92a54.77,54.77,0,0,0,51,51.73l.75.05c1,0,1.94.08,2.92.08A54.72,54.72,0,0,0,247,142c.14-1.55.2-3.11.2-4.7s-.05-2.89-.16-4.31a53.16,53.16,0,0,0-1.4-8.73A54.87,54.87,0,0,0,205.44,84.1a53.16,53.16,0,0,0-8.73-1.4c-1.42-.11-2.86-.16-4.31-.16-1.23,0-2.46,0-3.67.12-.34,0-.68,0-1,.08a54.3,54.3,0,0,0-22.65,7.1,54.7,54.7,0,0,0-27.43,47.48Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.62,137.32c0,1,0,2,.08,2.92a54.77,54.77,0,0,0,51,51.73l.75.05c1,0,1.94.08,2.92.08A54.72,54.72,0,0,0,247,142c.14-1.55.2-3.11.2-4.7s-.05-2.89-.16-4.31a53.16,53.16,0,0,0-1.4-8.73A54.87,54.87,0,0,0,205.44,84.1a53.16,53.16,0,0,0-8.73-1.4c-1.42-.11-2.86-.16-4.31-.16-1.23,0-2.46,0-3.67.12-.34,0-.68,0-1,.08a54.3,54.3,0,0,0-22.65,7.1,54.7,54.7,0,0,0-27.43,47.48Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,176.19A54.41,54.41,0,0,0,247,142c.14-1.55.21-3.11.21-4.7s-.06-2.89-.17-4.31a53.16,53.16,0,0,0-1.4-8.73A54.87,54.87,0,0,0,205.44,84.1a53.16,53.16,0,0,0-8.73-1.4c-1.42-.11-2.86-.16-4.31-.16-1.23,0-2.46,0-3.67.12-.34,0-.68,0-1,.08a54.3,54.3,0,0,0-22.65,7.1,55.09,55.09,0,0,0-6.86,4.75,54.46,54.46,0,0,0-16.12,38.78c0,1,0,1.95.09,2.92a54.75,54.75,0,0,0,51,51.73l.74,0c1,.05,1.95.08,2.93.08a54.38,54.38,0,0,0,34.13-12Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,176.19A54.41,54.41,0,0,0,247,142c.14-1.55.21-3.11.21-4.7s-.06-2.89-.17-4.31a53.16,53.16,0,0,0-1.4-8.73A54.87,54.87,0,0,0,205.44,84.1a53.16,53.16,0,0,0-8.73-1.4c-1.42-.11-2.86-.16-4.31-.16-1.23,0-2.46,0-3.67.12-.34,0-.68,0-1,.08a54.3,54.3,0,0,0-22.65,7.1,55.09,55.09,0,0,0-6.86,4.75,54.46,54.46,0,0,0-16.12,38.78c0,1,0,1.95.09,2.92a54.75,54.75,0,0,0,51,51.73l.74,0c1,.05,1.95.08,2.93.08a54.38,54.38,0,0,0,34.13-12Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.69,70.24c33.11-17.15,60-8.23,78,2.47,26,17.45,42.4,46.68,33.43,85.31v-.08a75.94,75.94,0,0,1-19.54,34A77.56,77.56,0,0,0,267,157.64v.07c8.27-32-2.13-57.41-19.48-75.34C228.93,65.23,197.43,48.3,154.69,70.24Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.16,96.83l-.06,7.38s-7.59-1.34-16.24,5.49c-.36.29-.68.57-1,.85a16,16,0,0,0-5.52,12.55l0,0a16,16,0,0,0,5.6,12.64c.29.25.63.48.92.73l.09.09,1,.72a9.93,9.93,0,0,0,.94.59,4.35,4.35,0,0,0,.39.23,5.16,5.16,0,0,0,.75.43,43.79,43.79,0,0,0,6.8,2.92c1.15.4,2.34.76,3.53,1.09,1.72.49,3.44.94,5.08,1.36l2,.49c4.68,1.13,8.09,2.05,10.25,3.27a5.58,5.58,0,0,1,2.75,2.72,5.34,5.34,0,0,1,.38,2c0,2.87-2.39,5.19-8.89,5-6.92-.26-10.81-3-11.74-7.22l-19,3.56c2.87,8.7,10.6,14.38,22.73,16.46l0,9.51,15.64.58,0-9.51c6.57-.55,12-2.34,15.7-5.35l.1-.08a16.11,16.11,0,0,0,5.88-13.06c.06-12.53-9.89-17-20.54-19.92-9.95-2.67-18.8-3.33-18.78-9.42,0-3.8,3.48-5.38,8.6-5.2,8.17.29,11.35,5.11,12,8.61l20-3.63a21.87,21.87,0,0,0-2-5.15,20.78,20.78,0,0,0-6.15-6.85c-4.44-3.2-10.08-5-15.74-5.88l0-9.54-15.48-.86Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.16,96.83l-.06,7.38s-7.59-1.34-16.24,5.49c-.36.29-.68.57-1,.85a16,16,0,0,0-5.52,12.55l0,0a16,16,0,0,0,5.6,12.64c.29.25.63.48.92.73l.09.09,1,.72a9.93,9.93,0,0,0,.94.59,4.35,4.35,0,0,0,.39.23,5.16,5.16,0,0,0,.75.43,43.79,43.79,0,0,0,6.8,2.92c1.15.4,2.34.76,3.53,1.09,1.72.49,3.44.94,5.08,1.36l2,.49c4.68,1.13,8.09,2.05,10.25,3.27a5.58,5.58,0,0,1,2.75,2.72,5.34,5.34,0,0,1,.38,2c0,2.87-2.39,5.19-8.89,5-6.92-.26-10.81-3-11.74-7.22l-19,3.56c2.87,8.7,10.6,14.38,22.73,16.46l0,9.51,15.64.58,0-9.51c6.57-.55,12-2.34,15.7-5.35l.1-.08a16.11,16.11,0,0,0,5.88-13.06c.06-12.53-9.89-17-20.54-19.92-9.95-2.67-18.8-3.33-18.78-9.42,0-3.8,3.48-5.38,8.6-5.2,8.17.29,11.35,5.11,12,8.61l20-3.63a21.87,21.87,0,0,0-2-5.15,20.78,20.78,0,0,0-6.15-6.85c-4.44-3.2-10.08-5-15.74-5.88l0-9.54-15.48-.86Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.24,152.24a16.79,16.79,0,0,0-4.51-11.37c-2.78-3-6.74-5-11.14-6.56s-9.21-2.62-13.93-3.85a29.74,29.74,0,0,1-6.57-2.42,5.61,5.61,0,0,1-3.17-5.14c.07,2.29,1.56,3.83,3.53,4.8a31.14,31.14,0,0,0,6.7,2.18,131.9,131.9,0,0,1,14.12,3.69c4.38,1.61,8.42,3.68,11.11,6.82a15.6,15.6,0,0,1,3.06,5.32A21,21,0,0,1,222.24,152.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.19 94.4 198.18 96.36 199.62 104.8 199.67 95.26 184.19 94.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.92 170.15 186.23 178.57 200.54 180.24 184.91 179.66 184.92 170.15",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.19,153.69a21,21,0,0,0,2.07,4.36l5.46-5.77Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.22,151.83a16.15,16.15,0,0,0-5.25-12.3l-32.05,33.94,0,6.19,10.67.4,5-5.29v-4a43.93,43.93,0,0,0,4.37-.59Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.41,125a15.71,15.71,0,0,0,2.57,7.44L199.1,95.22l-9.12-.5-5.85,6.2,0,3.29a13.45,13.45,0,0,0-3.05,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.93,136.58l1,.72a9.93,9.93,0,0,0,.94.59,4.35,4.35,0,0,0,.39.23,5.16,5.16,0,0,0,.75.43,43.79,43.79,0,0,0,6.8,2.92c.53.18,1.08.33,1.62.5l11.61-12.29c-4.84-1.37-8.15-3.06-8.14-6.78s3.48-5.38,8.6-5.2a13.87,13.87,0,0,1,8.29,2.71l11.44-12.12a41.68,41.68,0,0,0-11.63-3.5l0-3.59L167,135.79c.28.24.6.47.87.7Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "143.19 91.23 144.46 74.51 145.73 91.23 162.45 92.5 145.73 93.78 144.46 110.49 143.19 93.78 126.47 92.5 143.19 91.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.3 104.95 156.92 96.84 157.53 104.95 165.64 105.56 157.53 106.18 156.92 114.28 156.3 106.18 148.2 105.56 156.3 104.95",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.55,365.53l8.47,0v17.33h0a23.25,23.25,0,0,1-.83,6.16c-.2.7-.44,1.4-.7,2.1a30.45,30.45,0,0,1-5.91,9.45,40.43,40.43,0,0,1-3,3,45.44,45.44,0,0,1-3.5,2.92A58.9,58.9,0,0,1,421,410c-1.92,1.17-3.92,2.26-6,3.29-1.58.77-3.2,1.5-4.88,2.19-24.52,10.13-58.33,11.36-85.31,3.14q-2.76-.84-5.4-1.81c-2.53-.93-5-1.94-7.35-3.05-1.94-.91-3.77-1.85-5.5-2.84-1.49-.85-2.91-1.73-4.24-2.63s-2.59-1.82-3.76-2.76h0a40.4,40.4,0,0,1-8.38-8.92c-.45-.67-.88-1.35-1.26-2a24.9,24.9,0,0,1-3.11-9.13,21.65,21.65,0,0,1-.17-2.91h0l0-16.39,7.75,0c.62-.67,1.27-1.34,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,89.34,89.34,0,0,1,9.43-3.85c22.18-7.67,50.42-8.7,74.42-2.74a106.86,106.86,0,0,1,10.37,3.12c2.79,1,5.49,2.1,8.08,3.31a71.33,71.33,0,0,1,10.64,6.08A48.85,48.85,0,0,1,431.55,365.53Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.39,422.32l0-35.18,12.88,1.35,0,35.21C349.93,423.44,345.62,423,341.39,422.32Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,382.83h0a23.25,23.25,0,0,1-.83,6.16c-.2.7-.44,1.4-.7,2.1a30.45,30.45,0,0,1-5.91,9.45c-.34.38-.7.75-1.06,1.13l0-36.2.06.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.07,366.66l6.61-1.56,0,52.72q-3.16,1-6.47,1.91Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,423l0-45.7,12.88,1,0,42.55A129.86,129.86,0,0,1,380,423Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.58,366.09l7.75,0c.62-.67,1.27-1.34,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,89.34,89.34,0,0,1,9.43-3.85q4.66-1.6,9.65-2.81l.06,73.39c-1.91-.47-3.8-1-5.65-1.55s-3.64-1.16-5.4-1.81c-2.53-.93-5-1.94-7.35-3.05-1.94-.91-3.77-1.85-5.5-2.84-1.49-.85-2.91-1.73-4.24-2.63s-2.59-1.82-3.76-2.76h0a40.4,40.4,0,0,1-8.38-8.92c-.45-.67-.88-1.35-1.26-2a24.9,24.9,0,0,1-3.11-9.13,21.65,21.65,0,0,1-.17-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.14,396.55c-.45-.67-.88-1.35-1.26-2a24.9,24.9,0,0,1-3.11-9.13,21.65,21.65,0,0,1-.17-2.91h0l0-16.39,7.75,0,.1-.1,2.61,1,0,36.46A38.1,38.1,0,0,1,290.14,396.55Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.58,334.69c-2.59-1.21-5.29-2.32-8.08-3.31a105,105,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34,34,0,0,0-6.87,8.93,23.1,23.1,0,0,0-2.65,13.93,25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40.5,40.5,0,0,0,8.39,8.93h0c1.18.94,2.43,1.87,3.76,2.77s2.75,1.77,4.25,2.63c1.72,1,3.56,1.93,5.49,2.83,2.36,1.11,4.82,2.13,7.35,3.05q2.65,1,5.41,1.81c27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.1-1,4.11-2.12,6-3.29s3.53-2.28,5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a38.34,38.34,0,0,0,3-3,30.71,30.71,0,0,0,5.92-9.46q.39-1.05.69-2.1a22.38,22.38,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.48,46.48,0,0,0-9.21-8.34A71.33,71.33,0,0,0,413.58,334.69Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.58,334.69c-2.59-1.21-5.29-2.32-8.08-3.31a105,105,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34,34,0,0,0-6.87,8.93,23.1,23.1,0,0,0-2.65,13.93,25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40.5,40.5,0,0,0,8.39,8.93h0c1.18.94,2.43,1.87,3.76,2.77s2.75,1.77,4.25,2.63c1.72,1,3.56,1.93,5.49,2.83,2.36,1.11,4.82,2.13,7.35,3.05q2.65,1,5.41,1.81c27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.1-1,4.11-2.12,6-3.29s3.53-2.28,5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a38.34,38.34,0,0,0,3-3,30.71,30.71,0,0,0,5.92-9.46q.39-1.05.69-2.1a22.38,22.38,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.48,46.48,0,0,0-9.21-8.34A71.33,71.33,0,0,0,413.58,334.69Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.58,334.69c-2.59-1.21-5.29-2.32-8.08-3.31a105,105,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34,34,0,0,0-6.87,8.93,23.1,23.1,0,0,0-2.65,13.93,25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40.5,40.5,0,0,0,8.39,8.93h0c1.18.94,2.43,1.87,3.76,2.77s2.75,1.77,4.25,2.63c1.72,1,3.56,1.93,5.49,2.83,2.36,1.11,4.82,2.13,7.35,3.05q2.65,1,5.41,1.81c27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.1-1,4.11-2.12,6-3.29s3.53-2.28,5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a38.34,38.34,0,0,0,3-3,30.71,30.71,0,0,0,5.92-9.46q.39-1.05.69-2.1a22.38,22.38,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.48,46.48,0,0,0-9.21-8.34A71.33,71.33,0,0,0,413.58,334.69Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.45,403.11c-1.92-.47-3.82-1-5.68-1.56s-3.64-1.16-5.41-1.81c-2.53-.92-5-1.94-7.35-3.05-1.93-.9-3.77-1.85-5.49-2.83-1.5-.86-2.91-1.73-4.25-2.63s-2.58-1.83-3.76-2.77h0a40.5,40.5,0,0,1-8.39-8.93c-.45-.67-.87-1.35-1.26-2a25.08,25.08,0,0,1-3.1-9.12,23.1,23.1,0,0,1,2.65-13.93,34,34,0,0,1,6.87-8.93,54.74,54.74,0,0,1,9.33-7.07c1.88-1.15,3.86-2.21,5.91-3.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,386.26a37.82,37.82,0,0,1-5.84-6.73c-.45-.67-.87-1.35-1.26-2a25.08,25.08,0,0,1-3.1-9.12,22.66,22.66,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.23,406.69c-4.34-.26-8.64-.73-12.86-1.38l-21.71-73.93,1-.38a107.42,107.42,0,0,1,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.88,403.76A129.86,129.86,0,0,1,380,406l-23.89-81.37c4.49-.2,9-.19,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.66,400.79q-3.2,1.05-6.52,1.93l-22.84-77.8c2.45.2,4.89.45,7.31.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.4,336.62h0c1,.54,2,1.09,2.93,1.66l.94.56.94.6c.68.44,1.36.88,2,1.33a46.48,46.48,0,0,1,9.21,8.34,27.47,27.47,0,0,1,6.37,13.6,22.38,22.38,0,0,1-.63,9.26q-.3,1-.69,2.1a30.71,30.71,0,0,1-5.92,9.46c-.33.38-.69.75-1.06,1.13Z",
    style: {
      fill: "#1976D2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.44,342.5C377.39,331.8,343,332.59,321.9,344c-.89.48-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.84-.52,1.66-1.06,2.42-1.6C426.86,371.51,423.5,353.2,400.44,342.5Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.44,342.5C377.39,331.8,343,332.59,321.9,344c-.89.48-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.84-.52,1.66-1.06,2.42-1.6C426.86,371.51,423.5,353.2,400.44,342.5Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.77,343.53c-.74-.34-1.5-.68-2.27-1-22-9.17-53.27-8.11-72.78,2.41l-.53.28c-.67.38-1.33.76-2,1.16a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.93,2.57,4,6.76,7.69,12.54,10.86,1.09.6,2.23,1.18,3.43,1.73s2.23,1,3.38,1.46a73.39,73.39,0,0,0,7.55,2.51c18.18,5,40.22,4.2,56.88-2.09a60.94,60.94,0,0,0,6.79-3c1-.54,2-1.1,3-1.69s1.59-1,2.32-1.53c.21-.14.41-.29.61-.44,4.86-3.56,8-7.55,9.49-11.67,2.52-7,.2-14.39-6.76-20.64A45.77,45.77,0,0,0,398.77,343.53Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.77,343.53c-.74-.34-1.5-.68-2.27-1-22-9.17-53.27-8.11-72.78,2.41l-.53.28c-.67.38-1.33.76-2,1.16a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.93,2.57,4,6.76,7.69,12.54,10.86,1.09.6,2.23,1.18,3.43,1.73s2.23,1,3.38,1.46a73.39,73.39,0,0,0,7.55,2.51c18.18,5,40.22,4.2,56.88-2.09a60.94,60.94,0,0,0,6.79-3c1-.54,2-1.1,3-1.69s1.59-1,2.32-1.53c.21-.14.41-.29.61-.44,4.86-3.56,8-7.55,9.49-11.67,2.52-7,.2-14.39-6.76-20.64A45.77,45.77,0,0,0,398.77,343.53Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.52,349c.78.31,1.53.65,2.27,1a45.12,45.12,0,0,1,11.26,7.19c4.07,3.64,6.54,7.67,7.4,11.79a17.21,17.21,0,0,1-.66,2.38c-1.48,4.12-4.63,8.11-9.49,11.67-.2.15-.4.3-.61.44-.73.52-1.51,1-2.32,1.53s-1.94,1.15-3,1.69a60.94,60.94,0,0,1-6.79,3c-16.66,6.29-38.7,7.1-56.88,2.09a73.39,73.39,0,0,1-7.55-2.51c-1.15-.46-2.28-.94-3.38-1.46s-2.34-1.13-3.43-1.73c-5.78-3.17-10-6.89-12.54-10.86a18.86,18.86,0,0,1-2.69-6.36,19.63,19.63,0,0,1,3.87-8.11,34.43,34.43,0,0,1,9.22-7.93c.64-.4,1.31-.78,2-1.15l.53-.29C343.26,340.89,374.56,339.83,396.52,349Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.52,349c.78.31,1.53.65,2.27,1a45.12,45.12,0,0,1,11.26,7.19c4.07,3.64,6.54,7.67,7.4,11.79a17.21,17.21,0,0,1-.66,2.38c-1.48,4.12-4.63,8.11-9.49,11.67-.2.15-.4.3-.61.44-.73.52-1.51,1-2.32,1.53s-1.94,1.15-3,1.69a60.94,60.94,0,0,1-6.79,3c-16.66,6.29-38.7,7.1-56.88,2.09a73.39,73.39,0,0,1-7.55-2.51c-1.15-.46-2.28-.94-3.38-1.46s-2.34-1.13-3.43-1.73c-5.78-3.17-10-6.89-12.54-10.86a18.86,18.86,0,0,1-2.69-6.36,19.63,19.63,0,0,1,3.87-8.11,34.43,34.43,0,0,1,9.22-7.93c.64-.4,1.31-.78,2-1.15l.53-.29C343.26,340.89,374.56,339.83,396.52,349Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.48,374.07c-8.74,19.43-33.19,27.18-53.12,30.68-30.3,4.36-63.28.71-86.71-16.53l.05,0c-6.37-5-11.8-11.73-12.94-19.87,1,8.22,6.24,15.17,12.61,20.32l0,0c18.87,14.63,45,19.37,70,18.67C393.52,405.86,427.05,399.09,438.48,374.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,380c8.56,3.59,17,2,24.77-.74l-2.06,2.12v8.89a37.08,37.08,0,0,0,5.29.86,38.59,38.59,0,0,0,9.21-.34,49.22,49.22,0,0,0,14.35-4.73l7.54,3.17L400.32,383v-8.88l-1.91-.82-.42-.18a8.08,8.08,0,0,0,.21-2.07,5.07,5.07,0,0,0-.06-.7c-.13-1.1.1-6.12.06-8.19,0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.58-6.47v0a27.27,27.27,0,0,0-13.47-1.79l-1.15.14h-.12l-1.2.2c-.35.06-.7.12-1.05.2-.14,0-.29.05-.42.09s-.55.1-.8.17a62.64,62.64,0,0,0-6.49,1.92c-.94.33-1.87.68-2.78,1l2.69-2.8v-8.89c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.42v8.89l2.36,1a5.25,5.25,0,0,0-.22,1.68v.07c.07,1.38-.06,7.26,0,8.82v.07C324.42,375.83,326.57,378.15,331,380Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.19,362.54c0,2.28-.16,6.75,0,7.77,0,.24,0,.46.06.71a8.3,8.3,0,0,1-.22,2.08l-5.42-2.28S398,368.18,398.19,362.54Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.47,362.41c-2.26-1-2.64-2.71,1.52-5.39,4.46-2.83,9.05-3.57,12.95-2.59l8.82-9.19,0,8.88-2.66,2.8c-.1,0-.17.07-.27.11-1.45.55-2.85,1.12-4.19,1.67-.54.25-1.07.47-1.59.67a55.34,55.34,0,0,1-8.89,3.27,10.07,10.07,0,0,1-3.86.27A7.16,7.16,0,0,1,343.47,362.41Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.47,362.57l-2.34-1v-8.88l7.51,3.15C326.85,358.18,325.06,360.45,324.47,362.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.13,380.34l10.19-6.26V383l-10.2,6.29-7.52-3.18a48.79,48.79,0,0,1-14.36,4.72,36.15,36.15,0,0,1-14.5-.51v-8.89a36.15,36.15,0,0,0,14.5.51,48.5,48.5,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.61,386.07a37.16,37.16,0,0,1-11.44,4.68,30.51,30.51,0,0,1-12.13.4,58.49,58.49,0,0,0,11.95-1.4c2-.43,3.91-1,5.85-1.6S380.68,386.8,382.61,386.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.27,373.21v0c-.07-1.57.07-7.44,0-8.84.16,2.63,2.29,4.94,6.75,6.81,9.94,4.14,19.61,1.42,28.46-2.13,8.21-3.33,14.18-6.86,19-4.86,3,1.27,2.15,3.26-1.13,5.36a18.15,18.15,0,0,1-14.2,2.24l-7.32,7.54h0c-7.84,2.77-16.22,4.3-24.76.73C326.56,378.15,324.43,375.84,324.27,373.21Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.94 363.32 357.94 354.43 366.75 345.23 366.75 354.12 357.94 363.32",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.94 363.32 357.94 354.43 366.75 345.23 366.75 354.12 357.94 363.32",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.12 352.71 329.66 355.86 324.49 362.58 322.13 361.6 322.12 352.71",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.12 352.71 329.66 355.86 324.49 362.58 322.13 361.6 322.12 352.71",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.41,373.27l-5.83-2.46s5.73-2.77,5.62-8.68c0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.58-6.47v0a27.27,27.27,0,0,0-13.47-1.79l-1.15.14h-.12l-1.2.2c-.35.06-.7.12-1.05.2-.15,0-.29.05-.42.09s-.55.1-.8.17a62.64,62.64,0,0,0-6.49,1.92c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.69l-1.59.67a57,57,0,0,1-8.9,3.27,10.18,10.18,0,0,1-3.85.26,8.08,8.08,0,0,1-1.81-.49c-2.27-1-2.65-2.72,1.53-5.4,4.45-2.84,9-3.58,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.42,7.54,3.15c-3.6,3-5.49,5.83-5.39,8.4v.07c.15,2.62,2.29,4.93,6.76,6.8,9.91,4.15,19.59,1.42,28.43-2.13,8.22-3.33,14.19-6.86,19-4.85,3,1.26,2.14,3.25-1.15,5.36a18.19,18.19,0,0,1-14.19,2.24l-9.38,9.64a36.42,36.42,0,0,0,14.51.52,49.25,49.25,0,0,0,14.34-4.72l7.54,3.16,10.19-6.26Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.41,373.27l-5.83-2.46s5.73-2.77,5.62-8.68c0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.58-6.47v0a27.27,27.27,0,0,0-13.47-1.79l-1.15.14h-.12l-1.2.2c-.35.06-.7.12-1.05.2-.15,0-.29.05-.42.09s-.55.1-.8.17a62.64,62.64,0,0,0-6.49,1.92c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.69l-1.59.67a57,57,0,0,1-8.9,3.27,10.18,10.18,0,0,1-3.85.26,8.08,8.08,0,0,1-1.81-.49c-2.27-1-2.65-2.72,1.53-5.4,4.45-2.84,9-3.58,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.42,7.54,3.15c-3.6,3-5.49,5.83-5.39,8.4v.07c.15,2.62,2.29,4.93,6.76,6.8,9.91,4.15,19.59,1.42,28.43-2.13,8.22-3.33,14.19-6.86,19-4.85,3,1.26,2.14,3.25-1.15,5.36a18.19,18.19,0,0,1-14.19,2.24l-9.38,9.64a36.42,36.42,0,0,0,14.51.52,49.25,49.25,0,0,0,14.34-4.72l7.54,3.16,10.19-6.26Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,371.13a28.41,28.41,0,0,0,11.8,1.83,43.09,43.09,0,0,0,12-2.55c3.95-1.3,7.74-3,11.61-4.62a39,39,0,0,1,6-2,9.84,9.84,0,0,1,6,.35,9.8,9.8,0,0,0-6-.08,40.08,40.08,0,0,0-5.85,2.11c-3.82,1.66-7.63,3.41-11.6,4.76a42.35,42.35,0,0,1-12.23,2.46,28.91,28.91,0,0,1-6.11-.46A29.29,29.29,0,0,1,331,371.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.13 380.35 390.14 389.24 382.6 386.07 382.59 377.19 390.13 380.35",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.13 380.35 390.14 389.24 382.6 386.07 382.59 377.19 390.13 380.35",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.32 374.08 390.17 379.36 382.59 377.19 390.13 380.35 400.32 374.08",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.73 349.43 332.23 347.21 322.12 352.71 332.19 346.29 339.73 349.43",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.75,345.23a39.38,39.38,0,0,0-4.73-.56l1.23,4.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.37,371.25a27.45,27.45,0,0,0,13,1.83l-7.27-24.75-4.9-2-6.87,4.38,1.14,3.85,3.2,1.34a26.27,26.27,0,0,0-2.21,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,354.37a26.33,26.33,0,0,0-7.49-1.37l8,27.12,6-3.69-1.33-4.52-2.6-1.1a11,11,0,0,0,1.9-1.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.81,353.3l-1.2.2c-.35.06-.7.12-1.05.2-.14,0-.29.05-.42.09s-.55.1-.8.17a62.64,62.64,0,0,0-6.49,1.92c-.47.16-.93.35-1.39.52l2.63,9c4.05-1.59,7.43-2.44,10.37-1.21s2.14,3.25-1.15,5.36a17.59,17.59,0,0,1-7.24,2.61l2.6,8.84a52,52,0,0,0,9.92-3.77l2.84,1.19L378,353.15l-1.1.14Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.43,344.48l8.47,0v17.34h0a23.18,23.18,0,0,1-.83,6.15c-.2.7-.44,1.4-.7,2.1a30.49,30.49,0,0,1-5.91,9.46,40.34,40.34,0,0,1-3,3,43.27,43.27,0,0,1-3.5,2.92,58.9,58.9,0,0,1-5.1,3.47c-1.92,1.17-3.92,2.27-6,3.29-1.58.77-3.2,1.51-4.88,2.19-24.52,10.13-58.33,11.37-85.31,3.14q-2.76-.84-5.4-1.81c-2.53-.92-5-1.94-7.35-3q-2.91-1.37-5.5-2.84c-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.75-2.77h0A40.51,40.51,0,0,1,280,375.5c-.44-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.68,23.68,0,0,1-.18-2.91h0V345.05l7.75,0c.62-.68,1.27-1.35,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,90.62,90.62,0,0,1,9.43-3.85c22.18-7.66,50.42-8.7,74.42-2.74q5.36,1.33,10.37,3.12c2.79,1,5.49,2.1,8.08,3.31a71.35,71.35,0,0,1,10.64,6.09A49.31,49.31,0,0,1,421.43,344.48Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.27,401.27l0-35.17,12.88,1.34,0,35.22C339.81,402.4,335.5,401.93,331.27,401.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.9,361.79h0a23.18,23.18,0,0,1-.83,6.15c-.2.7-.44,1.4-.7,2.1a30.49,30.49,0,0,1-5.91,9.46c-.34.38-.7.75-1.06,1.12l0-36.19.06.05,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,345.62l6.61-1.57,0,52.72q-3.16,1.05-6.47,1.92Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.91,401.92l0-45.69,12.88.94,0,42.56C378.6,400.66,374.29,401.39,369.91,401.92Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.46,345.05l7.75,0c.62-.68,1.27-1.35,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,90.62,90.62,0,0,1,9.43-3.85c3.1-1.07,6.33-2,9.64-2.81l.06,73.4c-1.9-.48-3.79-1-5.64-1.56s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.94-7.35-3q-2.91-1.37-5.5-2.84c-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.75-2.77h0A40.51,40.51,0,0,1,280,375.5c-.44-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.68,23.68,0,0,1-.18-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,375.5c-.44-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.68,23.68,0,0,1-.18-2.91h0V345.05l7.75,0a.94.94,0,0,1,.1-.1l2.61.95,0,36.45A38.23,38.23,0,0,1,280,375.5Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.46,313.64c-2.59-1.21-5.29-2.31-8.08-3.31-3.34-1.19-6.81-2.23-10.37-3.12-24-6-52.24-4.92-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93,23.13,23.13,0,0,0-2.65,13.93,25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.35,1.26,2a40.23,40.23,0,0,0,8.39,8.92h0q1.77,1.43,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3q2.64,1,5.41,1.82c27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.2q3.15-1.53,6-3.29a55.88,55.88,0,0,0,5.09-3.47,45.27,45.27,0,0,0,3.51-2.92,38.34,38.34,0,0,0,3-3,30.56,30.56,0,0,0,5.91-9.45c.27-.7.5-1.4.7-2.11a22.53,22.53,0,0,0,.63-9.26,27.51,27.51,0,0,0-6.37-13.6,46.24,46.24,0,0,0-9.22-8.33A70.72,70.72,0,0,0,403.46,313.64Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.46,313.64c-2.59-1.21-5.29-2.31-8.08-3.31-3.34-1.19-6.81-2.23-10.37-3.12-24-6-52.24-4.92-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93,23.13,23.13,0,0,0-2.65,13.93,25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.35,1.26,2a40.23,40.23,0,0,0,8.39,8.92h0q1.77,1.43,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3q2.64,1,5.41,1.82c27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.2q3.15-1.53,6-3.29a55.88,55.88,0,0,0,5.09-3.47,45.27,45.27,0,0,0,3.51-2.92,38.34,38.34,0,0,0,3-3,30.56,30.56,0,0,0,5.91-9.45c.27-.7.5-1.4.7-2.11a22.53,22.53,0,0,0,.63-9.26,27.51,27.51,0,0,0-6.37-13.6,46.24,46.24,0,0,0-9.22-8.33A70.72,70.72,0,0,0,403.46,313.64Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.46,313.64c-2.59-1.21-5.29-2.31-8.08-3.31-3.34-1.19-6.81-2.23-10.37-3.12-24-6-52.24-4.92-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93,23.13,23.13,0,0,0-2.65,13.93,25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.35,1.26,2a40.23,40.23,0,0,0,8.39,8.92h0q1.77,1.43,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3q2.64,1,5.41,1.82c27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.2q3.15-1.53,6-3.29a55.88,55.88,0,0,0,5.09-3.47,45.27,45.27,0,0,0,3.51-2.92,38.34,38.34,0,0,0,3-3,30.56,30.56,0,0,0,5.91-9.45c.27-.7.5-1.4.7-2.11a22.53,22.53,0,0,0,.63-9.26,27.51,27.51,0,0,0-6.37-13.6,46.24,46.24,0,0,0-9.22-8.33A70.72,70.72,0,0,0,403.46,313.64Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.33,382.07c-1.92-.48-3.82-1-5.68-1.56s-3.65-1.17-5.41-1.82c-2.53-.92-5-1.93-7.35-3-1.93-.91-3.77-1.85-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.77h0a40.23,40.23,0,0,1-8.39-8.92c-.45-.68-.87-1.35-1.26-2a25,25,0,0,1-3.1-9.12,23.13,23.13,0,0,1,2.65-13.93,34.35,34.35,0,0,1,6.87-8.93,54.34,54.34,0,0,1,9.33-7.07c1.88-1.14,3.86-2.21,5.91-3.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.83,365.21a38.46,38.46,0,0,1-5.83-6.72c-.45-.68-.87-1.35-1.26-2a25,25,0,0,1-3.1-9.12,22.66,22.66,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.11,385.65c-4.34-.27-8.64-.73-12.87-1.39l-21.7-73.93,1-.38c3.34-1.15,6.83-2.14,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.76,382.72c-4.18.93-8.49,1.66-12.87,2.19L346,303.53c4.49-.2,9-.18,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.54,379.74q-3.19,1.06-6.52,1.93l-22.84-77.8c2.45.2,4.89.45,7.31.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.28,315.57h0c1,.55,2,1.1,2.93,1.66l.94.57c.32.19.63.39.94.59.68.44,1.36.89,2,1.34a46.24,46.24,0,0,1,9.22,8.33,27.51,27.51,0,0,1,6.37,13.6,22.53,22.53,0,0,1-.63,9.26c-.2.71-.43,1.41-.7,2.11a30.56,30.56,0,0,1-5.91,9.45c-.33.38-.69.76-1.06,1.13Z",
    style: {
      fill: "#1976D2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.32,321.45c-23.05-10.7-57.42-9.9-78.54,1.49-.89.48-1.78,1-2.63,1.51-20.79,12.8-18.17,32.22,5.86,43.38s60.38,9.83,81.18-3c.84-.52,1.65-1.06,2.42-1.6C416.74,350.47,413.38,332.16,390.32,321.45Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.32,321.45c-23.05-10.7-57.42-9.9-78.54,1.49-.89.48-1.78,1-2.63,1.51-20.79,12.8-18.17,32.22,5.86,43.38s60.38,9.83,81.18-3c.84-.52,1.65-1.06,2.42-1.6C416.74,350.47,413.38,332.16,390.32,321.45Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.65,322.49c-.74-.35-1.5-.68-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.53.29c-.67.37-1.34.76-2,1.15a34.42,34.42,0,0,0-9.21,7.94c-5.22,6.69-5.54,14.17-1.16,20.93,2.57,4,6.76,7.68,12.54,10.85,1.08.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a71.05,71.05,0,0,0,7.55,2.51c18.18,5,40.22,4.21,56.88-2.09a59.16,59.16,0,0,0,6.79-3c1-.53,2-1.1,3-1.68s1.58-1,2.32-1.53c.21-.15.41-.29.61-.45,4.86-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.39-6.76-20.64A45.48,45.48,0,0,0,388.65,322.49Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.65,322.49c-.74-.35-1.5-.68-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.53.29c-.67.37-1.34.76-2,1.15a34.42,34.42,0,0,0-9.21,7.94c-5.22,6.69-5.54,14.17-1.16,20.93,2.57,4,6.76,7.68,12.54,10.85,1.08.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a71.05,71.05,0,0,0,7.55,2.51c18.18,5,40.22,4.21,56.88-2.09a59.16,59.16,0,0,0,6.79-3c1-.53,2-1.1,3-1.68s1.58-1,2.32-1.53c.21-.15.41-.29.61-.45,4.86-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.39-6.76-20.64A45.48,45.48,0,0,0,388.65,322.49Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.4,328c.78.32,1.53.65,2.27,1a45.39,45.39,0,0,1,11.26,7.18c4.07,3.65,6.54,7.68,7.4,11.8a17.6,17.6,0,0,1-.66,2.38c-1.48,4.11-4.63,8.1-9.49,11.66-.2.16-.4.3-.61.45-.74.51-1.51,1-2.32,1.53s-1.94,1.15-3,1.68a59.16,59.16,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.09a71.05,71.05,0,0,1-7.55-2.51c-1.15-.45-2.28-.94-3.38-1.45s-2.35-1.14-3.43-1.74c-5.78-3.17-10-6.89-12.54-10.85a18.94,18.94,0,0,1-2.69-6.36,19.57,19.57,0,0,1,3.87-8.11,34.73,34.73,0,0,1,9.21-7.94c.65-.39,1.31-.78,2-1.15l.53-.29C333.13,319.85,364.44,318.78,386.4,328Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.4,328c.78.32,1.53.65,2.27,1a45.39,45.39,0,0,1,11.26,7.18c4.07,3.65,6.54,7.68,7.4,11.8a17.6,17.6,0,0,1-.66,2.38c-1.48,4.11-4.63,8.1-9.49,11.66-.2.16-.4.3-.61.45-.74.51-1.51,1-2.32,1.53s-1.94,1.15-3,1.68a59.16,59.16,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.09a71.05,71.05,0,0,1-7.55-2.51c-1.15-.45-2.28-.94-3.38-1.45s-2.35-1.14-3.43-1.74c-5.78-3.17-10-6.89-12.54-10.85a18.94,18.94,0,0,1-2.69-6.36,19.57,19.57,0,0,1,3.87-8.11,34.73,34.73,0,0,1,9.21-7.94c.65-.39,1.31-.78,2-1.15l.53-.29C333.13,319.85,364.44,318.78,386.4,328Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.35,353c-8.73,19.43-33.18,27.18-53.11,30.68-30.3,4.35-63.28.7-86.71-16.54l.05,0c-6.37-5-11.8-11.73-12.94-19.87,1,8.23,6.24,15.18,12.61,20.33l0,0c18.87,14.63,45,19.36,70,18.66C383.39,384.82,416.93,378,428.35,353Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.91,359c8.56,3.58,16.95,2,24.77-.74l-2.06,2.12v8.88a35.77,35.77,0,0,0,5.29.87,38.59,38.59,0,0,0,9.21-.35A49,49,0,0,0,372.47,365l7.55,3.16,10.18-6.26V353l-1.92-.82-.41-.17a8.16,8.16,0,0,0,.21-2.08,5.21,5.21,0,0,0-.06-.7c-.13-1.1.09-6.11.06-8.18,0-.25,0-.48-.07-.71-.3-2.48-2.36-4.71-6.58-6.46v0A27.29,27.29,0,0,0,368,332.1l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.2l-.42.09c-.27.05-.55.11-.8.18a62.61,62.61,0,0,0-6.49,1.91c-.94.33-1.87.68-2.78,1.05l2.68-2.81v-8.88c-8.67-1.66-17.92-.25-27,4.2l-7.55-3.15L312,331.67v8.89l2.36,1a5.49,5.49,0,0,0-.23,1.68v.07c.07,1.38-.06,7.26,0,8.82v.06C314.3,354.79,316.45,357.1,320.91,359Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.07,341.5c0,2.27-.16,6.75-.05,7.76,0,.25.05.47.07.71a8.33,8.33,0,0,1-.22,2.09l-5.42-2.28S387.92,347.13,388.07,341.5Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.35,341.36c-2.26-.95-2.64-2.71,1.52-5.39,4.46-2.82,9.05-3.56,12.95-2.58l8.82-9.19,0,8.87-2.66,2.8c-.1,0-.17.08-.27.11-1.45.55-2.85,1.13-4.19,1.68-.54.24-1.07.46-1.59.67a55.16,55.16,0,0,1-8.9,3.26,9.81,9.81,0,0,1-3.85.27A7.16,7.16,0,0,1,333.35,341.36Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.35,341.53l-2.35-1,0-8.88,7.51,3.15C316.73,337.13,314.94,339.4,314.35,341.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,359.3,390.2,353v8.89L380,368.2,372.49,365a48.5,48.5,0,0,1-14.36,4.72,36.15,36.15,0,0,1-14.5-.51v-8.88a36,36,0,0,0,14.5.5,48.78,48.78,0,0,0,14.36-4.71Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.49,365a36.94,36.94,0,0,1-11.44,4.69,30.51,30.51,0,0,1-12.13.39,57.12,57.12,0,0,0,11.95-1.4c2-.43,3.91-1,5.85-1.6S370.56,365.76,372.49,365Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.15,352.17v-.05c-.07-1.57.07-7.45,0-8.84.16,2.63,2.28,4.94,6.75,6.8,9.94,4.15,19.61,1.42,28.46-2.13,8.21-3.32,14.18-6.85,19-4.85,3,1.26,2.15,3.26-1.13,5.36a18.19,18.19,0,0,1-14.2,2.23l-7.32,7.55h0c-7.83,2.77-16.21,4.29-24.75.72C316.43,357.11,314.31,354.79,314.15,352.17Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.82 342.27 347.82 333.39 356.63 324.19 356.63 333.07 347.82 342.27",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.82 342.27 347.82 333.39 356.63 324.19 356.63 333.07 347.82 342.27",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312 331.67 319.54 334.81 314.37 341.54 312.01 340.56 312 331.67",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312 331.67 319.54 334.81 314.37 341.54 312.01 340.56 312 331.67",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.28,352.22l-5.82-2.45s5.73-2.77,5.62-8.68c0-.25,0-.48-.07-.71-.3-2.48-2.36-4.71-6.58-6.46v0A27.29,27.29,0,0,0,368,332.1l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.2l-.42.09c-.27.05-.55.11-.8.18a62.61,62.61,0,0,0-6.49,1.91c-1,.36-2,.74-3,1.14-1.45.56-2.86,1.15-4.2,1.7l-1.59.67a55.79,55.79,0,0,1-8.9,3.26,10.2,10.2,0,0,1-3.85.27,8.1,8.1,0,0,1-1.81-.5c-2.27-.95-2.65-2.72,1.53-5.4,4.45-2.84,9-3.57,12.94-2.58l8.81-9.2c-8.67-1.66-17.92-.25-27,4.2l-7.55-3.15L312,331.67l7.54,3.14c-3.6,3-5.49,5.84-5.4,8.41v.07c.14,2.61,2.29,4.93,6.75,6.79,9.92,4.15,19.6,1.43,28.44-2.13,8.22-3.33,14.19-6.86,19-4.84,3,1.26,2.14,3.25-1.15,5.35A18.19,18.19,0,0,1,353,350.7l-9.38,9.65a37.22,37.22,0,0,0,5.3.86,38,38,0,0,0,9.2-.35,48.92,48.92,0,0,0,14.35-4.72l7.54,3.17L390.19,353Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.28,352.22l-5.82-2.45s5.73-2.77,5.62-8.68c0-.25,0-.48-.07-.71-.3-2.48-2.36-4.71-6.58-6.46v0A27.29,27.29,0,0,0,368,332.1l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.2l-.42.09c-.27.05-.55.11-.8.18a62.61,62.61,0,0,0-6.49,1.91c-1,.36-2,.74-3,1.14-1.45.56-2.86,1.15-4.2,1.7l-1.59.67a55.79,55.79,0,0,1-8.9,3.26,10.2,10.2,0,0,1-3.85.27,8.1,8.1,0,0,1-1.81-.5c-2.27-.95-2.65-2.72,1.53-5.4,4.45-2.84,9-3.57,12.94-2.58l8.81-9.2c-8.67-1.66-17.92-.25-27,4.2l-7.55-3.15L312,331.67l7.54,3.14c-3.6,3-5.49,5.84-5.4,8.41v.07c.14,2.61,2.29,4.93,6.75,6.79,9.92,4.15,19.6,1.43,28.44-2.13,8.22-3.33,14.19-6.86,19-4.84,3,1.26,2.14,3.25-1.15,5.35A18.19,18.19,0,0,1,353,350.7l-9.38,9.65a37.22,37.22,0,0,0,5.3.86,38,38,0,0,0,9.2-.35,48.92,48.92,0,0,0,14.35-4.72l7.54,3.17L390.19,353Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.9,350.08a28.49,28.49,0,0,0,11.81,1.84,43.81,43.81,0,0,0,12-2.55c3.95-1.3,7.74-3,11.61-4.63a40.08,40.08,0,0,1,6-2,9.92,9.92,0,0,1,6,.36,9.8,9.8,0,0,0-6-.09,39,39,0,0,0-5.85,2.12c-3.82,1.66-7.63,3.4-11.6,4.76a42.4,42.4,0,0,1-12.23,2.45,28.91,28.91,0,0,1-6.11-.46A29.61,29.61,0,0,1,320.9,350.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.01 359.31 380.02 368.19 372.47 365.03 372.47 356.14 380.01 359.31",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.01 359.31 380.02 368.19 372.47 365.03 372.47 356.14 380.01 359.31",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.19 353.04 380.05 358.31 372.47 356.14 380.01 359.31 390.19 353.04",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.61 328.39 322.11 326.16 312 331.67 322.06 325.24 329.61 328.39",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.63,324.19a37.39,37.39,0,0,0-4.74-.56l1.24,4.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.25,350.21a27.57,27.57,0,0,0,13,1.83L327,327.29l-4.91-2.05-6.86,4.38,1.13,3.86,3.21,1.33a24.84,24.84,0,0,0-2.21,2.05Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.91,333.32a26.37,26.37,0,0,0-7.49-1.36l8,27.12,6-3.7-1.32-4.52-2.6-1.09a11,11,0,0,0,1.9-1.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.69,332.26l-1.2.19c-.35.06-.7.12-1.05.2l-.42.09c-.27.05-.55.11-.8.18a62.61,62.61,0,0,0-6.49,1.91l-1.39.52,2.63,9c4-1.6,7.43-2.44,10.37-1.21s2.14,3.25-1.15,5.35a17.76,17.76,0,0,1-7.24,2.62l2.6,8.83a51.31,51.31,0,0,0,9.92-3.77l2.84,1.2-7.4-25.23-1.1.14Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.78,322.44l8.47,0v17.33h0a22.46,22.46,0,0,1-.83,6.16c-.2.7-.43,1.4-.7,2.1a30.6,30.6,0,0,1-5.91,9.46,42.15,42.15,0,0,1-3,3c-1.08,1-2.25,2-3.51,2.92a58.9,58.9,0,0,1-5.1,3.47c-1.91,1.17-3.92,2.26-6,3.29q-2.37,1.16-4.87,2.19C367.8,382.47,334,383.7,307,375.48q-2.76-.84-5.4-1.81c-2.53-.92-5-1.94-7.35-3.05-1.93-.91-3.77-1.85-5.5-2.83-1.49-.86-2.91-1.73-4.24-2.64s-2.58-1.82-3.76-2.76h0a40.48,40.48,0,0,1-8.39-8.93c-.45-.67-.87-1.35-1.26-2a25.1,25.1,0,0,1-3.11-9.12,23.67,23.67,0,0,1-.17-2.91h0l0-16.39,7.75,0c.62-.68,1.27-1.35,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,88.65,88.65,0,0,1,9.44-3.85c22.17-7.67,50.42-8.7,74.41-2.74a107.91,107.91,0,0,1,10.38,3.12c2.78,1,5.48,2.1,8.07,3.31a71.33,71.33,0,0,1,10.64,6.08A48.35,48.35,0,0,1,413.78,322.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.62,379.23l0-35.18,12.88,1.35,0,35.22C332.16,380.35,327.85,379.89,323.62,379.23Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.25,339.74h0a22.46,22.46,0,0,1-.83,6.16c-.2.7-.43,1.4-.7,2.1a30.6,30.6,0,0,1-5.91,9.46c-.33.37-.69.75-1.05,1.12l0-36.2.06.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.3,323.57l6.61-1.56,0,52.72c-2.11.7-4.27,1.33-6.47,1.91Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.26,379.88l0-45.7,12.88.95,0,42.55A129.86,129.86,0,0,1,362.26,379.88Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.81,323l7.75,0c.62-.68,1.27-1.35,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,88.65,88.65,0,0,1,9.44-3.85c3.1-1.07,6.33-2,9.64-2.81l.06,73.39c-1.91-.47-3.8-1-5.65-1.55s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.94-7.35-3.05-1.93-.91-3.77-1.85-5.5-2.83-1.49-.86-2.91-1.73-4.24-2.64s-2.58-1.82-3.76-2.76h0a40.48,40.48,0,0,1-8.39-8.93c-.45-.67-.87-1.35-1.26-2a25.1,25.1,0,0,1-3.11-9.12,23.67,23.67,0,0,1-.17-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.37,353.46c-.45-.67-.87-1.35-1.26-2a25.1,25.1,0,0,1-3.11-9.12,23.67,23.67,0,0,1-.17-2.91h0l0-16.39,7.75,0a.94.94,0,0,1,.1-.1l2.61.94,0,36.46A38.1,38.1,0,0,1,272.37,353.46Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.81,291.6c-2.59-1.21-5.29-2.32-8.08-3.31a106.86,106.86,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.41,2.74a88.65,88.65,0,0,0-9.44,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.4,34.4,0,0,0-6.87,8.93A23.25,23.25,0,0,0,268,325.29a24.91,24.91,0,0,0,3.11,9.12c.38.68.8,1.36,1.25,2a40.28,40.28,0,0,0,8.39,8.93h0q1.75,1.42,3.75,2.77c1.34.9,2.75,1.78,4.25,2.63,1.73,1,3.56,1.93,5.49,2.83q3.56,1.66,7.35,3,2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14q2.51-1,4.88-2.19c2.1-1,4.1-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,40.34,40.34,0,0,0,3-3,30.67,30.67,0,0,0,5.91-9.46c.26-.7.5-1.4.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.2,46.2,0,0,0-9.21-8.34A71.33,71.33,0,0,0,395.81,291.6Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.81,291.6c-2.59-1.21-5.29-2.32-8.08-3.31a106.86,106.86,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.41,2.74a88.65,88.65,0,0,0-9.44,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.4,34.4,0,0,0-6.87,8.93A23.25,23.25,0,0,0,268,325.29a24.91,24.91,0,0,0,3.11,9.12c.38.68.8,1.36,1.25,2a40.28,40.28,0,0,0,8.39,8.93h0q1.75,1.42,3.75,2.77c1.34.9,2.75,1.78,4.25,2.63,1.73,1,3.56,1.93,5.49,2.83q3.56,1.66,7.35,3,2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14q2.51-1,4.88-2.19c2.1-1,4.1-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,40.34,40.34,0,0,0,3-3,30.67,30.67,0,0,0,5.91-9.46c.26-.7.5-1.4.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.2,46.2,0,0,0-9.21-8.34A71.33,71.33,0,0,0,395.81,291.6Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.81,291.6c-2.59-1.21-5.29-2.32-8.08-3.31a106.86,106.86,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.41,2.74a88.65,88.65,0,0,0-9.44,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.4,34.4,0,0,0-6.87,8.93A23.25,23.25,0,0,0,268,325.29a24.91,24.91,0,0,0,3.11,9.12c.38.68.8,1.36,1.25,2a40.28,40.28,0,0,0,8.39,8.93h0q1.75,1.42,3.75,2.77c1.34.9,2.75,1.78,4.25,2.63,1.73,1,3.56,1.93,5.49,2.83q3.56,1.66,7.35,3,2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14q2.51-1,4.88-2.19c2.1-1,4.1-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,40.34,40.34,0,0,0,3-3,30.67,30.67,0,0,0,5.91-9.46c.26-.7.5-1.4.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.2,46.2,0,0,0-9.21-8.34A71.33,71.33,0,0,0,395.81,291.6Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.68,360c-1.92-.48-3.82-1-5.68-1.57s-3.64-1.16-5.41-1.81q-3.79-1.38-7.35-3c-1.93-.9-3.76-1.85-5.49-2.83-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.75-2.77h0a40.28,40.28,0,0,1-8.39-8.93c-.45-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.25,23.25,0,0,1,2.65-13.93,34.4,34.4,0,0,1,6.87-8.93,54.74,54.74,0,0,1,9.33-7.07c1.88-1.15,3.86-2.21,5.91-3.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.19,343.17a37.82,37.82,0,0,1-5.84-6.73c-.45-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,22.66,22.66,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.46,363.6c-4.33-.26-8.64-.72-12.86-1.38l-21.71-73.93,1.06-.38a107.42,107.42,0,0,1,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12,360.67a127.2,127.2,0,0,1-12.88,2.19l-23.89-81.37c4.5-.2,9-.19,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.89,357.7c-2.12.7-4.3,1.35-6.52,1.93l-22.84-77.8c2.45.2,4.89.45,7.31.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.63,293.53h0c1,.54,2,1.1,2.93,1.66l.94.56.94.6c.69.44,1.36.88,2,1.33a46.2,46.2,0,0,1,9.21,8.34,27.47,27.47,0,0,1,6.37,13.6,22.37,22.37,0,0,1-.63,9.26c-.19.7-.43,1.4-.69,2.1a30.67,30.67,0,0,1-5.91,9.46c-.34.38-.7.75-1.06,1.13Z",
    style: {
      fill: "#1976D2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.68,299.41c-23.06-10.7-57.42-9.9-78.55,1.48-.89.49-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.85-.52,1.66-1.06,2.43-1.6C409.09,328.42,405.73,310.11,382.68,299.41Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.68,299.41c-23.06-10.7-57.42-9.9-78.55,1.48-.89.49-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.85-.52,1.66-1.06,2.43-1.6C409.09,328.42,405.73,310.11,382.68,299.41Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,300.44c-.74-.34-1.49-.68-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.52.29c-.68.37-1.34.75-2,1.15a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.53,14.17-1.16,20.94,2.58,4,6.76,7.68,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a74.21,74.21,0,0,0,7.55,2.51c18.18,5,40.22,4.21,56.88-2.09a61.11,61.11,0,0,0,6.8-3c1-.54,2-1.1,3-1.69s1.59-1,2.32-1.52l.61-.45c4.87-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.4-6.76-20.64A45.49,45.49,0,0,0,381,300.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,300.44c-.74-.34-1.49-.68-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.52.29c-.68.37-1.34.75-2,1.15a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.53,14.17-1.16,20.94,2.58,4,6.76,7.68,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a74.21,74.21,0,0,0,7.55,2.51c18.18,5,40.22,4.21,56.88-2.09a61.11,61.11,0,0,0,6.8-3c1-.54,2-1.1,3-1.69s1.59-1,2.32-1.52l.61-.45c4.87-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.4-6.76-20.64A45.49,45.49,0,0,0,381,300.44Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.76,305.91c.77.32,1.53.65,2.27,1a45.49,45.49,0,0,1,11.26,7.19c4.06,3.64,6.53,7.67,7.39,11.79a17.34,17.34,0,0,1-.66,2.39c-1.48,4.11-4.62,8.1-9.49,11.66l-.61.45c-.73.51-1.51,1-2.32,1.52s-1.94,1.15-3,1.69a61.11,61.11,0,0,1-6.8,3c-16.66,6.3-38.7,7.11-56.88,2.09a74.21,74.21,0,0,1-7.55-2.51c-1.15-.46-2.27-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.78-3.17-10-6.89-12.54-10.85a18.76,18.76,0,0,1-2.68-6.37,19.39,19.39,0,0,1,3.87-8.11,34.4,34.4,0,0,1,9.21-7.93c.64-.4,1.31-.78,2-1.15l.53-.29C325.49,297.81,356.79,296.74,378.76,305.91Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.76,305.91c.77.32,1.53.65,2.27,1a45.49,45.49,0,0,1,11.26,7.19c4.06,3.64,6.53,7.67,7.39,11.79a17.34,17.34,0,0,1-.66,2.39c-1.48,4.11-4.62,8.1-9.49,11.66l-.61.45c-.73.51-1.51,1-2.32,1.52s-1.94,1.15-3,1.69a61.11,61.11,0,0,1-6.8,3c-16.66,6.3-38.7,7.11-56.88,2.09a74.21,74.21,0,0,1-7.55-2.51c-1.15-.46-2.27-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.78-3.17-10-6.89-12.54-10.85a18.76,18.76,0,0,1-2.68-6.37,19.39,19.39,0,0,1,3.87-8.11,34.4,34.4,0,0,1,9.21-7.93c.64-.4,1.31-.78,2-1.15l.53-.29C325.49,297.81,356.79,296.74,378.76,305.91Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.71,331c-8.74,19.43-33.19,27.18-53.12,30.69-30.3,4.35-63.28.7-86.71-16.54l.05,0c-6.37-5-11.79-11.73-12.94-19.87,1,8.22,6.24,15.18,12.61,20.32l0,0c18.87,14.62,45,19.36,70,18.66C375.75,362.77,409.29,356,420.71,331Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.26,336.92c8.56,3.59,16.95,2,24.77-.73L336,338.3v8.89a37.08,37.08,0,0,0,5.29.86,38,38,0,0,0,9.21-.34A49.22,49.22,0,0,0,364.83,343l7.54,3.17,10.18-6.27V331l-1.91-.82-.42-.17a8.2,8.2,0,0,0,.21-2.08,5.07,5.07,0,0,0-.06-.7c-.13-1.1.1-6.12.06-8.19,0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.57-6.47v0a27.33,27.33,0,0,0-13.48-1.79l-1.14.14H359l-1.2.2c-.35.06-.69.12-1,.2-.15,0-.3.05-.43.09s-.55.1-.79.17a62.1,62.1,0,0,0-6.5,1.92c-.93.33-1.86.68-2.78,1L349,311v-8.89c-8.66-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.43v8.88l2.36,1a5.47,5.47,0,0,0-.22,1.68v.06c.08,1.38-.06,7.26,0,8.82v.07C306.65,332.74,308.8,335.06,313.26,336.92Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.43,319.46c0,2.27-.17,6.74-.05,7.76,0,.24,0,.46.06.71a8.3,8.3,0,0,1-.22,2.08l-5.42-2.28S380.27,325.09,380.43,319.46Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.7,319.32c-2.26-.95-2.63-2.71,1.53-5.39,4.45-2.83,9-3.56,12.94-2.59l8.82-9.19V311l-2.67,2.8-.27.11c-1.45.55-2.85,1.12-4.18,1.68-.55.24-1.08.46-1.6.66a55,55,0,0,1-8.89,3.27,10.07,10.07,0,0,1-3.86.27A7.16,7.16,0,0,1,325.7,319.32Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.7,319.48l-2.34-1v-8.88l7.51,3.15C309.08,315.09,307.29,317.36,306.7,319.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.36,337.25,382.55,331v8.89l-10.2,6.28L364.84,343a48.79,48.79,0,0,1-14.36,4.72,36.15,36.15,0,0,1-14.5-.51V338.3a36.15,36.15,0,0,0,14.5.51,48.5,48.5,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.84,343a37.16,37.16,0,0,1-11.44,4.68,30.33,30.33,0,0,1-12.13.4,58.58,58.58,0,0,0,12-1.4c2-.43,3.9-1,5.84-1.6S362.91,343.71,364.84,343Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.51,330.12v-.05c-.06-1.56.07-7.44,0-8.83.15,2.62,2.28,4.94,6.74,6.8,9.94,4.14,19.61,1.42,28.46-2.13,8.21-3.32,14.18-6.86,19-4.86,3,1.27,2.15,3.27-1.13,5.36a18.15,18.15,0,0,1-14.2,2.24L338,336.19h0c-7.84,2.77-16.22,4.3-24.76.73C308.79,335.06,306.66,332.75,306.51,330.12Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.18 320.23 340.17 311.34 348.98 302.14 348.99 311.03 340.18 320.23",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.18 320.23 340.17 311.34 348.98 302.14 348.99 311.03 340.18 320.23",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.35 309.63 311.89 312.77 306.72 319.5 304.36 318.51 304.35 309.63",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.35 309.63 311.89 312.77 306.72 319.5 304.36 318.51 304.35 309.63",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.64,330.18l-5.83-2.45s5.73-2.78,5.62-8.69c0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.57-6.47v0a27.33,27.33,0,0,0-13.48-1.79l-1.14.14H359l-1.2.2c-.35.06-.69.12-1,.2-.15,0-.3.05-.43.09s-.55.1-.79.17a62.1,62.1,0,0,0-6.5,1.92c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.7-.54.24-1.07.45-1.59.66a57.37,57.37,0,0,1-8.89,3.27,10.21,10.21,0,0,1-3.85.26,7.94,7.94,0,0,1-1.81-.49c-2.27-.95-2.66-2.72,1.52-5.4,4.45-2.84,9-3.57,12.94-2.59l8.81-9.2c-8.66-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.43,7.54,3.14c-3.59,3-5.49,5.83-5.39,8.41v.06c.15,2.62,2.29,4.93,6.76,6.8,9.91,4.15,19.59,1.42,28.43-2.13,8.23-3.33,14.19-6.86,19-4.85,3,1.27,2.13,3.25-1.15,5.36a18.22,18.22,0,0,1-14.2,2.24L336,338.3a36.11,36.11,0,0,0,5.3.87,38.59,38.59,0,0,0,9.21-.35,49.15,49.15,0,0,0,14.34-4.72l7.54,3.16L382.55,331Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.64,330.18l-5.83-2.45s5.73-2.78,5.62-8.69c0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.57-6.47v0a27.33,27.33,0,0,0-13.48-1.79l-1.14.14H359l-1.2.2c-.35.06-.69.12-1,.2-.15,0-.3.05-.43.09s-.55.1-.79.17a62.1,62.1,0,0,0-6.5,1.92c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.7-.54.24-1.07.45-1.59.66a57.37,57.37,0,0,1-8.89,3.27,10.21,10.21,0,0,1-3.85.26,7.94,7.94,0,0,1-1.81-.49c-2.27-.95-2.66-2.72,1.52-5.4,4.45-2.84,9-3.57,12.94-2.59l8.81-9.2c-8.66-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.43,7.54,3.14c-3.59,3-5.49,5.83-5.39,8.41v.06c.15,2.62,2.29,4.93,6.76,6.8,9.91,4.15,19.59,1.42,28.43-2.13,8.23-3.33,14.19-6.86,19-4.85,3,1.27,2.13,3.25-1.15,5.36a18.22,18.22,0,0,1-14.2,2.24L336,338.3a36.11,36.11,0,0,0,5.3.87,38.59,38.59,0,0,0,9.21-.35,49.15,49.15,0,0,0,14.34-4.72l7.54,3.16L382.55,331Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.26,328a28.43,28.43,0,0,0,11.8,1.83,43.23,43.23,0,0,0,12.05-2.55c3.94-1.3,7.73-3,11.6-4.62a39.32,39.32,0,0,1,6-2,9.88,9.88,0,0,1,6,.35,9.84,9.84,0,0,0-6-.08,40.5,40.5,0,0,0-5.85,2.11c-3.81,1.67-7.63,3.41-11.6,4.76A42.35,42.35,0,0,1,325,330.31a28.77,28.77,0,0,1-6.1-.46A29.17,29.17,0,0,1,313.26,328Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.36 337.26 372.37 346.15 364.83 342.98 364.82 334.1 372.36 337.26",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.36 337.26 372.37 346.15 364.83 342.98 364.82 334.1 372.36 337.26",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.55 331 372.4 336.27 364.82 334.1 372.36 337.26 382.55 331",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.96 306.34 314.46 304.12 304.35 309.63 314.42 303.2 321.96 306.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,302.14a39.38,39.38,0,0,0-4.73-.56l1.23,4.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.6,328.17a27.56,27.56,0,0,0,13,1.82l-7.27-24.75-4.9-2-6.86,4.38,1.13,3.85,3.2,1.34a28.06,28.06,0,0,0-2.21,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.26,311.28a26.33,26.33,0,0,0-7.49-1.37l8,27.12,6-3.69-1.33-4.52-2.6-1.09a11.74,11.74,0,0,0,1.91-1.28Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,310.21l-1.2.2c-.35.06-.7.12-1,.2-.15,0-.3.05-.43.09s-.55.1-.79.17a62.1,62.1,0,0,0-6.5,1.92c-.47.16-.93.35-1.39.52l2.63,9c4.06-1.6,7.43-2.45,10.38-1.22s2.13,3.25-1.15,5.36a17.7,17.7,0,0,1-7.24,2.61l2.59,8.84a51.72,51.72,0,0,0,9.92-3.77l2.85,1.19-7.41-25.22-1.09.13Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.13,302.68l8.47,0V320h0a23.25,23.25,0,0,1-.83,6.16c-.2.7-.44,1.4-.7,2.1a30.6,30.6,0,0,1-5.91,9.46,42.34,42.34,0,0,1-3,3,45.44,45.44,0,0,1-3.5,2.92,58.9,58.9,0,0,1-5.1,3.47c-1.92,1.17-3.92,2.26-6,3.29-1.58.77-3.2,1.5-4.88,2.19-24.52,10.13-58.33,11.36-85.31,3.14q-2.76-.84-5.4-1.81c-2.53-.92-5-1.94-7.35-3.05q-2.91-1.37-5.5-2.83c-1.5-.86-2.91-1.73-4.25-2.64s-2.58-1.82-3.75-2.76h0a40.72,40.72,0,0,1-8.39-8.93c-.44-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.68,23.68,0,0,1-.18-2.91h0V303.25l7.75,0c.62-.68,1.27-1.35,2-2a54.34,54.34,0,0,1,9.33-7.07,72.88,72.88,0,0,1,6.67-3.6,88.48,88.48,0,0,1,9.43-3.85c22.18-7.67,50.42-8.7,74.42-2.74a107.71,107.71,0,0,1,10.37,3.12c2.79,1,5.49,2.1,8.08,3.31a70.71,70.71,0,0,1,10.63,6.08A49,49,0,0,1,433.13,302.68Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,359.47l0-35.18,12.88,1.35,0,35.22C351.51,360.59,347.2,360.13,343,359.47Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.6,320h0a23.25,23.25,0,0,1-.83,6.16c-.2.7-.44,1.4-.7,2.1a30.6,30.6,0,0,1-5.91,9.46c-.34.37-.7.75-1.06,1.12l0-36.2.06.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.65,303.81l6.61-1.56,0,52.72c-2.11.7-4.27,1.33-6.47,1.91Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.6,360.12l0-45.7,12.87.95,0,42.55A129.56,129.56,0,0,1,381.6,360.12Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.16,303.25l7.75,0c.62-.68,1.27-1.35,2-2a54.34,54.34,0,0,1,9.33-7.07,72.88,72.88,0,0,1,6.67-3.6,88.48,88.48,0,0,1,9.43-3.85c3.1-1.07,6.33-2,9.64-2.81l.06,73.39c-1.9-.47-3.79-1-5.64-1.55s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.94-7.35-3.05q-2.91-1.37-5.5-2.83c-1.5-.86-2.91-1.73-4.25-2.64s-2.58-1.82-3.75-2.76h0a40.72,40.72,0,0,1-8.39-8.93c-.44-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.68,23.68,0,0,1-.18-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.71,333.7c-.44-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.68,23.68,0,0,1-.18-2.91h0V303.25l7.75,0,.09-.1,2.62.94,0,36.46A38.58,38.58,0,0,1,291.71,333.7Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.16,271.84c-2.59-1.21-5.29-2.32-8.08-3.31-3.34-1.19-6.81-2.24-10.37-3.12-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07A34.19,34.19,0,0,0,290,291.6a23.1,23.1,0,0,0-2.65,13.93,25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40,40,0,0,0,8.39,8.93h0q1.77,1.42,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.1,4.82,2.12,7.35,3q2.64,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.53,6-3.29a60.27,60.27,0,0,0,5.09-3.47c1.26-.95,2.43-1.93,3.51-2.92a38.34,38.34,0,0,0,3-3,30.49,30.49,0,0,0,5.91-9.46c.27-.7.5-1.4.7-2.1a22.71,22.71,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.28,46.28,0,0,0-9.22-8.34A70.71,70.71,0,0,0,415.16,271.84Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.16,271.84c-2.59-1.21-5.29-2.32-8.08-3.31-3.34-1.19-6.81-2.24-10.37-3.12-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07A34.19,34.19,0,0,0,290,291.6a23.1,23.1,0,0,0-2.65,13.93,25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40,40,0,0,0,8.39,8.93h0q1.77,1.42,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.1,4.82,2.12,7.35,3q2.64,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.53,6-3.29a60.27,60.27,0,0,0,5.09-3.47c1.26-.95,2.43-1.93,3.51-2.92a38.34,38.34,0,0,0,3-3,30.49,30.49,0,0,0,5.91-9.46c.27-.7.5-1.4.7-2.1a22.71,22.71,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.28,46.28,0,0,0-9.22-8.34A70.71,70.71,0,0,0,415.16,271.84Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.16,271.84c-2.59-1.21-5.29-2.32-8.08-3.31-3.34-1.19-6.81-2.24-10.37-3.12-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07A34.19,34.19,0,0,0,290,291.6a23.1,23.1,0,0,0-2.65,13.93,25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40,40,0,0,0,8.39,8.93h0q1.77,1.42,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.1,4.82,2.12,7.35,3q2.64,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.53,6-3.29a60.27,60.27,0,0,0,5.09-3.47c1.26-.95,2.43-1.93,3.51-2.92a38.34,38.34,0,0,0,3-3,30.49,30.49,0,0,0,5.91-9.46c.27-.7.5-1.4.7-2.1a22.71,22.71,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.28,46.28,0,0,0-9.22-8.34A70.71,70.71,0,0,0,415.16,271.84Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,340.27c-1.92-.48-3.82-1-5.68-1.57s-3.65-1.16-5.41-1.81c-2.53-.92-5-1.94-7.35-3-1.93-.91-3.77-1.86-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.77h0a40,40,0,0,1-8.39-8.93c-.45-.67-.87-1.35-1.26-2a25.08,25.08,0,0,1-3.1-9.12A23.1,23.1,0,0,1,290,291.6a34.19,34.19,0,0,1,6.87-8.93,54.34,54.34,0,0,1,9.33-7.07c1.88-1.15,3.86-2.21,5.91-3.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.53,323.41a38.15,38.15,0,0,1-5.83-6.73c-.45-.67-.87-1.35-1.26-2a25.08,25.08,0,0,1-3.1-9.12A22.66,22.66,0,0,1,288.9,294Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.8,343.84c-4.33-.26-8.63-.72-12.86-1.38l-21.7-73.93,1.05-.38a107.42,107.42,0,0,1,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.46,340.91a127,127,0,0,1-12.87,2.19l-23.9-81.37c4.5-.2,9-.19,13.54,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.23,337.94c-2.12.7-4.29,1.35-6.51,1.93l-22.85-77.8c2.46.2,4.9.45,7.32.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,273.77h0c1,.54,2,1.1,2.93,1.66l.94.56.94.6c.68.44,1.36.88,2,1.33a46.28,46.28,0,0,1,9.22,8.34,27.47,27.47,0,0,1,6.37,13.6,22.71,22.71,0,0,1-.63,9.26c-.2.7-.43,1.4-.7,2.1a30.49,30.49,0,0,1-5.91,9.46c-.33.38-.7.75-1.06,1.13Z",
    style: {
      fill: "#1976D2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,279.65c-23-10.7-57.42-9.9-78.54,1.48-.89.49-1.78,1-2.63,1.51-20.79,12.81-18.17,32.23,5.86,43.39s60.38,9.82,81.17-3c.85-.52,1.66-1.06,2.43-1.6C428.44,308.66,425.08,290.35,402,279.65Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,279.65c-23-10.7-57.42-9.9-78.54,1.48-.89.49-1.78,1-2.63,1.51-20.79,12.81-18.17,32.23,5.86,43.39s60.38,9.82,81.17-3c.85-.52,1.66-1.06,2.43-1.6C428.44,308.66,425.08,290.35,402,279.65Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.35,280.68c-.74-.34-1.5-.68-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.53.29c-.67.37-1.34.75-2,1.15a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.94,2.57,4,6.76,7.68,12.54,10.85,1.08.6,2.22,1.18,3.43,1.74s2.22,1,3.38,1.45a74,74,0,0,0,7.54,2.51c18.19,5,40.23,4.21,56.89-2.09a60.94,60.94,0,0,0,6.79-3c1-.54,2-1.1,3-1.69s1.58-1,2.32-1.52l.61-.45c4.86-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.4-6.76-20.64A45.49,45.49,0,0,0,400.35,280.68Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.35,280.68c-.74-.34-1.5-.68-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.53.29c-.67.37-1.34.75-2,1.15a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.94,2.57,4,6.76,7.68,12.54,10.85,1.08.6,2.22,1.18,3.43,1.74s2.22,1,3.38,1.45a74,74,0,0,0,7.54,2.51c18.19,5,40.23,4.21,56.89-2.09a60.94,60.94,0,0,0,6.79-3c1-.54,2-1.1,3-1.69s1.58-1,2.32-1.52l.61-.45c4.86-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.4-6.76-20.64A45.49,45.49,0,0,0,400.35,280.68Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.1,286.15c.78.32,1.53.65,2.27,1a45.12,45.12,0,0,1,11.26,7.19c4.07,3.64,6.54,7.67,7.4,11.79a17.34,17.34,0,0,1-.66,2.39c-1.48,4.11-4.63,8.1-9.49,11.66l-.61.45c-.74.51-1.51,1-2.32,1.52s-1.94,1.15-3,1.69a60.94,60.94,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.89,2.09a74,74,0,0,1-7.54-2.51c-1.16-.46-2.28-.94-3.38-1.45s-2.35-1.14-3.43-1.74c-5.78-3.17-10-6.89-12.54-10.85a19,19,0,0,1-2.69-6.37,19.63,19.63,0,0,1,3.87-8.11,34.71,34.71,0,0,1,9.21-7.93c.65-.4,1.31-.78,2-1.15l.53-.29C344.83,278.05,376.14,277,398.1,286.15Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.1,286.15c.78.32,1.53.65,2.27,1a45.12,45.12,0,0,1,11.26,7.19c4.07,3.64,6.54,7.67,7.4,11.79a17.34,17.34,0,0,1-.66,2.39c-1.48,4.11-4.63,8.1-9.49,11.66l-.61.45c-.74.51-1.51,1-2.32,1.52s-1.94,1.15-3,1.69a60.94,60.94,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.89,2.09a74,74,0,0,1-7.54-2.51c-1.16-.46-2.28-.94-3.38-1.45s-2.35-1.14-3.43-1.74c-5.78-3.17-10-6.89-12.54-10.85a19,19,0,0,1-2.69-6.37,19.63,19.63,0,0,1,3.87-8.11,34.71,34.71,0,0,1,9.21-7.93c.65-.4,1.31-.78,2-1.15l.53-.29C344.83,278.05,376.14,277,398.1,286.15Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.05,311.22c-8.73,19.44-33.18,27.18-53.11,30.69-30.3,4.35-63.28.7-86.71-16.54l0,0c-6.37-5-11.8-11.73-12.94-19.87,1,8.22,6.24,15.18,12.61,20.32l0,0c18.87,14.62,45,19.36,70,18.66C395.09,343,428.63,336.24,440.05,311.22Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.61,317.16c8.56,3.59,16.95,2,24.77-.73l-2.06,2.11v8.89a37.08,37.08,0,0,0,5.29.86,38.08,38.08,0,0,0,9.21-.34,49.06,49.06,0,0,0,14.34-4.73l7.55,3.17,10.18-6.27v-8.88l-1.91-.82-.41-.17a8.2,8.2,0,0,0,.21-2.08,5.07,5.07,0,0,0-.06-.7c-.13-1.1.09-6.12,0-8.19a5.21,5.21,0,0,0-.06-.7c-.3-2.48-2.36-4.71-6.58-6.47v0a27.29,27.29,0,0,0-13.47-1.79l-1.15.14-.12,0-1.2.19c-.35.06-.7.12-1.05.2-.15,0-.3,0-.42.09-.27.05-.55.1-.8.17a62.64,62.64,0,0,0-6.49,1.92c-.94.33-1.87.68-2.78,1l2.68-2.8v-8.89c-8.67-1.65-17.92-.25-27,4.2l-7.55-3.14-10.06,6.43v8.88l2.36,1a5.49,5.49,0,0,0-.23,1.68v.06c.08,1.38,0,7.26,0,8.82v.07C326,313,328.15,315.3,332.61,317.16Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.77,299.7c0,2.27-.16,6.74,0,7.76,0,.24,0,.47.07.71a8.3,8.3,0,0,1-.22,2.08L394.15,308S399.62,305.33,399.77,299.7Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.05,299.56c-2.27-.95-2.64-2.71,1.52-5.39,4.46-2.83,9.05-3.56,12.95-2.59l8.82-9.19,0,8.88-2.66,2.8c-.1,0-.17.07-.27.11-1.45.55-2.85,1.12-4.19,1.68q-.81.36-1.59.66a55.38,55.38,0,0,1-8.9,3.27,10,10,0,0,1-3.85.27A7,7,0,0,1,345.05,299.56Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.05,299.72l-2.35-1,0-8.88,7.51,3.15C328.43,295.33,326.64,297.6,326.05,299.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.71,317.49l10.19-6.26v8.89l-10.2,6.28-7.52-3.18a48.79,48.79,0,0,1-14.36,4.72,36.15,36.15,0,0,1-14.5-.51v-8.89a36.15,36.15,0,0,0,14.5.51,48.5,48.5,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.19,323.22a37.16,37.16,0,0,1-11.44,4.68,30.33,30.33,0,0,1-12.13.4,58.49,58.49,0,0,0,11.95-1.4c2-.43,3.91-1,5.85-1.6S382.26,324,384.19,323.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.85,310.36v-.05c-.07-1.56.07-7.44,0-8.83.16,2.62,2.28,4.94,6.75,6.8,9.94,4.14,19.61,1.42,28.46-2.13,8.21-3.32,14.18-6.86,19-4.86,3,1.27,2.15,3.27-1.13,5.36a18.17,18.17,0,0,1-14.21,2.24l-7.31,7.54h0c-7.83,2.77-16.21,4.3-24.75.73C328.13,315.3,326,313,325.85,310.36Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.52 300.47 359.52 291.58 368.33 282.38 368.33 291.27 359.52 300.47",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.52 300.47 359.52 291.58 368.33 282.38 368.33 291.27 359.52 300.47",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.7 289.87 331.24 293.01 326.07 299.74 323.71 298.75 323.7 289.87",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.7 289.87 331.24 293.01 326.07 299.74 323.71 298.75 323.7 289.87",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,310.42,394.16,308s5.73-2.78,5.61-8.69a5.21,5.21,0,0,0-.06-.7c-.3-2.48-2.36-4.71-6.58-6.47v0a27.29,27.29,0,0,0-13.47-1.79l-1.15.14-.12,0-1.2.19c-.35.06-.7.12-1.05.2-.15,0-.3,0-.42.09-.27.05-.55.1-.8.17a62.64,62.64,0,0,0-6.49,1.92c-1,.36-2,.74-3,1.14-1.45.56-2.86,1.14-4.2,1.7-.55.24-1.07.45-1.59.66a57.41,57.41,0,0,1-8.9,3.27,10.18,10.18,0,0,1-3.85.26,8.08,8.08,0,0,1-1.81-.49c-2.27-.95-2.65-2.72,1.53-5.4,4.45-2.84,9-3.57,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2l-7.55-3.14-10.06,6.43,7.54,3.14c-3.6,3-5.49,5.83-5.4,8.41v.06c.15,2.62,2.3,4.93,6.76,6.8,9.92,4.15,19.6,1.42,28.44-2.13,8.22-3.33,14.19-6.86,19-4.85,3,1.27,2.14,3.25-1.15,5.36a18.19,18.19,0,0,1-14.19,2.24l-9.38,9.64a36,36,0,0,0,5.29.87,38.55,38.55,0,0,0,9.21-.35,49.21,49.21,0,0,0,14.35-4.72l7.54,3.16,10.18-6.26Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,310.42,394.16,308s5.73-2.78,5.61-8.69a5.21,5.21,0,0,0-.06-.7c-.3-2.48-2.36-4.71-6.58-6.47v0a27.29,27.29,0,0,0-13.47-1.79l-1.15.14-.12,0-1.2.19c-.35.06-.7.12-1.05.2-.15,0-.3,0-.42.09-.27.05-.55.1-.8.17a62.64,62.64,0,0,0-6.49,1.92c-1,.36-2,.74-3,1.14-1.45.56-2.86,1.14-4.2,1.7-.55.24-1.07.45-1.59.66a57.41,57.41,0,0,1-8.9,3.27,10.18,10.18,0,0,1-3.85.26,8.08,8.08,0,0,1-1.81-.49c-2.27-.95-2.65-2.72,1.53-5.4,4.45-2.84,9-3.57,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2l-7.55-3.14-10.06,6.43,7.54,3.14c-3.6,3-5.49,5.83-5.4,8.41v.06c.15,2.62,2.3,4.93,6.76,6.8,9.92,4.15,19.6,1.42,28.44-2.13,8.22-3.33,14.19-6.86,19-4.85,3,1.27,2.14,3.25-1.15,5.36a18.19,18.19,0,0,1-14.19,2.24l-9.38,9.64a36,36,0,0,0,5.29.87,38.55,38.55,0,0,0,9.21-.35,49.21,49.21,0,0,0,14.35-4.72l7.54,3.16,10.18-6.26Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.6,308.28a28.48,28.48,0,0,0,11.81,1.83,43.09,43.09,0,0,0,12-2.55c3.95-1.3,7.74-3,11.61-4.62a39,39,0,0,1,6-2,9.84,9.84,0,0,1,6,.35,9.8,9.8,0,0,0-6-.08,40.08,40.08,0,0,0-5.85,2.11c-3.82,1.67-7.64,3.41-11.6,4.76a42.42,42.42,0,0,1-12.23,2.46,28.91,28.91,0,0,1-6.11-.46A29.39,29.39,0,0,1,332.6,308.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.71 317.5 391.71 326.39 384.17 323.22 384.17 314.34 391.71 317.5",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.71 317.5 391.71 326.39 384.17 323.22 384.17 314.34 391.71 317.5",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.89 311.24 391.75 316.51 384.17 314.34 391.71 317.5 401.89 311.24",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.31 286.58 333.81 284.36 323.7 289.87 333.76 283.44 341.31 286.58",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.33,282.38a39.3,39.3,0,0,0-4.74-.56l1.24,4.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,308.41a27.56,27.56,0,0,0,13,1.82l-7.27-24.75-4.91-2-6.86,4.38,1.13,3.85,3.21,1.34a26.39,26.39,0,0,0-2.21,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.61,291.52a26.39,26.39,0,0,0-7.49-1.37l8,27.12,6-3.69-1.32-4.52-2.6-1.09a10.71,10.71,0,0,0,1.9-1.28Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.39,290.46l-1.2.19c-.35.06-.7.12-1.05.2-.15,0-.3,0-.42.09-.27.05-.55.1-.8.17a62.64,62.64,0,0,0-6.49,1.92c-.47.16-.93.35-1.39.52l2.63,9c4.05-1.6,7.43-2.45,10.37-1.22s2.14,3.25-1.15,5.36a17.59,17.59,0,0,1-7.24,2.61l2.6,8.84a52,52,0,0,0,9.92-3.77l2.84,1.19-7.4-25.22-1.1.13Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "296.81 380.6 298.04 371.28 299.27 380.6 315.41 381.31 299.27 382.02 298.04 391.34 296.81 382.02 280.67 381.31 296.81 380.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.85 388.59 309.45 384.08 310.04 388.59 317.87 388.94 310.04 389.28 309.45 393.8 308.85 389.28 301.03 388.94 308.85 388.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.49 291.58 282.72 282.26 283.94 291.58 300.09 292.29 283.94 293 282.72 302.32 281.49 293 265.34 292.29 281.49 291.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.21 298.81 290.81 294.29 291.4 298.81 299.23 299.15 291.4 299.5 290.81 304.01 290.21 299.5 282.39 299.15 290.21 298.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.29 331.78 414.52 322.46 415.75 331.78 431.89 332.49 415.75 333.2 414.52 342.52 413.29 333.2 397.15 332.49 413.29 331.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.02 339.01 422.61 334.49 423.21 339.01 431.03 339.35 423.21 339.69 422.61 344.21 422.02 339.69 414.19 339.35 422.02 339.01",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215,392l8.47,0v17.34h0a22.44,22.44,0,0,1-.83,6.15c-.2.7-.43,1.4-.7,2.1A30.6,30.6,0,0,1,216,427a42.15,42.15,0,0,1-3,3c-1.08,1-2.25,2-3.51,2.92a58.9,58.9,0,0,1-5.1,3.47c-1.91,1.17-3.92,2.26-6,3.29-1.57.77-3.2,1.5-4.87,2.19C169,452,135.22,453.21,108.25,445q-2.77-.84-5.41-1.81c-2.53-.92-5-1.94-7.35-3.05-1.93-.9-3.77-1.85-5.49-2.83-1.5-.86-2.92-1.73-4.25-2.64s-2.58-1.82-3.76-2.76h0A40.26,40.26,0,0,1,73.6,423c-.45-.67-.87-1.35-1.26-2a25.1,25.1,0,0,1-3.11-9.12,23.67,23.67,0,0,1-.17-2.91h0l0-16.39,7.75,0c.62-.68,1.27-1.35,2-2a54.44,54.44,0,0,1,9.34-7.07,72.7,72.7,0,0,1,6.66-3.6,88.65,88.65,0,0,1,9.44-3.85c22.17-7.67,50.42-8.7,74.41-2.74A107.91,107.91,0,0,1,189,376.34c2.78,1,5.48,2.1,8.07,3.31a70.48,70.48,0,0,1,10.64,6.09A48.31,48.31,0,0,1,215,392Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.85,448.74l0-35.17,12.88,1.34,0,35.22C133.39,449.86,129.08,449.4,124.85,448.74Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.48,409.26h0a22.44,22.44,0,0,1-.83,6.15c-.2.7-.43,1.4-.7,2.1A30.6,30.6,0,0,1,216,427c-.33.37-.69.75-1,1.12l0-36.2.06.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.53,393.08l6.61-1.56,0,52.72c-2.1.7-4.26,1.33-6.47,1.91Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.49,449.39l0-45.7,12.88.95,0,42.55A130.06,130.06,0,0,1,163.49,449.39Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,392.52l7.75,0c.62-.68,1.27-1.35,2-2a54.44,54.44,0,0,1,9.34-7.07,72.7,72.7,0,0,1,6.66-3.6,88.65,88.65,0,0,1,9.44-3.85c3.1-1.07,6.33-2,9.64-2.81l.06,73.39c-1.91-.47-3.8-1-5.64-1.55s-3.65-1.16-5.41-1.81c-2.53-.92-5-1.94-7.35-3.05-1.93-.9-3.77-1.85-5.49-2.83-1.5-.86-2.92-1.73-4.25-2.64s-2.58-1.82-3.76-2.76h0A40.26,40.26,0,0,1,73.6,423c-.45-.67-.87-1.35-1.26-2a25.1,25.1,0,0,1-3.11-9.12,23.67,23.67,0,0,1-.17-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6,423c-.45-.67-.87-1.35-1.26-2a25.1,25.1,0,0,1-3.11-9.12,23.67,23.67,0,0,1-.17-2.91h0l0-16.39,7.75,0a.94.94,0,0,1,.1-.1l2.61.95,0,36.45A38.1,38.1,0,0,1,73.6,423Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,361.11c-2.59-1.21-5.29-2.31-8.08-3.31a106.86,106.86,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.41,2.74a88.65,88.65,0,0,0-9.44,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.4,34.4,0,0,0-6.87,8.93,23.28,23.28,0,0,0-2.65,13.93,24.91,24.91,0,0,0,3.11,9.12c.38.68.8,1.36,1.25,2A40.28,40.28,0,0,0,82,414.88h0q1.76,1.42,3.75,2.77c1.34.9,2.75,1.78,4.25,2.63q2.59,1.47,5.5,2.84c2.36,1.1,4.81,2.12,7.34,3q2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47A45.44,45.44,0,0,0,213,413a40.34,40.34,0,0,0,3-3,30.67,30.67,0,0,0,5.91-9.46c.26-.7.5-1.4.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.2,46.2,0,0,0-9.21-8.34A71.33,71.33,0,0,0,197,361.11Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,361.11c-2.59-1.21-5.29-2.31-8.08-3.31a106.86,106.86,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.41,2.74a88.65,88.65,0,0,0-9.44,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.4,34.4,0,0,0-6.87,8.93,23.28,23.28,0,0,0-2.65,13.93,24.91,24.91,0,0,0,3.11,9.12c.38.68.8,1.36,1.25,2A40.28,40.28,0,0,0,82,414.88h0q1.76,1.42,3.75,2.77c1.34.9,2.75,1.78,4.25,2.63q2.59,1.47,5.5,2.84c2.36,1.1,4.81,2.12,7.34,3q2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47A45.44,45.44,0,0,0,213,413a40.34,40.34,0,0,0,3-3,30.67,30.67,0,0,0,5.91-9.46c.26-.7.5-1.4.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.2,46.2,0,0,0-9.21-8.34A71.33,71.33,0,0,0,197,361.11Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,361.11c-2.59-1.21-5.29-2.31-8.08-3.31a106.86,106.86,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.41,2.74a88.65,88.65,0,0,0-9.44,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.4,34.4,0,0,0-6.87,8.93,23.28,23.28,0,0,0-2.65,13.93,24.91,24.91,0,0,0,3.11,9.12c.38.68.8,1.36,1.25,2A40.28,40.28,0,0,0,82,414.88h0q1.76,1.42,3.75,2.77c1.34.9,2.75,1.78,4.25,2.63q2.59,1.47,5.5,2.84c2.36,1.1,4.81,2.12,7.34,3q2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47A45.44,45.44,0,0,0,213,413a40.34,40.34,0,0,0,3-3,30.67,30.67,0,0,0,5.91-9.46c.26-.7.5-1.4.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.2,46.2,0,0,0-9.21-8.34A71.33,71.33,0,0,0,197,361.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.91,429.54c-1.92-.48-3.82-1-5.68-1.57s-3.64-1.16-5.4-1.81c-2.54-.92-5-1.94-7.35-3q-2.91-1.37-5.5-2.84c-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.75-2.77h0A40.28,40.28,0,0,1,73.58,406c-.45-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.28,23.28,0,0,1,2.65-13.93,34.4,34.4,0,0,1,6.87-8.93,54.74,54.74,0,0,1,9.33-7.07c1.88-1.15,3.86-2.21,5.91-3.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.42,412.68A37.82,37.82,0,0,1,73.58,406c-.45-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,22.77,22.77,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,433.12c-4.33-.27-8.64-.73-12.86-1.39L103.12,357.8l1.06-.38c3.34-1.15,6.83-2.14,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.35,430.18a126.72,126.72,0,0,1-12.88,2.19L139.58,351c4.5-.2,9-.19,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.12,427.21c-2.12.7-4.3,1.35-6.52,1.93l-22.84-77.8c2.45.2,4.89.45,7.31.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.86,363h0c1,.54,2,1.1,2.93,1.66l.94.56.94.6c.69.44,1.36.88,2,1.33a46.2,46.2,0,0,1,9.21,8.34,27.47,27.47,0,0,1,6.37,13.6,22.37,22.37,0,0,1-.63,9.26c-.19.7-.43,1.4-.69,2.1A30.67,30.67,0,0,1,216,410c-.34.38-.7.75-1.06,1.13Z",
    style: {
      fill: "#1976D2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.91,368.92c-23.06-10.7-57.42-9.9-78.55,1.48-.89.49-1.77,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.85-.53,1.66-1.07,2.43-1.61C210.32,397.93,207,379.62,183.91,368.92Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.91,368.92c-23.06-10.7-57.42-9.9-78.55,1.48-.89.49-1.77,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.85-.53,1.66-1.07,2.43-1.61C210.32,397.93,207,379.62,183.91,368.92Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.23,370c-.74-.34-1.49-.67-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.52.29c-.68.37-1.34.75-2,1.15a34.4,34.4,0,0,0-9.21,7.93c-5.22,6.7-5.53,14.17-1.16,20.94,2.58,4,6.77,7.68,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a71.82,71.82,0,0,0,7.55,2.51c18.18,5,40.22,4.21,56.88-2.09a61.11,61.11,0,0,0,6.8-3c1-.54,2-1.1,3-1.68s1.59-1,2.32-1.53l.61-.45c4.87-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.39-6.76-20.64A45.49,45.49,0,0,0,182.23,370Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.23,370c-.74-.34-1.49-.67-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.52.29c-.68.37-1.34.75-2,1.15a34.4,34.4,0,0,0-9.21,7.93c-5.22,6.7-5.53,14.17-1.16,20.94,2.58,4,6.77,7.68,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a71.82,71.82,0,0,0,7.55,2.51c18.18,5,40.22,4.21,56.88-2.09a61.11,61.11,0,0,0,6.8-3c1-.54,2-1.1,3-1.68s1.59-1,2.32-1.53l.61-.45c4.87-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.39-6.76-20.64A45.49,45.49,0,0,0,182.23,370Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,375.42c.77.32,1.53.65,2.27,1a45.49,45.49,0,0,1,11.26,7.19c4.06,3.64,6.53,7.68,7.39,11.79a16,16,0,0,1-.66,2.39c-1.48,4.11-4.62,8.1-9.49,11.66l-.61.45c-.73.51-1.51,1-2.32,1.53s-1.94,1.14-3,1.68a61.11,61.11,0,0,1-6.8,3c-16.66,6.3-38.7,7.11-56.88,2.09a71.82,71.82,0,0,1-7.55-2.51c-1.15-.46-2.27-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.77-3.17-10-6.89-12.54-10.85a18.76,18.76,0,0,1-2.68-6.37,19.29,19.29,0,0,1,3.87-8.1,34.24,34.24,0,0,1,9.21-7.94c.64-.4,1.31-.78,2-1.15l.53-.29C126.72,367.32,158,366.25,180,375.42Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,375.42c.77.32,1.53.65,2.27,1a45.49,45.49,0,0,1,11.26,7.19c4.06,3.64,6.53,7.68,7.39,11.79a16,16,0,0,1-.66,2.39c-1.48,4.11-4.62,8.1-9.49,11.66l-.61.45c-.73.51-1.51,1-2.32,1.53s-1.94,1.14-3,1.68a61.11,61.11,0,0,1-6.8,3c-16.66,6.3-38.7,7.11-56.88,2.09a71.82,71.82,0,0,1-7.55-2.51c-1.15-.46-2.27-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.77-3.17-10-6.89-12.54-10.85a18.76,18.76,0,0,1-2.68-6.37,19.29,19.29,0,0,1,3.87-8.1,34.24,34.24,0,0,1,9.21-7.94c.64-.4,1.31-.78,2-1.15l.53-.29C126.72,367.32,158,366.25,180,375.42Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.94,400.49c-8.74,19.44-33.19,27.19-53.12,30.69-30.3,4.35-63.28.7-86.71-16.54l0,0c-6.37-5-11.79-11.73-12.94-19.87,1,8.22,6.24,15.18,12.62,20.32l0,0c18.87,14.62,45,19.36,70,18.66C177,432.29,210.52,425.51,221.94,400.49Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.49,406.43c8.56,3.59,17,2,24.77-.73l-2.06,2.12v8.88a37.22,37.22,0,0,0,5.3.86,38,38,0,0,0,9.2-.34,49.22,49.22,0,0,0,14.35-4.73l7.54,3.17,10.18-6.27v-8.88l-1.91-.82-.42-.17a8.2,8.2,0,0,0,.21-2.08,5.07,5.07,0,0,0-.06-.7c-.13-1.1.1-6.11.06-8.19,0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.57-6.47v0a27.31,27.31,0,0,0-13.48-1.79l-1.14.14-.13,0-1.2.19c-.35.06-.69.12-1,.2-.15,0-.3.05-.43.09a6.1,6.1,0,0,0-.79.18,59.76,59.76,0,0,0-6.5,1.91c-.93.33-1.86.68-2.78,1l2.69-2.8v-8.89c-8.66-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.43V388l2.36,1a5.8,5.8,0,0,0-.22,1.68v.07c.08,1.37-.06,7.26,0,8.81v.07C107.88,402.26,110,404.57,114.49,406.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.66,389c0,2.27-.17,6.74,0,7.76,0,.24,0,.47.06.71a8.25,8.25,0,0,1-.22,2.08L176,397.24S181.51,394.6,181.66,389Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93,388.83c-2.26-.95-2.63-2.71,1.53-5.39,4.46-2.83,9-3.56,12.94-2.59l8.82-9.19v8.88l-2.66,2.8-.28.11c-1.44.55-2.85,1.12-4.18,1.68q-.83.36-1.59.66a55.38,55.38,0,0,1-8.9,3.27,10.07,10.07,0,0,1-3.86.27A7.16,7.16,0,0,1,126.93,388.83Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93,389l-2.34-1v-8.88l7.51,3.15C110.31,384.6,108.52,386.87,107.93,389Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.59,406.76l10.19-6.26v8.89l-10.2,6.28-7.52-3.18a48.79,48.79,0,0,1-14.36,4.72,36.15,36.15,0,0,1-14.5-.51v-8.88a36.47,36.47,0,0,0,14.5.5,48.5,48.5,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.07,412.49a37.16,37.16,0,0,1-11.44,4.68,30.33,30.33,0,0,1-12.13.4,58.58,58.58,0,0,0,12-1.4c2-.43,3.9-1,5.84-1.6S164.14,413.22,166.07,412.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.74,399.63v-.05c-.06-1.56.07-7.44,0-8.83.15,2.62,2.28,4.94,6.74,6.8,9.94,4.14,19.61,1.42,28.46-2.13,8.21-3.32,14.18-6.86,19-4.86,3,1.27,2.15,3.27-1.13,5.36a18.15,18.15,0,0,1-14.2,2.24l-7.32,7.54h0c-7.84,2.77-16.22,4.3-24.76.73C110,404.57,107.89,402.26,107.74,399.63Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.41 389.74 141.4 380.85 150.21 371.65 150.22 380.54 141.41 389.74",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.41 389.74 141.4 380.85 150.21 371.65 150.22 380.54 141.41 389.74",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.58 379.14 113.13 382.28 107.95 389.01 105.59 388.02 105.58 379.14",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.58 379.14 113.13 382.28 107.95 389.01 105.59 388.02 105.58 379.14",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.87,399.69,176,397.24s5.73-2.78,5.62-8.69c0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.57-6.47v0a27.31,27.31,0,0,0-13.48-1.79l-1.14.14-.13,0-1.2.19c-.34.06-.69.12-1,.2-.15,0-.3.05-.43.09a6.1,6.1,0,0,0-.79.18,59.76,59.76,0,0,0-6.5,1.91c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.7-.54.24-1.07.45-1.59.67a58.19,58.19,0,0,1-8.89,3.26,10.21,10.21,0,0,1-3.85.26,7.94,7.94,0,0,1-1.81-.49c-2.27-.95-2.66-2.72,1.52-5.4,4.45-2.84,9-3.57,12.94-2.59l8.81-9.19c-8.66-1.66-17.92-.26-27,4.19l-7.54-3.14-10.07,6.43,7.55,3.14c-3.6,3-5.5,5.83-5.4,8.41v.07c.15,2.61,2.29,4.92,6.76,6.79,9.91,4.15,19.59,1.42,28.44-2.13,8.22-3.33,14.18-6.86,19-4.85,3,1.27,2.14,3.25-1.15,5.36a18.22,18.22,0,0,1-14.2,2.24l-9.38,9.65a37.45,37.45,0,0,0,5.3.86,38.08,38.08,0,0,0,9.21-.35,49.15,49.15,0,0,0,14.34-4.72l7.54,3.16,10.19-6.26Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.87,399.69,176,397.24s5.73-2.78,5.62-8.69c0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.57-6.47v0a27.31,27.31,0,0,0-13.48-1.79l-1.14.14-.13,0-1.2.19c-.34.06-.69.12-1,.2-.15,0-.3.05-.43.09a6.1,6.1,0,0,0-.79.18,59.76,59.76,0,0,0-6.5,1.91c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.7-.54.24-1.07.45-1.59.67a58.19,58.19,0,0,1-8.89,3.26,10.21,10.21,0,0,1-3.85.26,7.94,7.94,0,0,1-1.81-.49c-2.27-.95-2.66-2.72,1.52-5.4,4.45-2.84,9-3.57,12.94-2.59l8.81-9.19c-8.66-1.66-17.92-.26-27,4.19l-7.54-3.14-10.07,6.43,7.55,3.14c-3.6,3-5.5,5.83-5.4,8.41v.07c.15,2.61,2.29,4.92,6.76,6.79,9.91,4.15,19.59,1.42,28.44-2.13,8.22-3.33,14.18-6.86,19-4.85,3,1.27,2.14,3.25-1.15,5.36a18.22,18.22,0,0,1-14.2,2.24l-9.38,9.65a37.45,37.45,0,0,0,5.3.86,38.08,38.08,0,0,0,9.21-.35,49.15,49.15,0,0,0,14.34-4.72l7.54,3.16,10.19-6.26Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.49,397.55a28.6,28.6,0,0,0,11.8,1.84,43.61,43.61,0,0,0,12-2.56c3.94-1.3,7.73-3,11.6-4.62a39.32,39.32,0,0,1,6-2,9.88,9.88,0,0,1,6,.35,9.83,9.83,0,0,0-6-.08,40.5,40.5,0,0,0-5.85,2.11c-3.81,1.67-7.63,3.41-11.6,4.76a42.35,42.35,0,0,1-12.23,2.46,28.77,28.77,0,0,1-6.1-.46A29.17,29.17,0,0,1,114.49,397.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.59 406.77 173.6 415.66 166.06 412.5 166.05 403.61 173.59 406.77",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.59 406.77 173.6 415.66 166.06 412.5 166.05 403.61 173.59 406.77",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.78 400.51 173.63 405.78 166.05 403.61 173.59 406.77 183.78 400.51",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.19 375.85 115.69 373.63 105.58 379.14 115.65 372.71 123.19 375.85",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.21,371.66a37.46,37.46,0,0,0-4.73-.57l1.23,4.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.83,397.68a27.58,27.58,0,0,0,13,1.82l-7.27-24.74-4.9-2.05-6.86,4.38,1.13,3.85,3.21,1.34a26.6,26.6,0,0,0-2.22,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.49,380.79a26,26,0,0,0-7.49-1.36l8,27.11,6-3.69-1.33-4.52-2.6-1.09A11,11,0,0,0,178,396Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.27,379.73l-1.2.19c-.34.06-.69.12-1,.2-.15,0-.3.05-.43.09a6.1,6.1,0,0,0-.79.18,59.76,59.76,0,0,0-6.5,1.91c-.47.16-.92.35-1.39.52l2.63,9c4.06-1.6,7.43-2.45,10.38-1.22s2.14,3.25-1.15,5.36a17.7,17.7,0,0,1-7.24,2.61l2.59,8.84a51.07,51.07,0,0,0,9.92-3.77l2.85,1.19-7.41-25.22c-.36,0-.74.1-1.09.13Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.06 390.64 74.29 381.32 75.52 390.64 91.66 391.35 75.52 392.06 74.29 401.38 73.06 392.06 56.91 391.35 73.06 390.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.78 397.87 82.38 393.35 82.97 397.87 90.8 398.21 82.97 398.55 82.38 403.07 81.78 398.55 73.96 398.21 81.78 397.87",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsAmico);
export default __webpack_public_path__ + "static/media/coins-amico.159f00f6b21fbd9e9c09f16988078a6a.svg";
export { ForwardRef as ReactComponent };